{
  "common": {
    "show_password": "Show password",
    "hide_password": "Hide password",
    "loading": "Loading…",
    "retry": "Retry",
    "error": "Something went wrong",
    "none": "—",
    "cancel": "Cancel",
    "back": "Back",
    "copy": "Copy",
    "done": "Done",
    "save": "Save",
    "edit": "Edit",
    "close": "Close",
    "list_sep": ", ",
    "list_sep2": "; ",
    "colon": ": ",
    "paren": " ({{x}})",
    "saving": "Saving…",
    "yes": "Yes",
    "on": "On",
    "off": "Off",
    "device_id": "Device ID",
    "action_delete": "Delete",
    "action_remove": "Remove",
    "action_update_fw": "Start update",
    "action_apply": "Apply",
    "action_change": "Change setting",
    "action_revoke": "Revoke",
    "action_purge": "Purge data",
    "action_reboot": "Reboot",
    "confirm_type": "Type “{{name}}” to confirm",
    "action_end": "End",
    "action_sign_out": "Sign out",
    "op_failed": "That didn't go through. Please try again later. (code: {{code}})",
    "state_unknown": "Unknown",
    "pick_date": "Pick a date",
    "dt24_bad": "Use 2026-10-13 22:25 (24-hour)",
    "on_this_page": "On this page:"
  },
  "auth": {
    "title": "Sign in",
    "email": "Email",
    "password": "Password",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "err_INVALID_CREDENTIALS": "Wrong email or password",
    "err_RATE_LIMITED": "Too many attempts, try again later",
    "err_NETWORK": "Cannot connect, check your network",
    "err_IDENTITY_UNAVAILABLE": "Account service unavailable",
    "err_default": "Sign-in failed ({{code}})",
    "reason_SESSION_IDLE": "You were signed out after being inactive. Please sign in again.",
    "err_SESSION_IDLE": "Inactive too long — please sign in again",
    "err_PASSKEY_REQUIRED": "Please sign in with your passkey",
    "reason_SESSION_REAUTH": "Duty accounts must sign in again every 12 hours.",
    "hint": "Sign in with the same account you use in the {{brand}} app: your own devices, devices your organizations give you access to, and devices shared with you are all here.",
    "forgot": "Forgot password?",
    "forgot_title": "Reset password",
    "forgot_hint": "Enter your account email and we'll send you a reset link.",
    "forgot_submit": "Send reset link",
    "forgot_sent": "If this email has an account, a reset link is on its way. Check your spam folder too.",
    "forgot_back": "Back to sign in",
    "no_account": "No account yet?",
    "signup": "Sign up",
    "signup_title": "Create an account",
    "signup_hint": "You can also use this account in the {{brand}} app. If an organization invites you or someone shares devices with you later, they show up under the same account.",
    "signup_submit": "Create account",
    "pending_invite": "The invitation you opened will be accepted after you sign in.",
    "err_EMAIL_EXISTS": "This email already has an account — please sign in",
    "err_WEAK_PASSWORD": "Password is too short or too common",
    "err_SIGNUP_CLOSED": "Sign-up is closed for this service",
    "err_BRAND_OFFBOARDING": "This brand no longer accepts new sign-ups",
    "reason_other": "You've been signed out. Please sign in again."
  },
  "nav": {
    "overview": "Overview",
    "live": "Live",
    "playback": "Playback",
    "events": "Events & alarms",
    "map": "Map",
    "devices": "Devices",
    "ai": "AI analytics",
    "backup": "Off-site backup",
    "exports": "Exports & evidence",
    "people": "People & access",
    "audit": "Audit",
    "billing": "Plans & billing",
    "rules": "Automation rules",
    "sites": "Organization & sites",
    "org": "Organization settings",
    "account": "My account"
  },
  "shell": {
    "scope_all": "All (mine + from my organizations + shared with me)",
    "language": "Language",
    "logout": "Sign out",
    "env": "Env",
    "env_badge": "Env: {{env}}",
    "scope": "Scope",
    "present_end": "End presentation"
  },
  "planned": {
    "title": "{{name}}: planned",
    "body": "This module ships in {{milestone}}; see plan/vms-web-v0.md.",
    "spec": "Spec section"
  },
  "overview": {
    "title": "Overview",
    "homes": "$t(leaf.cur_pl)",
    "devices": "Devices",
    "online": "Online",
    "offline": "Offline",
    "role": "Role",
    "no_homes": "No $t(leaf.cur_lc_pl) or sites yet. Create a $t(leaf.cur_lc) in the app, or ask your organization admin for access.",
    "open_devices": "View devices",
    "cameras": "Camera feeds (online / all)",
    "recent_events": "Recent events",
    "devices_n_one": "{{count}}",
    "devices_n_other": "{{count}}",
    "channels_note_one": "plus {{count}} NVR channel",
    "channels_note_other": "plus {{count}} NVR channels",
    "devices_tip": "Devices = physical units, NVR channels not included (an NVR counts as 1)",
    "offline_tip": "If an NVR is online but a channel is offline, only the channel is counted",
    "online_rate": "{{pct}}% of devices online",
    "cameras_tip": "A feed is a camera or a channel; an NVR has as many feeds as channels. Opens the video wall",
    "recorders_bad": "{{bad}} / {{total}} with problems",
    "recorders_tip": "Recorders = NVRs and Kinio Stations (including Mac / Windows)",
    "basis_auto": "Estimated from the recent average {{mbps}} Mbps and {{gb}} GB with overwrite",
    "basis_off": "Estimated from the recent average {{mbps}} Mbps and {{gb}} GB left (no overwrite)",
    "fw_outdated_one": "{{count}} update available",
    "fw_outdated_other": "{{count}} updates available",
    "fw_all_latest_one": "{{count}} up to date",
    "fw_all_latest_other": "{{count}} up to date",
    "fw_tip": "Counts devices only (channels follow their NVR); same data as Devices › Firmware",
    "todo_title": "Needs attention",
    "todo_none": "Nothing needs attention right now.",
    "todo_offline": "Offline — devices: {{devices}}, channels: {{channels}}",
    "todo_storage_one": "{{count}} recorder has a storage problem",
    "todo_storage_other": "{{count}} recorders have storage problems",
    "todo_cert_one": "{{count}} device certificate expired or expiring",
    "todo_cert_other": "{{count}} device certificates expired or expiring",
    "todo_fw_one": "{{count}} device has a firmware update",
    "todo_fw_other": "{{count}} devices have firmware updates",
    "todo_alarms_one": "{{count}} alarm not handled yet",
    "todo_alarms_other": "{{count}} alarms not handled yet",
    "todo_gaps_one": "{{count}} camera has recording gaps in the last 24 hours",
    "todo_gaps_other": "{{count}} cameras have recording gaps in the last 24 hours",
    "gap_cam_reason": "{{name}} ({{reason}})",
    "and_more_one": " and {{count}} more",
    "and_more_other": " and {{count}} more",
    "act_view": "View",
    "act_check": "Check",
    "act_update": "Firmware",
    "act_handle": "Handle alarms",
    "act_playback": "Play back",
    "recent_alarms": "Recent alarms",
    "no_alarms": "No recent alarms",
    "unknown_device": "Removed device",
    "home_online": "{{on}} / {{total}} online",
    "armed_hint": "Arming mode decides which detections count as alarms",
    "fw_item": "{{name}} (now {{v}})",
    "no_new_alarms_open_one": "No new alarms recently; {{count}} earlier alarm is still open.",
    "no_new_alarms_open_other": "No new alarms recently; {{count}} earlier alarms are still open.",
    "open_alarms": "Alarms not handled yet",
    "open_alarms_more": "See all {{count}}",
    "fw_all_latest_card_one": "All up to date ({{count}} device)",
    "fw_all_latest_card_other": "All up to date ({{count}} devices)",
    "fw_unknown_note_one": "{{count}} device not reporting its version",
    "fw_unknown_note_other": "{{count}} devices not reporting their version",
    "recorders_ok_one": "{{count}} OK",
    "recorders_ok_other": "All {{count}} OK",
    "offline_short": "{{devices}} dev · {{channels}} ch",
    "offline_dev_only_one": "{{count}} device",
    "offline_dev_only_other": "{{count}} devices",
    "offline_ch_only_one": "{{count}} channel",
    "offline_ch_only_other": "{{count}} channels",
    "todo_alarms_more_one": "{{count}}+ alarms not handled yet",
    "todo_alarms_more_other": "{{count}}+ alarms not handled yet",
    "todo_alarms_counting": "Alarms not handled yet (counting…)",
    "unlisted_open_one": "{{count}} more alarm comes from an unregistered or removed device and is not counted",
    "unlisted_open_other": "{{count}} more alarms come from unregistered or removed devices and are not counted"
  },
  "devices": {
    "title": "Devices",
    "search": "Search name or model",
    "col_name": "Name",
    "col_home": "$t(leaf.cur) / site",
    "col_model": "Model",
    "col_kind": "Kind",
    "col_fw": "Firmware",
    "col_status": "Status",
    "col_last_seen": "Last seen",
    "online": "Online",
    "offline": "Offline",
    "unknown": "Unknown",
    "empty": "No devices",
    "count_one": "{{count}} device",
    "count_other": "{{count}} devices",
    "home_failed": "Failed to load {{home}}: {{err}}",
    "expand": "Expand",
    "collapse": "Collapse",
    "channels": "{{n}} ch",
    "watch": "Watch",
    "kind_native": "Kinio",
    "kind_child": "Channel / sub-device",
    "kind_lscloud": "LS Cloud",
    "kind_swann": "Swann",
    "filter_status": "Status",
    "filter_all": "All statuses",
    "view": "View",
    "view_table": "Table",
    "view_tree": "By position",
    "col_recording": "Cloud recording",
    "col_ai": "AI",
    "col_location": "Position",
    "seat_event": "Event seat",
    "seat_continuous": "Continuous seat",
    "reason_keepalive_timeout": "Connection timed out",
    "reason_gateway_lost": "Platform connection lost",
    "reason_missed_check_in": "Missed check-in after sleep",
    "reason_clean_close": "Device disconnected",
    "reason_probe_timeout": "Probe timed out",
    "reason_superseded": "Replaced by a new connection",
    "reason_channel_offline": "Channel offline",
    "reason_read_error": "Read failed",
    "reason_other": "Unknown reason",
    "count2_one": "{{count}} device · channels: {{channels}}",
    "count2_other": "{{count}} devices · channels: {{channels}}",
    "count_tip": "Devices = physical units (an NVR counts as 1); channels are counted separately",
    "filter_cert": "Expiring certificates only",
    "filter_type": "Type",
    "type_all": "All types",
    "type_camera": "Cameras",
    "type_recorder": "Recorders",
    "type_sensor": "Sensors",
    "cols": "Columns ▾",
    "col_reason": "Offline reason",
    "col_actions": "Actions",
    "more": "More actions for {{name}}",
    "model_generic": "RTSP camera (no model info)",
    "model_unknown": "Model not known yet",
    "model_onvif": "ONVIF camera"
  },
  "live": {
    "cameras": "Cameras",
    "no_cameras": "No cameras to watch",
    "layout": "Layout",
    "autofill": "Fill with online cameras",
    "empty_cell": "Click or drag a camera from the list",
    "back_to_wall": "Back to wall",
    "expand": "Expand",
    "remove": "Remove from wall",
    "connecting": "Connecting…",
    "offline": "Device offline",
    "no_video": "Connected, but the device sent no video track",
    "failed": "Cannot play ({{code}})",
    "err_DEVICE_OFFLINE": "Device offline",
    "err_CHANNEL_OFFLINE": "Channel offline",
    "err_HARDWARE_ERROR": "Device video engine error; restart the device if this keeps happening",
    "err_FORBIDDEN": "You don't have permission to view this device",
    "err_NO_WEBRTC": "Browser does not support WebRTC",
    "slow_first_frame": "Connected, no frames yet (battery / HaLow cameras may be asleep)",
    "err_MAX_SESSIONS_REACHED": "This device's viewer limit is reached; close another view first",
    "err_VIEWER_LIMIT": "This device's viewer limit is reached; close another view first",
    "watch_playback": "Playback",
    "budget_note": "This computer decodes up to {{budget}} streams at once; {{n}} more tiles show a preview — click Go live or expand to watch.",
    "preview": "Preview",
    "go_live": "Go live",
    "stream_main": "High quality",
    "stream_sub": "Data saver",
    "reconnect_wait": "Reconnecting in {{s}} s (attempt {{n}})",
    "reconnecting": "Reconnecting… (attempt {{n}})",
    "err_STALLED": "Video interrupted",
    "err_NETWORK": "Network interrupted",
    "err_CONNECT_TIMEOUT": "Connection timed out",
    "err_SIGNAL_CLOSED": "Connection lost",
    "err_SESSION_REVOKED": "Your sign-in has ended (signed out elsewhere or password reset); please sign in again",
    "err_ACCESS_REVOKED": "Your access to this device was revoked",
    "err_CODEC_UNSUPPORTED": "This browser can't play this channel's encoding (H.265). Change this channel's sub-stream to H.264",
    "err_INVALID_PAYLOAD": "Could not establish the connection (request format mismatch)",
    "path_lan": "LAN",
    "path_direct": "Direct",
    "path_relay": "Relay",
    "zoom_reset": "{{z}}× reset",
    "zoom_hint": "Scroll to zoom, drag to pan, double-click to reset",
    "snapshot": "Snapshot (download)",
    "replay": "Rewind 30 s",
    "stream_switch": "Switch quality: data saver / high quality (now: {{s}})",
    "stream_manual": "Manual",
    "custom_grid": "Custom",
    "custom_cols": "Columns",
    "custom_rows": "Rows",
    "custom_apply": "Apply",
    "err_RELAY_IDLE": "Relay connection was idle too long and has been stopped",
    "err_RELAY_LIMIT": "Relay connection reached its 30-minute limit and has been stopped",
    "relay_idle_warn": "Relay connection idle; stopping in {{s}} s",
    "relay_continue": "Keep watching",
    "talk": "Hold to talk",
    "talking": "Talking…",
    "talk_starting": "Opening microphone…",
    "talk_hint": "Hold to talk, release to stop (or hold Space when focused)",
    "listen_on": "Turn on live audio",
    "listen_off": "Turn off live audio",
    "talk_forbidden": "You are not allowed to talk through this device",
    "talk_incapable": "This device does not support two-way talk",
    "talk_busy": "Another user is talking",
    "talk_denied": "The browser has not allowed microphone access",
    "talk_error": "Could not start talking. Try again.",
    "talk_unavailable": "You can talk once the video is connected",
    "no_live_n_one": "{{count}} camera cannot be viewed live right now",
    "no_live_n_other": "{{count}} cameras cannot be viewed live right now",
    "ms_popout": "Open on another screen (video wall)",
    "ms_pick_screen": "Which screen",
    "ms_this_screen": "this screen",
    "ms_drag_hint": "Opened a new window — drag it to the screen you want and press F11 for full screen.",
    "ms_blocked": "The browser blocked the pop-up. Allow pop-ups for this site.",
    "ms_restore": "Restore multi-screen setup ({{n}})",
    "ms_wall": "Video wall (another screen)",
    "ms_f11": "Press F11 for full screen",
    "ms_alarm_here": "Alarms pop up in this window",
    "ms_claim_alarm": "Show alarms in this window",
    "ms_close_wall": "Close this wall",
    "ms_budget_shared": "Other screens are using {{used}} of {{total}} decode slots",
    "snapshot_at": "Snapshot {{at}}",
    "scope_changed": "Scope changed to {{name}} ({{n}} views).",
    "scope_fill": "Fill the wall from this scope",
    "scope_keep": "Keep the current wall",
    "overflow_n_one": "{{count}} more view on the next page",
    "overflow_n_other": "{{count}} more views on the next page",
    "overflow_next": "Next page",
    "more_grids": "More layouts",
    "ms_popout_hint": "Opens a window with only the video wall; drag it to another screen and go full screen",
    "grid_key": "{{n}} tiles (shortcut {{key}})",
    "stream_main_short": "HD",
    "stream_sub_short": "Eco",
    "conn_info": "Connection info (path, codec, resolution)",
    "tile_more": "More for {{name}} (quality, connection info, sound, snapshot, replay, PTZ)",
    "slow_first_frame_wired": "Connected, waiting for the first frame…",
    "slow_connect": "Taking longer than usual to connect…",
    "wall_out_of_scope_one": "{{count}} tile on the wall is outside the current scope",
    "wall_out_of_scope_other": "{{count}} tiles on the wall are outside the current scope",
    "wall_fill_scope": "Fill with this scope",
    "out_of_scope_tile": "This tile is outside the current scope (in {{where}})",
    "scope_changed_all_on": "Scope changed to {{name}} (all {{n}} views are already on the wall).",
    "scope_ack": "OK",
    "autofill_all_on": "Every view in this scope is already on the wall",
    "wall_pruned_one": "{{count}} view is no longer in your list (camera moved, unbound or access removed) and was removed from the wall.",
    "wall_pruned_other": "{{count}} views are no longer in your list (camera moved, unbound or access removed) and were removed from the wall.",
    "wall_pruned_undo": "Undo",
    "wall_pruned_ok": "Got it",
    "cell_gone": "This camera is no longer in your list",
    "cell_no_live": "This device has no live view",
    "err_UNREACHABLE": "Can't reach the video (the device shows as online)",
    "err_ICE_FAILED": "Connection lost, reconnecting…",
    "failed_retrying": "Connection lost, reconnecting…",
    "failed_plain": "Cannot play",
    "reconnect_now": "Reconnect now",
    "focus": "Focus",
    "focus_tip": "Hide the menus so video fills the screen (Shift+F)",
    "focus_exit": "Exit focus (Esc)",
    "empty_cell_focus": "Exit focus mode to add a camera"
  },
  "events": {
    "search": "Search type, device, $t(leaf.cur_lc)",
    "count": "Results: {{n}}",
    "empty": "No matching events",
    "class_motion": "Motion",
    "class_sensor": "Sensor",
    "class_system": "System",
    "class_other": "Other",
    "live_new": "Live",
    "class_alarm": "Alarms",
    "class_detection": "Detections",
    "mark_all_seen": "Mark all as seen",
    "unseen_n": "{{n}} unseen alarms and detections",
    "thumb_alt": "Event thumbnail",
    "cls_name": {
      "motion": "Motion",
      "person": "Person",
      "human": "Person",
      "vehicle": "Vehicle",
      "pet": "Animal",
      "package": "Package",
      "ai_label": "AI detection",
      "sound": "Sound",
      "alarm": "Alarm",
      "tamper": "Tampering",
      "contact": "Door / window",
      "occupancy": "Occupied / vacant",
      "doorbell": "Doorbell",
      "call": "Call",
      "connection": "Connection",
      "storage": "Storage",
      "recording": "Recording",
      "power": "Power",
      "ota": "Firmware update",
      "credential": "Certificate",
      "system": "System",
      "security_mode": "Security mode",
      "bookmark": "Bookmark"
    },
    "type_unknown": "Other event",
    "chip_tip": "Click to see only this kind; click again for all. Hold ⌘ / Ctrl to pick several",
    "more": "More",
    "unregistered_channel": "{{parent}} / CH{{n}} (unregistered channel)",
    "device_unknown": "Device not in your list",
    "tab_alarms": "Alarms",
    "tab_alarms_n_one": "Alarms ({{count}} not handled)",
    "tab_alarms_n_other": "Alarms ({{count}} not handled)",
    "tab_all": "All events",
    "tab_saved": "Saved searches",
    "other_channels": "Other channels ({{n}})",
    "device_unknown_tail": "Device not in your list (…{{tail}})",
    "tag": {
      "person": "Person",
      "human": "Person",
      "vehicle": "Vehicle",
      "car": "Car",
      "animal": "Animal",
      "pet": "Pet",
      "dog": "Dog",
      "cat": "Cat",
      "package": "Package",
      "face": "Face",
      "bark": "Barking",
      "glass_break": "Glass break",
      "baby_cry": "Crying",
      "smoke_alarm": "Smoke alarm sound",
      "motion": "Motion",
      "sound": "Sound",
      "bicycle": "Bicycle",
      "motorcycle": "Motorcycle"
    },
    "other_devices": "Others ({{n}})",
    "times_n": "× {{n}} (first at {{since}})",
    "times_only": "× {{n}}",
    "ep_lasted": "lasted {{dur}}",
    "ep_open": "Ongoing",
    "ep_stale": "No end record received",
    "ep_end_only": "End",
    "times_counting": "counting…",
    "all_loaded": "All {{n}} loaded (merged into {{rows}} rows)",
    "no_thumb": "No thumbnail",
    "tab_alarms_more_one": "Alarms ({{count}}+ not handled)",
    "tab_alarms_more_other": "Alarms ({{count}}+ not handled)",
    "ep_lasted_lt1": "lasted under 1 s",
    "tab_alarms_counting": "Alarms (counting…)",
    "compose": {
      "multi_press_n": "Pressed {{count}} times",
      "contact_opened": "Open",
      "contact_closed": "Closed",
      "leak_detected": "Leak detected",
      "leak_cleared": "Leak cleared",
      "occupied": "Occupied",
      "unoccupied": "Vacant",
      "ai_detected": "AI: {{what}}"
    },
    "lens_chip_a11y": "Event from {{name}}"
  },
  "playback": {
    "recording_sd": "Memory card",
    "day": "Date",
    "pick_time": "Drag or click the timeline below to pick a time",
    "timeline": "Recording timeline",
    "type_continuous": "Continuous",
    "type_event": "Event",
    "no_recording_after": "No recording after this time",
    "tunnel_idle": "Playback channel idle",
    "tunnel_opening": "Opening playback channel…",
    "tunnel_open": "Playback channel connected",
    "tunnel_failed": "Playback channel failed",
    "tunnel_closed": "Playback channel closed",
    "err_MAX_SESSIONS_REACHED": "Device connection limit reached (live and playback share it); close another view first",
    "err_VIEWER_LIMIT": "Device connection limit reached (live and playback share it); close another view first",
    "err_CHANNEL_OFFLINE": "Channel offline",
    "err_HARDWARE_ERROR": "Device video engine error; restart the device if this keeps happening",
    "err_CODEC_UNSUPPORTED": "This browser can't play this channel's encoding (H.265). Change this channel's sub-stream to H.264",
    "err_INVALID_PAYLOAD": "Could not establish the connection (request format mismatch)",
    "err_TUNNEL_TIMEOUT": "Playback channel timed out",
    "unified": "Timeline",
    "all_sources": "Show all sources",
    "src_cloud": "Cloud",
    "src_nvr": "NVR disk",
    "src_sd": "SD card",
    "src_edge": "ONVIF edge",
    "src_backup": "Offsite backup",
    "gap": "Gap",
    "gap_offline": "Device offline",
    "gap_retention": "Beyond retention",
    "gap_unknown": "Source unknown (device unreachable)",
    "gap_not_recorded": "Not recorded",
    "gaps_title_one": "{{count}} gap",
    "gaps_title_other": "{{count}} gaps",
    "summary": "Recordings: {{spans}} · gaps: {{gaps}}",
    "source_changed": "Source changed: {{from}} → {{to}}.",
    "end_of_day": "No more recordings this day",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out",
    "pan_back": "Earlier",
    "pan_forward": "Later",
    "zoom_span": "Window {{span}}",
    "hours": "{{n}} h",
    "minutes": "{{n}} min",
    "dst_day": "DST day ({{h}} h)",
    "err_no_recording_after": "No recording after this time",
    "err_TUNNEL_NOT_READY": "Playback tunnel not connected yet; try again shortly",
    "err_TUNNEL_FAILED": "Playback tunnel failed; local recordings unavailable",
    "tz": "Time zone",
    "tz_site": "Site time",
    "tz_browser": "Browser time",
    "src_node": "Computer",
    "src_phone": "Phone",
    "gap_paused": "Paused: {{reason}}",
    "unknown_node_offline": "Unknown (computer is offline)",
    "unknown_node_pending": "Unknown (computer has not reported yet)",
    "unknown_phone_offline": "Unknown (phone is offline)",
    "err_NODE_PLAYBACK_UNAVAILABLE": "Playback from the computer is not available yet (this period is recorded on the computer)",
    "pause_app_background": "app in background",
    "pause_killed": "app closed",
    "pause_updating": "updating",
    "pause_schedule": "schedule",
    "pause_home_mode": "owner at home",
    "pause_thermal": "overheating",
    "pause_battery_low": "battery low",
    "pause_storage_full": "storage full",
    "pause_camera_busy": "camera in use",
    "pause_permission": "no camera permission",
    "pause_local_network_denied": "no local network permission",
    "pause_mic_denied": "no microphone permission",
    "pause_plan_limit": "over plan limit",
    "pause_in_pocket": "phone put away",
    "pause_user": "paused by user",
    "pause_source_unreachable": "computer cannot reach the camera",
    "pause_not_recorded": "not recorded by schedule",
    "prev_month": "Previous month",
    "next_month": "Next month",
    "day_has_rec": "{{day}} (has recordings)",
    "day_legend": "Highlighted days have recordings (cloud or on the device)",
    "event_density": "Event density",
    "events_n_one": "{{count}} event",
    "events_n_other": "{{count}} events",
    "speed": "Speed",
    "frame_back": "Previous frame",
    "frame_fwd": "Next frame",
    "timeline_aria": "Playback timeline (drag to scroll, wheel to zoom; ← / → move, Shift + ← / → previous / next event, Space play / pause)",
    "seam": "{{d}} without events folded",
    "dur_hm": "{{h}} h {{m}} min",
    "only_events": "Only times with events",
    "no_events_day": "No events on this day",
    "end_of_events": "No more events after this",
    "group_person": "Person",
    "group_vehicle": "Vehicle",
    "group_animal": "Animal",
    "group_package": "Package",
    "group_sound": "Sound",
    "group_sensor": "Sensor",
    "group_alarm": "Alarm",
    "group_motion": "Motion",
    "skipped_from": "{{gaps}}; playing from {{at}}.",
    "err_local_unreachable": "Can't read {{name}}'s {{src}} recording (the device isn't responding).",
    "err_source_unreachable": "Couldn't load this recording ({{src}}). Try again later.",
    "err_decode": "The browser can't play this recording (unsupported format or damaged file).",
    "err_generic": "This recording can't be played. Try again later.",
    "err_detail": "Details",
    "no_sources": "This camera has no recording source: no SD card or recorder, and cloud recording is off.",
    "no_recording_unreachable": "No recordings were read for this day: a source couldn't be reached (device offline or not responding), so some recordings may be missing.",
    "no_recording_day": "No recording from any source on this day. Possible reasons:",
    "go_last_day": "Go to the latest day with recordings ({{day}})",
    "err_overlay": "Can't play this (see below)",
    "err_local_offline": "{{name}} is offline, so its local recording can't be read.",
    "err_cloud_unreachable": "Cloud recording can't be read right now. Please try again later.",
    "err_no_cloud": "This camera has no cloud recording.",
    "err_forbidden": "You don't have playback access to this camera.",
    "try_cloud": "Watch cloud recording",
    "try_source": "Watch {{src}}",
    "go_nearest": "Go to the nearest recording",
    "buy_seats": "Buy seats",
    "gap_none_span": "No recording {{from}}–{{to}}",
    "why_overwritten": "The {{src}} has been overwritten (old recordings are replaced by new ones)",
    "why_no_cloud": "Cloud recording isn't on",
    "why_schedule": "The recording schedule doesn't cover this time",
    "why_offline": "{{name}} was offline during this time",
    "no_rec_events_one": "There is {{count}} event on this day, but no recording to play.",
    "no_rec_events_other": "There are {{count}} events on this day, but no recording to play.",
    "from_event": "From event: {{name}} · {{cam}} · {{at}}",
    "from_event_generic": "Event",
    "from_event_dismiss": "Remove this label",
    "drag_hint": "Drag the timeline to change the time — the center line is the play position. Click to jump there.",
    "hint_ok": "Got it",
    "settings": "Timeline settings (time zone, legend, event-only, all sources)",
    "modes": "Playback mode",
    "mode_single": "Single",
    "day_no_rec": "No recording on this day",
    "why_local_unreachable": "{{name}}'s {{src}} recordings can't be read right now (the device isn't responding).",
    "why_local_offline": "{{name}} is offline, so its {{src}} recordings can't be read.",
    "why_cloud_no_clip": "{{name}} has no cloud clips for this time (the cloud only keeps event clips).",
    "why_cloud_retention": "This is older than the cloud retention period ({{n}} days).",
    "why_local_empty": "The {{src}} has no recording for this time either (it may have been overwritten, or the schedule didn't cover it).",
    "retry_local": "Retry reading {{src}}",
    "seek_no_rec": "No recording at {{at}}; playing from {{from}}.",
    "fallback": "Couldn't read {{dev}}'s {{src}}; playing the {{to}} recording from {{at}} instead.",
    "cam_not_found": "Camera not found (it may have been removed, or you can't view its recordings). Pick a camera on the left or above.",
    "pick_camera": "Pick a camera…",
    "slow": "Recording from {{src}} is taking a long time to load.",
    "slow_fallback": "No picture from {{src}} after {{sec}} s; switched to {{to}} (from {{at}}).",
    "avoid_broken": "{{dev}}'s {{src}} couldn't be read a moment ago; playing {{to}} first (from {{at}}).",
    "src_missing": "This camera has no {{src}} recording at this time; using another source.",
    "back_to": "Back to {{src}}",
    "src_pinned": "Source you picked: kept when you switch cameras",
    "src_auto_hint": "Picked automatically (the source that last played wins)",
    "src_auto": "Pick source automatically",
    "play": "▶ Play",
    "pause": "⏸ Pause",
    "sound_on": "🔇 Sound on",
    "sound_off": "🔊 Sound off",
    "fullscreen": "⛶ Full screen",
    "cloud_suspect": "This cloud clip may be incomplete (its length doesn't add up); the picture may be green or frozen.",
    "cloud_suspect_switched": "This cloud clip may be incomplete (its length doesn't add up), so playing {{to}} instead (from {{at}}).",
    "events_n_more": "More than {{count}} events (only {{count}} marked)",
    "slow_tier_hint": "The connection is too slow for smooth playback. Switch recording quality to Standard (affects future recordings only).",
    "slow_tier_switch": "Switch to Standard",
    "slow_tier_never": "Don't show again",
    "slow_tier_close": "Close",
    "slow_tier_done": "Switched to Standard. Future recordings use Standard; existing ones stay as they are.",
    "slow_tier_sent": "Sent. The camera will switch to Standard when it's back online.",
    "slow_tier_hint_no_write": "The connection is too slow for smooth playback. Someone with settings access to this camera can switch recording quality to Standard.",
    "slow_tier_failed": "Couldn't switch. Try again in the device's Recording & storage tab › Recording quality.",
    "err_local_host_limit": "The recorder of {{name}} plays at most {{n}} local streams at once; this one was not loaded. Open it in single playback instead."
  },
  "map": {
    "plans": "Floor plans",
    "upload": "Upload floor plan",
    "place_devices": "Place devices",
    "pick_device": "Pick a device, then click the plan to drop it",
    "click_to_place": "Click a spot on the plan",
    "done": "Done",
    "edit": "Edit placement",
    "delete": "Delete plan",
    "confirm_delete": "Delete floor plan \"{{name}}\"?",
    "no_map_key": "The map needs the brand's Google / Baidu key (brands/<Brand>/vms/vms.yaml maps.*). Floor plan mode still works.",
    "empty": "No floor plans yet. Upload a floor image (PNG / JPG / SVG / WebP, up to 20 MB) and place cameras and sensors on it.",
    "rotate_left": "Rotate left 15°",
    "rotate_right": "Rotate right 15°",
    "remove": "Remove",
    "load_demo": "Load sample plan (auto-place)",
    "demo_name": "Sample 1F",
    "owner": "Upload to",
    "conflict": "Someone else changed this; reloaded — please try again",
    "empty_readonly": "No floor plans yet; a $t(leaf.cur_lc) owner / admin or org admin can upload one.",
    "mode_map": "Map",
    "mode_plan": "Floor plans",
    "load_failed": "Map failed to load: {{err}}",
    "fallback": "{{from}} failed to load; switched to {{to}}",
    "provider": "Map",
    "provider_google": "Google",
    "provider_baidu": "Baidu",
    "provider_dev": "Dev basemap",
    "dev_basemap": "Development environment: no Google / Baidu map key for this brand yet, so a development basemap is used (never shown in production).",
    "health_ok": "OK",
    "health_warn": "Device offline",
    "health_alarm": "Alarm",
    "sites": "Sites",
    "set_location": "Pick location on map",
    "click_map_home": "Click the map to set this site's location",
    "click_map_to_place": "Click the map to place (click the device again to move it)",
    "overlays": "Floor plan overlays",
    "align": "Align",
    "opacity": "Opacity",
    "heading": "Heading",
    "fov": "Field of view",
    "range": "Range",
    "move": "Move",
    "align_title": "Align “{{name}}”",
    "align_help": "Click a point on the floor plan, then the same spot on the map. 2 points = move/rotate/scale; 3 points also correct skew.",
    "align_click_img": "Click point {{n}} on the floor plan",
    "align_click_map": "Click where point {{n}} is on the map",
    "align_save": "Apply ({{n}} points)",
    "align_reset": "Start over",
    "align_clear": "Remove overlay",
    "align_bad": "Control points must not overlap or be collinear",
    "align_ready": "All 3 points set — click Apply",
    "timezone": "Time zone",
    "timezone_unset": "Time zone (unset — browser)",
    "events_recent": "Recent events ({{n}})",
    "events_results": "Search results ({{n}})",
    "events_clear": "Clear search results",
    "events_title": "Events",
    "events_none": "No events",
    "events_playback": "Play this moment",
    "events_help": "Devices with events blink on the map; click an entry to mark its device. Only devices already placed on the map have a position.",
    "search_placeholder": "Search an address or place",
    "search": "Search",
    "search_none": "No matching address",
    "search_busy": "Too many address searches; try again shortly",
    "search_attrib": "Development geocoding: © OpenStreetMap contributors (Nominatim)",
    "tiles_failed": "The map background can't be loaded right now.",
    "use_plan": "Use floor plans instead",
    "alarms_only": "Alarms only",
    "unplaced_devices_one": "Not on the map yet ({{count}}) · {{home}}",
    "unplaced_devices_other": "Not on the map yet ({{count}}) · {{home}}",
    "placed_devices_one": "On the map ({{count}})",
    "placed_devices_other": "On the map ({{count}})",
    "all_placed": "Every device here is on the map.",
    "timezone_change": "Change",
    "timezone_edit": "Change time zone",
    "site_health_alarm": "Red: a device here is alarming",
    "site_health_warn": "Yellow: a device here is offline",
    "site_health_ok": "Green: all devices here are OK",
    "location_set": "Location: set",
    "location_unset": "Location: not set",
    "location_pick": "Set",
    "location_move": "Move",
    "timezone_label": "Time zone: {{tz}}",
    "timezone_unset_short": "not set (browser)",
    "unplaced_devices_ch": "Not yet on the map ({{count}}, incl. {{ch}} channels) · {{home}}"
  },
  "mfa": {
    "title": "Two-step verification",
    "code_body": "Open your authenticator app (Google Authenticator, Microsoft Authenticator, etc.) and enter the 6-digit code.",
    "code": "Verification code",
    "recovery_hint": "No phone? Enter a recovery code (xxxx-xxxx).",
    "verify": "Verify",
    "enroll_title": "Set up two-step verification",
    "enroll_body": "Scan the QR code with your authenticator app, then enter the 6-digit code it shows.",
    "first_code": "Code from the app",
    "enable": "Turn on two-step verification",
    "recovery_title": "Recovery codes",
    "saved_continue": "I've saved them, continue",
    "qr_alt": "Authenticator setup QR code",
    "manual_entry": "Can't scan? Enter this key manually:",
    "recovery_notice": "Each recovery code works once. Store them somewhere safe (password manager or paper) — they're the only way in if you lose your phone, and they won't be shown again.",
    "copy_codes": "Copy all",
    "section": "Two-step verification",
    "enabled": "On",
    "disabled": "Off",
    "required_policy": "Required by an organization you belong to",
    "recovery_remaining": "{{n}} recovery codes left",
    "regenerate": "Regenerate recovery codes",
    "regenerate_body": "All existing recovery codes will stop working. Enter your current code.",
    "disable": "Turn off two-step verification",
    "disable_body": "You'll sign in with your password only. Enter your password and current code.",
    "err_MFA_CODE_INVALID": "Wrong or already-used code",
    "err_MFA_TOKEN_INVALID": "Verification timed out — enter your password again",
    "err_RATE_LIMITED": "Too many attempts, try again later",
    "err_INVALID_CREDENTIALS": "Wrong password",
    "err_MFA_REQUIRED": "Enter your verification code",
    "err_MFA_ALREADY_ENABLED": "Two-step verification is already on",
    "err_MFA_NOT_SETUP": "Two-step verification isn't set up",
    "err_MFA_REQUIRED_BY_POLICY": "An organization you belong to requires two-step verification: keep at least one method (TOTP or passkey)",
    "err_SESSION_UNKNOWN": "Your session was refreshed, please try again",
    "err_NETWORK": "Can't connect — check your network",
    "err_IDENTITY_UNAVAILABLE": "Account service is temporarily unavailable",
    "err_default": "Verification failed ({{code}})"
  },
  "stepup": {
    "title": "Confirm it's you",
    "body": "This is a sensitive action (permissions, suspending members, …). Please re-verify within 5 minutes.",
    "code_hint": "If two-step verification is on, open your authenticator app (Google Authenticator etc.) and enter the current 6-digit code for Kinio. If it's off, leave this empty and just enter your password.",
    "submit": "Verify and continue",
    "code": "Two-step verification code",
    "code_optional": "Two-step verification code (only if turned on)",
    "code_hint_on": "Open your authenticator app (Google Authenticator, Microsoft Authenticator etc.) and enter the current 6-digit code for Kinio. No phone? Enter a recovery code (xxxx-xxxx)."
  },
  "settings": {
    "security": "Security",
    "org": "Organization",
    "notifications": "Notifications"
  },
  "activate": {
    "title": "Accept invitation",
    "bad_link": "This invitation link is incomplete or expired. Ask the person who invited you for a new one.",
    "done": "Account {{email}} has been created and joined. Go back to sign in.",
    "to_login": "Go to sign-in",
    "body": "You have been invited to an organization (or someone shared devices with you). If you already have an account, sign in; otherwise sign up with this invitation (the invited email is used and cannot be changed).",
    "display_name": "Display name (optional)",
    "password_hint": "At least 8 characters; avoid common passwords.",
    "password_again": "Confirm password",
    "mismatch": "Passwords don't match",
    "submit": "Sign up and join",
    "err_INVITE_GONE": "Invitation expired or already used — ask the admin to invite you again",
    "err_ACCOUNT_EXISTS": "This email already has an account — please sign in",
    "err_WEAK_PASSWORD": "Password too short or too common",
    "err_INVITE_EMAIL_MISMATCH": "The invitation was sent to a different email than the account you signed in with",
    "err_default": "Activation failed ({{code}})",
    "have_account": "I have an account — sign in",
    "no_account": "I don't have an account — sign up",
    "register_body": "Set a password to create your account and join. You can use the same account in the brand app.",
    "done_existing": "This email already has an account and has been added. Sign in with your existing password.",
    "done_share": "The share is active. The devices appear under \"Shared with me\".",
    "err_INVITE_EMAIL_MISMATCH_masked": "This invitation is for {{email}}. Sign in with that account instead.",
    "err_ALREADY_MEMBER": "You are already a member of this organization",
    "err_ORG_SUSPENDED": "This organization is suspended and cannot be joined",
    "err_EMAIL_NOT_VERIFIED": "Verify your email first, then accept the invitation.",
    "org": "Organization",
    "invited_by": "Invited by",
    "invited_email": "Invited email",
    "expires": "Expires",
    "already_member": "You are already a member of this organization ({{role}}).",
    "accept": "Accept and join",
    "joined": "You joined \"{{name}}\". Its devices appear under \"From my organizations\".",
    "joined_short": "Invitation accepted.",
    "switch_account": "Sign out and switch account",
    "to_devices": "Go to devices",
    "joined_org": "Joined \"{{name}}\"."
  },
  "org": {
    "err_default": "Action failed ({{code}})",
    "err_VERSION_CONFLICT": "Someone else changed this — refresh and try again",
    "err_REAUTH_REQUIRED": "Re-verification required",
    "err_SITE_CYCLE": "A site can't move under itself",
    "err_CROSS_TREE": "Sites are in different trees",
    "err_SITE_ARCHIVED": "Site is archived",
    "err_OUT_OF_ANCHOR": "Device isn't within this site",
    "err_OUT_OF_SITE": "Listed devices aren't in the granted site",
    "err_SITE_NOT_RELATED": "The granted site must be above or below the $t(leaf.cur_lc)'s site",
    "err_EMPTY_SCOPE": "No devices in scope",
    "err_GRANT_TOO_LONG": "Grants last at most 90 days",
    "err_NOT_ACTIVE_ORG_MEMBER": "They are not an active member of this organization",
    "err_ROLE_NOT_GRANT": "This role isn't a data-access role",
    "err_NO_ACTIONS": "Pick at least one action",
    "err_BAD_SITE": "Invalid site (name 1–64 characters)",
    "err_BAD_TIMEZONE": "Invalid time zone (e.g. Asia/Taipei)",
    "err_ALREADY_MEMBER": "Already a member",
    "err_TOO_MANY_INVITES": "Too many pending invitations — revoke unused ones first",
    "err_LAST_ORG_ADMIN": "Keep at least one organization admin",
    "err_SELF": "You can't suspend yourself",
    "err_LIMIT": "Limit reached",
    "err_ORG_LIMIT": "You can create up to 5 organizations (your home doesn't count)",
    "err_FORBIDDEN": "Not allowed",
    "err_NOT_FOUND": "Not found",
    "err_NETWORK": "Can't connect — check your network",
    "no_site_permission": "You don't have permission to manage this organization's sites. Contact an organization admin.",
    "create_title": "Create an organization",
    "create_body": "Companies, shops, communities, security providers and installers can create an organization with its own site tree, members, roles and security policy. You become the owner. Up to 5 per person (your home doesn't count).",
    "name": "Organization name",
    "create": "Create",
    "sites_title": "Sites of {{name}}",
    "add_root_site": "Add site",
    "revoked_grants": "Revoked {{n}} affected grants",
    "no_sites": "No sites yet. Start with your headquarters or first branch.",
    "kind_site": "Branch",
    "kind_building": "Building",
    "kind_floor": "Floor",
    "kind_zone": "Zone",
    "archived": "Archived",
    "add_child": "Add sub-site",
    "add_home": "Add $t(leaf.cur_lc)",
    "archive": "Archive",
    "restore": "Restore",
    "home": "$t(leaf.cur)",
    "add_child_of": "Add under \"{{name}}\"",
    "edit_site": "Edit \"{{name}}\"",
    "add_home_at": "Add a $t(leaf.cur_lc) at \"{{name}}\"",
    "home_body": "A $t(leaf.cur_lc) is the place where devices actually are (for example \"My home\" or \"Building A cameras\"). Once devices are paired into this $t(leaf.cur_lc), they can be used according to roles and access.",
    "home_name": "$t(leaf.cur) name",
    "kind": "Type",
    "site_name": "Name",
    "timezone": "Time zone",
    "parent": "Parent site",
    "parent_root": "(top level)",
    "move_warning": "Moving revokes grants that no longer cover it.",
    "pick": "Organization",
    "err_OWNS_HOMES": "They still manage $t(leaf.cur_lc_pl) — hand them over first",
    "err_HOME_UNASSIGNED": "This $t(leaf.cur_lc) is unmanaged; an organization admin must take it over first",
    "err_NOT_OWNER": "Only the current manager can hand over",
    "err_REASON_REQUIRED": "Please enter a reason",
    "err_IDEMPOTENCY_KEY_REQUIRED": "Please refresh and try again",
    "err_HOME_NOT_FOUND": "$t(leaf.cur) not found",
    "err_WOULD_LOCK_OUT": "Saving would lock you out (your current IP isn't on the list, or this sign-in has no two-step verification)",
    "err_BAD_CIDR": "Invalid IP / CIDR",
    "err_IP_NOT_ALLOWED": "Organization policy does not allow access from this network",
    "err_BAD_SCHEDULE": "Invalid time window",
    "my_orgs": "My organizations",
    "my_orgs_hint": "Every account has its own home (personal organization — it can't be left or deleted). You can also create organizations (company, shop, community…) or be invited to others. Organizations can't see each other.",
    "kind_col": "Type",
    "kind_personal": "Personal",
    "kind_team": "Team",
    "personal_badge": "my home",
    "requires_mfa": "Requires two-step verification",
    "manage": "Manage",
    "leave": "Leave",
    "leave_confirm": "Leave \"{{name}}\"?",
    "leave_body": "You only lose the access this organization gave you; your own home, other organizations and shares with you are not affected. To come back you'll need a new invitation.",
    "created": "\"{{name}}\" created — you are the owner.",
    "personal_hint": "This is your home (personal organization): add $t(leaf.cur_lc_pl) and sites and invite family here. It can't be left, transferred or deleted — it belongs to your account.",
    "team_hint": "Team organization: organization roles only cover organization matters; viewing video needs a $t(leaf.cur_lc) role or site access.",
    "member_count_one": "{{count}} member",
    "member_count_other": "{{count}} members",
    "owner_transfer": "Transfer ownership",
    "owner_transfer_of": "Transfer ownership of \"{{name}}\"",
    "owner_transfer_hint": "The new owner must be an active admin; you become an admin. Both of you and the other admins are notified.",
    "new_owner": "New owner",
    "no_admins": "No other admins yet — make the new owner an admin in the Members tab first.",
    "owner_transfer_done": "Ownership transferred.",
    "delete": "Delete organization",
    "delete_confirm": "Delete \"{{name}}\"?",
    "delete_body": "All members leave and shares with this organization end. An organization that still has $t(leaf.cur_lc_pl) can't be deleted — delete or move the $t(leaf.cur_lc_pl) first. This cannot be undone.",
    "err_ORG_NOT_EMPTY": "The organization still has $t(leaf.cur_lc_pl) — delete or move these $t(leaf.cur_lc_pl) first:",
    "err_INVALID_NAME": "Organization name must be 2–60 characters",
    "err_OWNER_REQUIRED": "Only the owner can do this",
    "err_OWNER_CANNOT_LEAVE": "Owners can't leave: your home belongs to your account; for a team organization, transfer ownership first",
    "err_OWNER_ROLE": "The owner's role can only change by transferring ownership",
    "err_PERSONAL_ORG": "Your home (personal organization) can't be transferred or deleted",
    "err_TARGET_NOT_ORG_ADMIN": "The new owner must be an active admin of this organization",
    "err_NOT_AN_ORG_MEMBER": "They are no longer a member of this organization",
    "err_ORG_SUSPENDED": "This organization is suspended; no changes can be made",
    "err_ORG_MFA_REQUIRED": "This organization requires two-step verification — turn it on and sign in again",
    "err_ORG_NOT_FOUND": "Organization not found",
    "err_DEV_HOME_NOT_ALLOWED": "Creating organizations or $t(leaf.cur_lc_pl) in this environment must be enabled first",
    "err_TEST_IDENTITY_REQUIRED": "Only test accounts can create organizations or $t(leaf.cur_lc_pl) in this environment",
    "err_FEATURE_DISABLED": "This feature isn't offered in this environment",
    "err_BAD_EMAIL": "Invalid email",
    "err_BAD_ROLE": "This role can't be used here",
    "err_INVALID_ROLE": "This role can't be used in this organization",
    "err_INVITE_GONE": "The invitation has expired or been used",
    "err_SHARE_EXISTS": "A share for the same purpose already exists — adjust that one instead",
    "err_SHARE_NOT_FOUND": "Share not found",
    "err_SHARE_SCOPE_EXCEEDED": "This goes beyond what was shared",
    "err_GRANT_EXCEEDS_ROLE": "You can't share access you don't have yourself",
    "err_INVALID_SCOPE": "Some selected permissions can't be used here",
    "err_INVALID_GRANTEE": "Invalid recipient",
    "err_SCOPE_EXPAND": "You can only narrow a share — share again to widen it",
    "err_TOO_LONG": "The period is longer than allowed for this purpose",
    "err_REQUEST_GONE": "The share request has expired or been used",
    "err_ORG_NOT_VERIFIED": "This organization is not verified for this purpose",
    "err_NOT_A_RENEWAL": "This code is not a renewal request",
    "err_NOT_INSTALL": "Only installation shares can be completed",
    "err_EMAIL_EXISTS": "This email already has an account",
    "err_BAD_TARGET": "The selected device isn't in this $t(leaf.cur_lc)",
    "err_BAD_POLICY": "Invalid policy setting",
    "err_SITE_NOT_FOUND": "Site not found",
    "rename": "Rename",
    "rename_of": "Rename \"{{name}}\"",
    "err_USE_ORG_API": "Leave the organization instead",
    "err_USER_NOT_FOUND": "They must be a member of this organization first",
    "err_UNAVAILABLE": "Temporarily unavailable, try again later",
    "err_NOT_ORG_HOME": "That $t(leaf.cur_lc) isn't under the selected node",
    "err_IDEMPOTENCY_CONFLICT": "The request changed — close the dialog and start again",
    "err_IDEMPOTENCY_IN_PROGRESS": "The previous request is still running, try again shortly",
    "err_RATE_LIMITED": "Too many requests, try again later",
    "err_CLAIM_NOT_FOUND": "Serial or order number doesn't match",
    "levels_hint": "Names for each level of the structure tree (e.g. Region › Site › Floor › Home); also used in paths and reports.",
    "err_SHARE_KIND_NOT_ALLOWED": "Kinio Nodes and Wi-Fi base stations can't be shared (they have no video or data to share). Remove them and try again."
  },
  "people": {
    "members": "Members",
    "grants": "Access",
    "roles": "Roles",
    "home_members": "$t(leaf.cur) members",
    "members_of": "Members of {{name}}",
    "invite": "Invite member",
    "members_hint": "What members can see comes from $t(leaf.cur_lc) roles and site access (organization roles only cover organization matters). Suspended or removed members lose live view and playback within 30 seconds.",
    "name": "Person",
    "role": "Role",
    "status": "Status",
    "org_perms": "Org permissions",
    "joined": "Joined",
    "all_perms": "All",
    "edit_perms": "Permissions",
    "suspend": "Suspend",
    "reactivate": "Reactivate",
    "pending_invites": "Pending invitations",
    "expires": "Expires {{date}}",
    "revoke_invite": "Revoke",
    "org_role_org_admin": "Admin",
    "org_role_developer": "Developer",
    "status_active": "Active",
    "status_suspended": "Suspended",
    "status_left": "Left",
    "edit_perms_of": "Org permissions for {{name}}",
    "perms_hint": "Org permissions don't include video; give that under Access.",
    "perm_org_sites": "Sites & people",
    "perm_org_sites_desc": "Manage the site tree, $t(leaf.cur_lc_pl) and access",
    "perm_org_audit": "Audit",
    "perm_org_audit_desc": "View audit log",
    "perm_org_billing": "Billing",
    "perm_org_billing_desc": "Plans, payment and usage",
    "invite_link_body": "{{email}} doesn't have an account yet, so an invitation email was sent. You can also give them this link directly (valid for 7 days):",
    "invite_body": "Invitations always go by email: if they already have an account they join right away and get notified; otherwise they get an invitation email and join after signing up (valid for 7 days).",
    "invite_role_hint": "\"Member\" has no device access by itself — give it with [+ Give access] on the Access tab. Only the owner can invite admins.",
    "send_invite": "Send invitation",
    "filter_user": "Filter by person",
    "all_users": "Everyone",
    "show_revoked": "Show revoked",
    "assign": "Grant access",
    "grants_hint": "Access = person × site × device scope × period. After sites move or devices relocate, press Refresh to re-expand targets.",
    "no_grants": "No access grants yet.",
    "site": "Site",
    "home": "$t(leaf.cur)",
    "scope": "Device scope",
    "expires_col": "Expires",
    "incl_desc": "(incl. sub-sites)",
    "scope_all": "All in site",
    "scope_list": "{{n}} listed",
    "targets": "{{n}} targets",
    "grant_active": "Active",
    "grant_expired": "Expired",
    "grant_revoked": "Revoked",
    "refresh": "Refresh",
    "refresh_hint": "Re-expand targets from current sites and device positions (can extend expiry)",
    "revoke": "Revoke",
    "revoke_confirm": "Revoke? They'll lose access to these devices within 30 seconds.",
    "assigned": "Granted — expanded to {{n}} device targets:",
    "include_descendants": "Include sub-sites",
    "no_related_homes": "No $t(leaf.cur_lc_pl) above or below this site",
    "custom_actions": "Custom actions…",
    "actions": "Actions",
    "scope_all_desc": "All devices in the site (refresh to include new ones)",
    "scope_list_desc": "Only listed devices",
    "devices": "Device list",
    "days": "Valid for (days)",
    "days_hint": "Up to 90 days; refresh before expiry to extend.",
    "stepup_note": "You may be asked to re-verify when submitting.",
    "new_role": "New role",
    "role_kind": "Type",
    "kind_grant": "Data access",
    "kind_home_admin": "$t(leaf.cur) admin",
    "kind_org_admin": "Org admin",
    "kind_org_permission": "Org permission",
    "system": "System",
    "pending_apply": "Added actions don't apply automatically: {{n}} grants are pending until you press Apply.",
    "pending_chip": "{{n}} pending",
    "apply": "Apply",
    "apply_title": "Apply to existing grants",
    "apply_confirm": "Apply the current actions of “{{role}}” to {{n}} grants that are still on an older version? Actions added individually to a grant are kept.",
    "applied": "Applied to {{n}} grants.",
    "edit_role": "Edit role",
    "role_name": "Role name",
    "role_desc": "Description",
    "role_edit_note": "Removing actions narrows every grant using this role immediately; added actions reach existing grants only when you press Apply.",
    "home_members_hint": "$t(leaf.cur) roles are only for members of the organization; invite family to your home first (Members tab). Members you can see are listed here.",
    "members_hidden": "You access this $t(leaf.cur_lc) through an organization grant, so the member list is hidden.",
    "hrole_owner": "Owner",
    "hrole_admin": "Admin",
    "hrole_member": "Member",
    "hrole_guest": "Guest",
    "hrole_undefined": "Granted",
    "access": "Access sources",
    "access_of": "Access sources of {{name}}",
    "src_org": "Organization",
    "src_homes": "$t(leaf.cur) roles",
    "src_grants": "Site grants ({{n}} active)",
    "src_note": "Organization roles carry no video access by themselves; video needs a $t(leaf.cur_lc) role or a site grant.",
    "owns_homes": "They still manage the $t(leaf.cur_lc_pl) below. Hand them over first in Organization & sites; only set them to unmanaged if nobody will take over:",
    "unassign_owned": "No successor — mark these $t(leaf.cur_lc_pl) unmanaged (only an organization admin can take them over later)",
    "left_done": "Removed: {{grants}} access grants revoked, {{homes}} $t(leaf.cur_lc) roles removed, {{unassigned}} $t(leaf.cur_lc_pl) set to unmanaged.",
    "schedule": "Time window",
    "schedule_on": "Only valid during set hours (site time zone {{tz}})",
    "dow_1": "Mon",
    "dow_2": "Tue",
    "dow_3": "Wed",
    "dow_4": "Thu",
    "dow_5": "Fri",
    "dow_6": "Sat",
    "dow_7": "Sun",
    "from": "From",
    "to": "To",
    "duty_mode": "Duty console account",
    "duty_mode_desc": "no idle sign-out, sign in again every 12 hours, cannot export recordings",
    "duty_badge": "Duty",
    "org_role_owner": "Owner",
    "org_role_member": "Member",
    "org_role_guest": "Guest",
    "org_role_factory_ops": "Factory operations",
    "role_of": "Role of {{name}}",
    "members_hint_personal": "People in your home (for example, family): admins can see and manage every $t(leaf.cur_lc), members can see every $t(leaf.cur_lc), and guests see no devices until you open them one by one.",
    "invite_body_personal": "Invite family to your home. If they already have an account they join right away; otherwise they get an invitation email (valid for 7 days).",
    "invite_role_hint_personal": "Admins can see and manage every $t(leaf.cur_lc); members can see every $t(leaf.cur_lc); guests see no devices by default. Only the owner can invite admins.",
    "invite_joined": "{{email}} already has an account, joined right away and was notified.",
    "invite_here": "Link to accept on this site:",
    "perm_org_devices": "Device inventory",
    "perm_org_devices_desc": "View inventory, claim, pre-assign and adopt devices (no video access)",
    "remove": "Remove",
    "remove_of": "Remove {{name}}",
    "remove_body": "Only the access this organization gave them is removed ($t(leaf.cur_lc) roles, site access, devices shared with the organization); their own home, other organizations and personal shares are not affected. Their live view in this organization stops within 30 seconds. Their account stays (you can invite them again).",
    "invited_by": "Invited by {{name}}",
    "perm_org_support": "Report problems",
    "perm_org_support_desc": "Report problems and see the organization's reports (no video access)"
  },
  "roles": {
    "role-org-admin": "Organization admin",
    "role-org-admin_desc": "Organization, site tree, members, billing, audit; video needs a separate grant",
    "role-site-admin": "Site admin",
    "role-site-admin_desc": "Admin of the $t(leaf.cur_lc_pl) in scope: devices, access, recording policy",
    "role-operator": "Operator",
    "role-operator_desc": "Live, playback, talk, PTZ, sirens",
    "role-viewer": "Viewer",
    "role-viewer_desc": "Live and events",
    "role-technician": "Installer",
    "role-technician_desc": "Focus, aim, settings; no playback or event history",
    "role-auditor": "Auditor",
    "role-auditor_desc": "Audit log"
  },
  "actions": {
    "device": {
      "read": "View devices",
      "control": "Control devices",
      "install": "Install devices",
      "diagnose": "Remote diagnostics"
    },
    "media": {
      "live": "Live view",
      "talk": "Talk"
    },
    "recording": {
      "read": "Playback",
      "export": "Export recordings"
    },
    "event": {
      "read": "View events"
    },
    "case": {
      "read": "View cases",
      "handle": "Handle cases"
    },
    "alarm": {
      "receive": "Receive alarms"
    },
    "security": {
      "arm": "Remote arm",
      "disarm": "Remote disarm"
    },
    "home": {
      "profile": {
        "read": "View $t(leaf.cur_lc) details"
      }
    },
    "install": {
      "complete": "Installation completed"
    }
  },
  "audit": {
    "pick_org": "Choose an organization to view.",
    "action": "Action",
    "all_actions": "All actions",
    "actor": "Actor",
    "all_actors": "All actors",
    "empty": "No matching records.",
    "system": "System",
    "more": "Load older records",
    "a_org_create": "Create organization",
    "a_site_create": "Add site",
    "a_site_update": "Edit site",
    "a_home_create": "Add $t(leaf.cur_lc)",
    "a_home_member_add": "Assign $t(leaf.cur_lc) member",
    "a_device_location": "Move device",
    "a_grant_create": "Grant access",
    "a_grant_refresh": "Refresh grant",
    "a_grant_revoke": "Revoke grant",
    "a_role_create": "Add role",
    "a_role_update": "Edit role",
    "a_member_update": "Update member",
    "a_member_join": "Member joined",
    "a_member_activate": "Joined by invitation",
    "a_member_leave": "Member left",
    "a_home_owner_handover": "Manager handover",
    "a_home_owner_takeover": "Controlled takeover",
    "a_home_unassigned": "$t(leaf.cur) unmanaged",
    "a_org_security_policy": "Security policy changed",
    "a_member_service_roles": "Service roles set",
    "a_member_duty_mode": "Duty account set",
    "a_billing_checkout": "Checkout started",
    "a_billing_seat_assign": "Seat assigned",
    "a_billing_seat_unassign": "Seat unassigned",
    "a_ai_consent_grant": "Cloud AI consent",
    "a_ai_consent_exclusions": "Cloud AI exclusions",
    "a_ai_consent_revoke": "Cloud AI consent withdrawn",
    "a_ai_usage_threshold": "Cloud AI quota reminder",
    "a_test_hook_billing_contract": "Test hook: contract",
    "search": "Search action, device, details, IP",
    "export_csv": "Export CSV (last 30 days)",
    "export_failed": "Export failed. Try again later",
    "a_device_settings": "Device settings changed",
    "a_device_command": "Device command",
    "a_member_invite": "Member invited",
    "a_member_invite_revoke": "Invitation revoked",
    "a_member_role": "Organization role changed",
    "a_member_remove": "Member removed",
    "a_org_owner_transfer": "Ownership transferred",
    "a_org_delete": "Organization deleted",
    "a_share_create": "Shared with a person",
    "a_share_request": "Share request created",
    "a_share_request_cancel": "Share request withdrawn",
    "a_share_accept": "Share with organization approved",
    "a_share_shrink": "Share narrowed",
    "a_share_revoke": "Share revoked",
    "a_share_end": "Share ended by organization",
    "a_share_handover": "Installation handed over",
    "a_share_grantee_removed": "Removed by recipient",
    "range": "Date range",
    "r_today": "Today",
    "r_yesterday": "Yesterday",
    "r_7d": "Last 7 days",
    "r_custom": "Custom",
    "from": "Start date",
    "to": "End date",
    "g_media": "Video access",
    "g_control": "Device control",
    "g_settings": "Settings changes",
    "g_perms": "Permissions",
    "g_account": "Account",
    "g_export": "Export",
    "g_billing": "Billing",
    "g_other": "Other",
    "g_all": "All {{group}}",
    "line": "{{who}} {{what}}",
    "line_target": "{{who}} {{what}}: {{target}}",
    "unknown_device": "a device",
    "unknown_user": "Former member",
    "unknown_home": "a $t(leaf.cur_lc)",
    "unknown_node": "a node",
    "src_local": "local recording",
    "src_cloud": "cloud recording",
    "f_device_ref": "Device",
    "f_device": "Device",
    "f_user_id": "Person",
    "f_target_user_id": "Person",
    "f_home_id": "$t(leaf.cur)",
    "f_node_id": "Node",
    "f_source": "Source",
    "f_reason": "Reason",
    "f_keys": "Settings changed",
    "f_command": "Command",
    "f_path": "Connection",
    "f_from": "Playback start",
    "f_ip": "IP",
    "tech": "Technical details (for support)",
    "s_device_settings": "{{who}} changed settings of {{target}}",
    "s_device_command": "{{who}} sent a command to {{target}}",
    "s_device_rpc": "{{who}} sent a command to {{target}}",
    "s_device_control": "{{who}} operated {{target}}",
    "s_device_location": "{{who}} changed the position of {{target}}",
    "s_media_session_start": "{{who}} started watching {{target}} live",
    "s_media_session_end": "{{who}} stopped watching {{target}} live",
    "s_recording_playback": "{{who}} watched {{target}} ({{src}})",
    "s_recording_download": "{{who}} downloaded a recording of {{target}}",
    "s_recording_delete": "{{who}} deleted recordings of {{target}}",
    "s_grant_create": "{{who}} gave {{target}} a site grant",
    "s_grant_refresh": "{{who}} refreshed {{target}}'s site grant",
    "s_grant_revoke": "{{who}} revoked {{target}}'s site grant",
    "s_member_invite": "{{who}} invited a new member",
    "s_member_role": "{{who}} changed {{target}}'s org role",
    "s_member_remove": "{{who}} removed {{target}} from the organization",
    "s_member_update": "{{who}} changed member settings of {{target}}",
    "s_member_join": "{{target}} joined the organization",
    "s_node_assignment_create": "{{who}} assigned someone at {{target}}",
    "s_node_assignment_revoke": "{{who}} revoked an assignment at {{target}}",
    "s_node_assignment_update": "{{who}} changed an assignment at {{target}}",
    "s_node_block_inheritance": "{{who}} changed inheritance blocking at {{target}}",
    "s_audit_export": "{{who}} exported the audit log",
    "s_billing_seat_assign": "{{who}} assigned a cloud recording seat",
    "a_device_rpc": "Device remote call",
    "a_media_session_start": "Started live view",
    "a_media_session_end": "Ended live view",
    "a_recording_playback": "Played back recording",
    "a_recording_download": "Downloaded recording",
    "a_recording_delete": "Deleted recordings",
    "a_recording_policy_update": "Changed recording settings",
    "a_node_assignment_create": "Node assignment",
    "a_node_assignment_update": "Changed node assignment",
    "a_node_assignment_revoke": "Revoked node assignment",
    "a_node_create": "Added node",
    "a_node_update": "Changed node",
    "a_node_move": "Moved node",
    "a_node_archive": "Archived node",
    "a_node_block_inheritance": "Inheritance blocking",
    "a_node_self_assign": "Assigned self",
    "a_role_apply": "Applied role change",
    "a_member_group_create": "Added member group",
    "a_member_group_update": "Changed member group",
    "a_member_group_delete": "Deleted member group",
    "a_audit_export": "Exported audit log",
    "a_org_rename": "Renamed organization",
    "a_org_tree_settings": "Changed level names",
    "a_home_delete": "Deleted $t(leaf.cur_lc)",
    "a_home_move_node": "Moved $t(leaf.cur_lc)",
    "line_generic_target": "{{who}} did something to {{target}}",
    "line_generic": "{{who}} did something",
    "times_one": "× {{count}}",
    "times_other": "× {{count}}",
    "see_all": "See all in Audit",
    "only_device": "Only {{name}}",
    "clear_device": "All devices",
    "a_media_live": "Watched live video",
    "s_media_watched": "{{who}} watched {{target}} live for {{dur}}",
    "dur_s": "{{s}} s",
    "dur_ms": "{{m}} min {{s}} s",
    "s_media_replayed": "{{who}} played back {{target}}'s local recording for {{dur}}",
    "paren": " ({{v}})",
    "mode_write": " (read-write)",
    "mode_read": " (read-only)",
    "mac_tail": "MAC ending {{v}}",
    "fleet_cmd_other": "a command",
    "fleet_cmd_reboot": "reboot",
    "fleet_cmd_identify": "identify (blink)",
    "fleet_cmd_site_wifi_set": "set site Wi-Fi",
    "fleet_cmd_wifi_set": "set Wi-Fi",
    "fleet_cmd_ttl_config": "configure UART (TTL)",
    "fleet_cmd_ttl_open": "open UART (TTL)",
    "fleet_cmd_ttl_close": "close UART (TTL)",
    "fleet_cmd_caps": "read capabilities",
    "fleet_cmd_ota_update": "update firmware",
    "fleet_cmd_host_nodes": "list attached Nodes",
    "fleet_cmd_host_power": "switch Node power",
    "fleet_cmd_host_reset": "reset a Node",
    "fleet_cmd_host_ota": "update Node firmware",
    "fleet_cmd_host_flash": "flash a Node",
    "fleet_cmd_host_wifi": "set Node Wi-Fi",
    "fleet_cmd_host_health": "read Node health",
    "fleet_cmd_host_imeas": "measure current",
    "org_status_active": "active",
    "org_status_suspended": "suspended",
    "org_status_closed": "closed",
    "s_recording_read": "{{who}} viewed {{target}}'s recording list",
    "s_fleet_console_ticket": "{{who}} got a terminal ticket for {{target}}{{mode}}",
    "s_fleet_console_open": "{{who}} opened {{target}}'s terminal{{mode}}",
    "s_fleet_console_close": "{{who}} closed {{target}}'s terminal",
    "s_fleet_console_writer": "{{who}} took input control of {{target}}'s terminal",
    "s_fleet_command": "{{who}} sent \"{{cmd}}\" to {{target}}",
    "s_fleet_local_credential": "{{who}} set {{target}}'s local sign-in password",
    "s_thing_update": "{{who}} renamed {{target}} to \"{{name}}\"",
    "s_thing_update_plain": "{{who}} updated {{target}}",
    "s_thing_assigned": "{{who}} assigned {{target}} to {{place}}",
    "s_thing_moved": "{{who}} moved {{target}} to {{place}}",
    "s_thing_ttl_direct_token": "{{who}} got a LAN direct token for {{target}}",
    "s_thing_admin_credential_set": "{{who}} set {{target}}'s admin password",
    "s_media_clip_fetch": "{{who}} fetched a clip from {{target}}{{dur}}",
    "s_vms_ai_assign": "{{who}} assigned {{target}} to AI host {{provider}}",
    "s_vms_ai_unassign": "{{who}} removed {{target}} from its AI host",
    "s_vms_alarm_state": "{{who}} marked {{target}}'s alarm as \"{{state}}\"",
    "s_vms_device_links_put": "{{who}} set the linked cameras for {{target}} ({{n}})",
    "s_vms_floorplan_create": "{{who}} added floor plan \"{{name}}\"",
    "s_vms_floorplan_delete": "{{who}} deleted floor plan \"{{name}}\"",
    "s_view_create": "{{who}} added layout \"{{name}}\"",
    "s_view_delete": "{{who}} deleted layout \"{{name}}\"",
    "s_org_node_enroll_lookup": "{{who}} looked up a Kinio Node{{mac}}",
    "s_org_node_enroll_identify": "{{who}} identified a Kinio Node{{mac}}",
    "s_org_node_enroll_approve": "{{who}} enrolled a Kinio Node{{mac}}",
    "s_org_inventory_claim": "{{who}} claimed an inventory device{{serial}}",
    "s_org_status": "{{who}} changed the organization status to \"{{state}}\"",
    "s_org_verification": "{{who}} reviewed the organization's service kinds",
    "s_relationship_request": "{{who}} requested a service relationship",
    "s_relationship_handover": "{{who}} handed over a service relationship",
    "s_service_client_created": "{{who}} created a service account key",
    "s_service_client_revoked": "{{who}} revoked a service account key",
    "s_service_client_secret_rotated": "{{who}} rotated a service account key",
    "s_service_write": "A service account wrote data",
    "s_model_org_assign": "{{who}} assigned model {{model}} to an organization",
    "s_model_org_moved": "{{who}} moved model {{model}} to another organization",
    "s_model_admin_create": "{{who}} created model {{model}}",
    "s_aid_allocate": "{{who}} allocated AIDs",
    "s_qa_org_case": "{{who}} changed a model test case",
    "a_recording_read": "View recording list",
    "a_fleet_console_ticket": "Terminal ticket",
    "a_fleet_console_open": "Open terminal",
    "a_fleet_console_close": "Close terminal",
    "a_fleet_console_session_closed": "Terminal ended",
    "a_fleet_console_writer": "Take terminal input",
    "a_fleet_command": "Node command",
    "a_fleet_local_credential": "Set local password",
    "a_thing_update": "Rename device",
    "a_thing_assigned": "Assign device",
    "a_thing_moved": "Move device",
    "a_thing_ttl_direct_token": "LAN direct token",
    "a_thing_admin_credential_set": "Set admin password",
    "a_media_clip_fetch": "Fetch clip",
    "a_vms_ai_assign": "Assign AI host",
    "a_vms_ai_unassign": "Unassign AI host",
    "a_vms_alarm_state": "Handle alarm",
    "a_vms_device_links_put": "Set linked cameras",
    "a_vms_floorplan_create": "Add floor plan",
    "a_vms_floorplan_delete": "Delete floor plan",
    "a_view_create": "Add layout",
    "a_view_delete": "Delete layout",
    "a_org_node_enroll_lookup": "Look up Kinio Node",
    "a_org_node_enroll_identify": "Identify Kinio Node",
    "a_org_node_enroll_approve": "Enroll Kinio Node",
    "a_org_inventory_claim": "Claim inventory device",
    "a_org_status": "Change organization status",
    "a_org_verification": "Review service kinds",
    "a_relationship_request": "Request service relationship",
    "a_relationship_handover": "Hand over service relationship",
    "a_service_client_created": "Create service key",
    "a_service_client_revoked": "Revoke service key",
    "a_service_client_secret_rotated": "Rotate service key",
    "a_service_write": "Service account write",
    "a_model_org_assign": "Assign model to org",
    "a_model_org_moved": "Move model",
    "a_model_admin_create": "Create model",
    "s_device_read": "{{who}} read the {{rcmd}} of {{target}}",
    "rcmd_other": "data",
    "rcmd_ch_list": "channel list",
    "rcmd_pb_timeline": "recording timeline",
    "rcmd_pb_days": "recording days",
    "rcmd_pb_thumb": "recording thumbnail",
    "rcmd_sys_info": "system info",
    "rcmd_hdd_info": "disk info",
    "rcmd_rec_status": "recording status",
    "rcmd_wifi_state": "Wi-Fi status",
    "rcmd_pb_list": "recording list",
    "s_recording_playback_at": "{{who}} watched {{target}} from {{at}} ({{src}})",
    "s_media_watched_nodur": "{{who}} watched {{target}} live",
    "s_media_replayed_nodur": "{{who}} watched local recordings of {{target}}",
    "no_end_record": "(no end record)",
    "s_media_replay_started": "{{who}} started watching local recordings of {{target}}",
    "s_media_replayed_at": "{{who}} played back {{target}}'s local recording from {{at}} for {{dur}}",
    "s_media_replayed_at_nodur": "{{who}} watched local recordings of {{target}} from {{at}}",
    "s_media_replay_started_at": "{{who}} started watching local recordings of {{target}} from {{at}}",
    "catalog_zh_hant": "no",
    "quoted": "“{{v}}”",
    "s_device_command_named": "{{who}} sent “{{cmdName}}” to {{target}}",
    "s_device_set_named": "{{who}} changed “{{cmdName}}” on {{target}}",
    "rpc_pb_export": "Export recording",
    "rpc_cfg_set": "Change settings",
    "rpc_hdd_smartTest": "Disk health check",
    "rpc_kinio_pair": "Pair device",
    "rpc_kinio_pairWindow": "Open pairing",
    "rpc_kinio_net": "Change network settings",
    "rpc_sys_factoryReset": "Factory reset",
    "rpc_upgrade_check": "Check for firmware update",
    "rpc_tool_run": "Run diagnostic tool",
    "rpc_tool_cancel": "Stop diagnostic tool",
    "times_since": "× {{n}} (first {{since}})",
    "each": "All {{n}} times",
    "filling": "Looking further back for matching entries…",
    "reason_client_stop": "Closed by the viewer",
    "reason_client_gone": "Viewer disconnected or closed the page",
    "reason_device_gone": "Device disconnected",
    "reason_viewer_limit": "Bumped by the viewer limit",
    "reason_token_expired": "Sign-in expired",
    "reason_access_revoked": "Viewing access revoked",
    "reason_authorization_unavailable": "Access could not be verified",
    "reason_api_delete": "Ended via API",
    "reason_timeout": "Timed out"
  },
  "sessions": {
    "title": "Signed-in devices",
    "hint": "After a forced sign-out, that device stops live video within 30 seconds and can no longer refresh its sign-in.",
    "device": "Device",
    "ip": "IP",
    "signed_in": "Signed in / last verified",
    "last_active": "Last active",
    "current": "This one",
    "mfa": "two-step",
    "revoke": "Sign out",
    "sign_out": "Sign out here",
    "revoke_others": "Sign out all other devices",
    "revoke_others_confirm": "Sign out all other devices?",
    "revoke_current_confirm": "This signs out this browser. Continue?",
    "client_c_livingstyle_vms": "ls-vms",
    "client_c_kinio_vms_work": "VMS",
    "client_c_kinio_emu": "Kinio emulator"
  },
  "transfer": {
    "button": "Hand over / take over",
    "title_handover": "Hand over \"{{name}}\"",
    "title_takeover": "Take over \"{{name}}\"",
    "current": "Current manager",
    "unassigned": "Unmanaged",
    "target": "New manager",
    "me": "me",
    "warn_new": "The new manager gets live video, recordings and management rights for this $t(leaf.cur_lc).",
    "warn_old": "The current manager loses the manager role and their site grants on this $t(leaf.cur_lc) (not demoted to admin).",
    "warn_takeover": "This is a controlled takeover by an organization admin; it is fully audited and the people involved are notified.",
    "reason": "Reason (required, recorded in the audit log)",
    "submit_handover": "Hand over",
    "submit_takeover": "Take over",
    "done": "Done. The previous manager's {{n}} grants on this $t(leaf.cur_lc) are revoked, effective within 30 seconds.",
    "unchanged": "That person is already the manager; nothing changed.",
    "not_allowed": "Only the current manager can hand over; organization admins can take over."
  },
  "policy": {
    "title": "Security policy",
    "hint": "Applies only when using this organization's devices and management features; members' own homes and other organizations are not affected. Changes take effect on the next request.",
    "idle": "Idle timeout",
    "idle_hint": "After no activity (mouse, keyboard, touch) for this long, members must verify again to keep using this organization's devices. Use duty mode for monitoring walls.",
    "max_sessions": "Concurrent sign-in limit",
    "max_hint": "Only sign-ins that use this organization count; when over the limit, that sign-in must verify again — the whole account isn't signed out.",
    "unlimited": "Unlimited",
    "sessions": "{{n}}",
    "minutes": "{{n}} min",
    "hours": "{{n}} h",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "saved": "Saved",
    "ip_allowlist": "IP allowlist",
    "ip_hint": "One IP or CIDR per line (e.g. 203.0.113.0/24); empty = no limit. Connections from outside the list are refused for this organization's devices and management. Your current IP must be on the list when saving.",
    "require_mfa": "Require two-step verification",
    "require_mfa_hint": "Members without two-step verification can't see this organization's devices and are asked to turn it on; the account itself isn't forced.",
    "login_max_age": "Sign-in lifetime",
    "login_max_age_hint": "After this long since sign-in, members must sign in again to keep using this organization's devices (the whole account isn't signed out).",
    "api_keys": "Members can access this organization with API keys",
    "api_keys_hint": "When on, members can let Claude look up this organization's devices, events and alarms with their own API keys (limited to each person's current access; writes and image downloads are audited each time, reads are not).",
    "snapshot_upload": "Save event snapshots to the cloud",
    "snapshot_upload_hint": "Each event saves one small image to the cloud so notifications and the event list show a thumbnail and cloud AI can analyze it. Turning off takes effect right away; turning on needs re-verification.",
    "snapshot_upload_off_hint": "Off: events are still recorded, but notifications have no thumbnail, the event list and preview tiles show a category icon, and cloud AI is unavailable (the local AI hub is not affected). Snapshots already in the cloud expire on their normal schedule. App screenshots are not affected."
  },
  "passkey": {
    "title": "Passkeys",
    "hint": "Sign in with fingerprint, face or device PIN — no password, and it counts as two-step verification. Passkeys saved in iCloud Keychain or Google Password Manager sync to your other devices.",
    "add": "Add passkey",
    "none": "No passkeys yet.",
    "unsupported": "This browser does not support passkeys.",
    "synced": "Synced",
    "created": "Added {{date}}",
    "last_used": "Last used {{date}}",
    "delete": "Delete",
    "delete_confirm": "Delete \"{{name}}\"? You won't be able to sign in with it.",
    "sign_in": "Sign in with a passkey",
    "or": "or",
    "verify": "Verify with a passkey",
    "or_password": "or enter your password",
    "err_PASSKEY_CANCELED": "Canceled or timed out",
    "err_PASSKEY_EXISTS": "This device already has a passkey for this account",
    "err_PASSKEY_INVALID": "Passkey verification failed",
    "err_PASSKEY_STATE_INVALID": "Timed out — please try again",
    "err_NO_PASSKEY": "This account has no passkey on this site yet. Use your password below instead (you can add a passkey in Settings › Security).",
    "err_LAST_FACTOR": "An organization you belong to requires two-step verification: keep at least one method (TOTP or passkey)",
    "err_PASSKEY_DISABLED": "Passkeys are not enabled in this environment",
    "err_BAD_RP": "Passkeys can't be used on this address",
    "err_REAUTH_REQUIRED": "Re-verification required",
    "err_default": "Passkey failed ({{code}})"
  },
  "ext": {
    "verified": "Verified by Kinio: {{kind}}",
    "until": "until {{date}}",
    "shrink": "Narrow",
    "revoke": "Revoke",
    "auto_include_new_on": "new devices included (status / events / alarms only)",
    "cond_always": "video any time",
    "cond_alarm_window": "video only within {{n}} min after an alarm",
    "cond_armed": "video only while armed",
    "code": "Invitation code",
    "code_hint": "Enter the code from the service provider (or open their link). You approve inside your own account; the provider never sees your account details.",
    "preview": "Review",
    "duration_one": "{{count}} day",
    "duration_other": "{{count}} days",
    "scopes": "Allowed actions",
    "devices": "Devices",
    "devices_all": "All current devices in the $t(leaf.cur_lc)",
    "devices_list": "Only selected devices",
    "auto_include_new": "Include devices added later (status, events and alarms only; video and control always need separate consent)",
    "media_condition": "Video condition",
    "history": "History before the start",
    "history_none": "None (default)",
    "history_days_one": "{{count}} day back",
    "history_days_other": "{{count}} days back",
    "install_lan": "Allow on-site mode (installer uses the local network, up to 8 hours, void on handover)",
    "consent_note": "Approving video, arm/disarm or on-site mode asks you to re-verify.",
    "accept": "Approve",
    "shrink_of": "Narrow \"{{name}}\"",
    "shrink_hint": "You can only narrow; to widen, the provider must send a new request.",
    "access_log_empty": "No service access yet.",
    "when": "When",
    "who": "Person",
    "what": "Action",
    "device": "Device",
    "purpose_install": "Installation",
    "purpose_maintenance": "Maintenance",
    "purpose_monitoring": "Monitoring",
    "purpose_security_service": "Security service",
    "purpose_care": "Care",
    "purpose_property": "Property",
    "kind_installer": "installer",
    "kind_security_provider": "security company",
    "kind_monitoring_center": "monitoring center",
    "kind_property_manager": "property manager",
    "kind_care_provider": "care provider",
    "kind_dealer": "dealer",
    "kind_enterprise": "enterprise",
    "device_unknown": "Removed device"
  },
  "svc": {
    "title": "Share requests",
    "note": "Note for the owner (optional)",
    "issue": "Create invitation code",
    "issued": "Valid for 7 days, single use. Give this code or link to the owner:",
    "status_active": "Active",
    "status_suspended": "Suspended",
    "status_ended": "Ended",
    "complete_install": "Complete installation (handover)",
    "end": "End",
    "end_confirm": "End this share?",
    "service_roles": "Service roles",
    "service_roles_hint": "Service roles decide what this person can do in customer $t(leaf.cur_lc_pl), never more than what the customer approved.",
    "role_operator": "Operator",
    "role_operator_desc": "status, events, video, playback, alarms",
    "role_supervisor": "Supervisor",
    "role_supervisor_desc": "arm/disarm, export recordings",
    "role_technician": "Technician",
    "role_technician_desc": "install, configure, remote diagnostics",
    "tab": "Shared with this organization",
    "hint_kinds": "This organization's service categories: {{kinds}}. Create a one-time code for a $t(leaf.cur_lc); the $t(leaf.cur_lc) approves in its own app or VMS before you get access (purposes not yet verified by the platform are flagged to the $t(leaf.cur_lc) and refused by the server).",
    "no_kinds": "This organization has no service category (e.g. installer, security, monitoring center), so it can't send share requests; $t(leaf.cur_lc_pl) can still share devices with you.",
    "purpose": "Purpose",
    "pending_requests": "Waiting for the $t(leaf.cur_lc) to approve",
    "renewal": "Renewal",
    "cancel_request": "Withdraw",
    "received": "Received shares",
    "received_hint": "Set what members can do with service roles under the member's \"Org permissions…\" — never more than the $t(leaf.cur_lc) shared. The organization can't manage or re-share these devices.",
    "none_received": "No shares received yet.",
    "a_home": "A $t(leaf.cur_lc)",
    "unverified": "This organization's service categories aren't verified by the platform yet (or have expired). Share requests are available after verification.",
    "verified_until": "Verified until {{date}}"
  },
  "sensor": {
    "popups": "Sensor pop-ups",
    "contact_title": "{{name}} opened",
    "motion_title": "{{name}} detected motion",
    "playback": "Play back {{cam}}",
    "no_link": "No linked camera. Link one under Devices to see live video when it triggers.",
    "contact_on": "Open",
    "contact_off": "Closed",
    "motion_on": "Occupied",
    "motion_off": "Clear",
    "alarm_title2": "Alarm · {{what}} · {{name}}",
    "detection_title2": "Detection · {{what}} · {{name}}",
    "more_n_one": "{{count}} more",
    "more_n_other": "{{count}} more",
    "expand": "Expand",
    "collapse": "Collapse",
    "watch_live": "Watch live",
    "no_snapshot": "No snapshot yet — press Watch live to see the scene",
    "switch_scope": "Switch to its scope",
    "alarm_kind": "Alarm · {{what}}",
    "detection_kind": "Detection · {{what}}",
    "out_of_scope_path": "Outside current scope: {{path}}",
    "switch_scope_to": "Switch to {{path}}"
  },
  "link": {
    "button": "Links",
    "title": "Cameras linked to {{name}}",
    "help": "Which cameras to show when it triggers (door opens / motion).",
    "cameras": "Cameras",
    "no_cameras": "No cameras in this $t(leaf.cur_lc)",
    "purposes": "Use for",
    "purpose_popup": "Live pop-up",
    "purpose_clip": "Playback on event card",
    "readonly": "Only a $t(leaf.cur_lc) owner / admin or org admin can change this"
  },
  "onvif": {
    "open": "Add ONVIF camera",
    "title": "Add ONVIF cameras (via a Kinio gateway)",
    "help": "Third-party ONVIF cameras connect through an on-site NVR, Kinio Station or AI box (the gateway); credentials go only to the gateway. Kinio devices are paired the Kinio way instead.",
    "no_gateway": "There is no Kinio NVR or Kinio Station you can manage here to act as a gateway (owner or admin required). Add an NVR or AI box to sites without one.",
    "gateway": "Gateway",
    "discover": "Discover",
    "discovering": "Discovering…",
    "group_managed": "Already added",
    "group_own": "Kinio devices",
    "group_suspect": "Probably Kinio devices",
    "group_third_party": "Third-party ONVIF",
    "none": "None",
    "on_channel": "Already CH{{ch}}",
    "pair_kinio": "Pair the Kinio way (not ONVIF)",
    "suspect_help": "Pair the Kinio way by default; adding an old model via ONVIF needs the owner and a reason.",
    "suspect_help_owner": "Pair the Kinio way by default; to add via ONVIF anyway, tick it and give a reason (audited).",
    "duplicates": "{{n}} duplicate answers merged (same camera on another interface)",
    "creds_help": "Camera credentials (sent only to the gateway, not stored; used for every ticked camera)",
    "user": "User",
    "password": "Password",
    "add": "Add {{n}}",
    "reason": "Why not pair the Kinio way? (e.g. old Swann model without the private protocol)",
    "force_add": "Add {{n}} via ONVIF anyway",
    "result_ok": "Added",
    "result_auth_failed": "Wrong credentials",
    "result_timeout": "Timed out",
    "result_unreachable": "Unreachable",
    "result_unsupported": "Unsupported",
    "h265_only": "H.265 only"
  },
  "ptz": {
    "title": "PTZ control",
    "home": "Home position",
    "speed": "Speed",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out",
    "presets": "Presets",
    "pick_preset": "Choose a preset",
    "no_presets": "No presets",
    "loading": "Loading…",
    "goto": "Go",
    "save_preset": "Save position",
    "preset_name": "Preset name",
    "held": "Controlled by {{role}} (free in {{n}} s)",
    "preempted": "Control was taken over by {{role}}",
    "take_over": "Take over",
    "role_owner": "the owner",
    "role_admin": "an admin",
    "role_member": "a member",
    "role_operator": "an operator",
    "role_partner": "a service partner",
    "dir_up": "Up",
    "dir_down": "Down",
    "dir_left": "Left",
    "dir_right": "Right",
    "dir_upleft": "Up left",
    "dir_upright": "Up right",
    "dir_downleft": "Down left",
    "dir_downright": "Down right",
    "err_GATEWAY_OFFLINE": "Gateway offline",
    "err_GATEWAY_TIMEOUT": "Gateway not responding",
    "err_FORBIDDEN": "You may not control this device",
    "cruise_start": "Start patrol",
    "cruise_stop": "Stop patrol",
    "cruise_dwell": "Dwell per preset (s)",
    "cruise_at": "Patrolling: {{name}}",
    "presets_count": "Presets  {{n}} / {{max}}",
    "presets_count_a11y": "Presets, {{n}} saved, up to {{max}}",
    "preset_n": "Position {{n}}",
    "preset_add": "+ Add",
    "preset_full": "Full",
    "preset_manage": "Manage",
    "preset_manage_a11y": "Manage presets",
    "preset_done": "Done",
    "preset_done_a11y": "Finish managing",
    "preset_rename": "Rename",
    "preset_name_it": "Name it",
    "preset_update": "Update to current position",
    "preset_delete": "Delete",
    "preset_delete_confirm": "Delete “{{name}}”?",
    "preset_here": "Current position",
    "preset_going": "Moving to {{name}}",
    "preset_arrived": "Moved to {{name}}",
    "preset_card_a11y": "{{name}}, preset",
    "preset_card_unnamed_a11y": "{{name}}, preset, unnamed",
    "preset_menu": "Preset options",
    "preset_name_label": "Name",
    "preset_name_hint": "Up to 12 characters; everyone who can see this camera sees it",
    "preset_save": "Save",
    "preset_unreachable": "The camera is offline; showing the last known presets",
    "preset_conflict": "Someone just changed the presets; the list is updated",
    "preset_err_BUSY": "The PTZ is busy. Try again later.",
    "preset_err_NOT_FOUND": "This position is no longer valid",
    "preset_err_NOT_CALIBRATED": "The PTZ is still calibrating",
    "preset_err_TIMEOUT": "Didn’t reach {{name}}",
    "preset_err_OFFLINE": "The camera is offline; nothing was updated or deleted",
    "preset_err_ASLEEP": "The camera is asleep. Try again later.",
    "preset_err_LIMIT": "Presets are full",
    "preset_err_INVALID_NAME": "Enter a name of 1–12 characters",
    "preset_err_OTHER": "That didn’t work. Try again.",
    "lens_note": "Left/right: both lenses turn. Up/down: only {{name}}",
    "lens_none": "Direction pad; this lens doesn’t move"
  },
  "ai": {
    "title": "AI compute",
    "help": "AI boxes, NVRs with an AI chip and Kinio Stations run AI analytics on site for cameras in the same $t(leaf.cur_lc); detections are recorded on the source camera. On-site AI comes with the hardware — no subscription needed.",
    "no_provider": "No device in this scope can run AI yet (AI box, NVR with an AI chip, or Kinio Station).",
    "assign": "Assign camera",
    "assign_title": "Assign a camera to {{name}}",
    "assign_submit": "Assign",
    "probing": "Asking the provider to test the stream…",
    "capacity": "{{used}} / {{total}} channels used",
    "capacity_title": "{{used}} of {{total}} channels used",
    "load": "Load {{n}}%",
    "fps": "{{n}} fps",
    "none": "No assignments yet",
    "move": "Move to…",
    "unassign": "Unassign",
    "drag_help": "Drag a camera onto a provider above, or use “Assign camera”",
    "camera": "Camera",
    "models": "Models",
    "sensitivity": "Sensitivity {{n}}",
    "st_pending": "Applying",
    "st_running": "Running",
    "st_degraded": "Degraded",
    "detail_viewer_limit": "Live viewers are using every viewing slot on this device. AI analysis yields and resumes when a slot frees up.",
    "detail_lan_unreachable": "The source device is not reachable on the local network; event analysis is paused.",
    "st_unreachable": "Unreachable",
    "st_rejected": "Rejected",
    "err_AI_SOURCE_UNREACHABLE": "The provider can't reach this camera: {{message}}",
    "err_AI_SOURCE_UNSUPPORTED": "The firmware of this camera (or its NVR / Station / base station) cannot relay video to an AI compute provider yet",
    "err_AI_CAPACITY_FULL": "Capacity full ({{used}} / {{channels}} channels)",
    "err_AI_ALREADY_ASSIGNED": "This camera is already assigned to a provider",
    "err_AI_MODEL_UNSUPPORTED": "The provider doesn't support model {{model}}",
    "err_PROVIDER_OFFLINE": "Provider offline",
    "err_NOT_AI_PROVIDER": "This device isn't an AI compute provider",
    "err_FORBIDDEN": "$t(leaf.cur) owner or admin required",
    "err_VERSION_CONFLICT": "Someone else changed this — please refresh",
    "err_GATEWAY_OFFLINE": "Gateway offline",
    "err_GATEWAY_TIMEOUT": "Gateway not responding",
    "model": {
      "kinio": {
        "person_vehicle@2": "Person & vehicle",
        "line_cross@1": "Line crossing",
        "intrusion@1": "Intrusion"
      }
    },
    "delivery": "Video delivery",
    "delivery_auto": "Automatic (continuous when possible)",
    "delivery_continuous": "Continuous stream",
    "delivery_event": "Event snapshots",
    "delivery_help": "Video is relayed to the provider by the camera or its NVR / Station / base station, so the provider never needs the camera password. A continuous stream uses one viewer slot on that device; battery cameras support event snapshots only.",
    "err_AI_DELIVERY_UNSUPPORTED": "This camera does not support that delivery mode (battery cameras support event snapshots only)",
    "err_AI_VIEWER_LIMIT": "The device has no free viewer slot (limit {{limit}}: {{viewers}} viewing, {{ai}} AI continuous streams). Use event snapshots or try again later",
    "err_BAD_DELIVERY": "Invalid delivery mode",
    "tab_local": "On-site AI",
    "tab_cloud": "Cloud AI",
    "stations_without_one": "{{count}} Kinio Station can't run AI (for example the Windows version), so it isn't listed above.",
    "stations_without_other": "{{count}} Kinio Stations can't run AI (for example the Windows version), so they aren't listed above.",
    "move_confirm": "Move {{cam}} to {{to}}?",
    "move_body": "Analysis on the current provider stops and the new one takes over within seconds.",
    "move_action": "Move",
    "moved": "Moved {{cam}} to {{to}}.",
    "move_undo": "Undo",
    "subject": {
      "person": "people",
      "vehicle": "vehicles",
      "animal": "animals",
      "face": "faces",
      "plate": "plates",
      "package": "packages",
      "fire": "fire",
      "smoke": "smoke"
    },
    "subject_sep": ", ",
    "model_detect": "Detects {{what}}",
    "model_detect_light": "Detects {{what}} (lightweight)",
    "model_generic": "AI detection model v{{v}}",
    "stations_without_named": "{{names}} has no AI compute (this Kinio Station build has no inference backend), so it is not listed above.",
    "unassign_confirm": "Stop AI analysis on {{cam}}?",
    "unassign_body": "AI detection on this camera stops and no more AI events will be created. You can press Undo afterwards to assign it again with the same settings.",
    "unassign_action": "Unassign",
    "unassigned": "AI analysis on {{cam}} stopped.",
    "tab_byo": "Your own AI"
  },
  "search": {
    "placeholder": "Search events: red scooter device:Front class:person tag:helmet after:2026-09-01",
    "sort": "Sort",
    "sort_time": "Newest first",
    "sort_relevance": "Most relevant",
    "suggest": "Suggestions",
    "syntax": "Syntax: free text, \"phrase\", -exclude, class: level: device: (device name, e.g. device:\"NVR631 / CH5\") site: (site incl. sub-sites) node: view: group: (org tree node / layout / group — type a name to pick) tag: after: before: on: has:clip; comma = or",
    "warnings": "Ignored conditions: {{list}}",
    "histogram": "Events per hour",
    "more": "Load more",
    "producer": "Detected by {{id}}",
    "bm_add": "Add bookmark",
    "bm_title": "Bookmark title",
    "bm_note": "Note (optional)",
    "bm_private": "Only me",
    "bm_saved": "Bookmarked",
    "bm_delete": "Delete bookmark",
    "bookmarks": "Bookmarks",
    "site_unknown": "Site not found: {{list}} (these conditions return nothing)",
    "saved": "Saved searches",
    "saved_none": "No saved searches yet",
    "saved_shared": "Shared",
    "saved_name": "Name",
    "saved_scope": "Save to",
    "saved_personal": "Only me",
    "saved_org": "Shared in {{name}}",
    "saved_save": "Save current search",
    "saved_delete": "Delete “{{name}}”",
    "saved_help": "Only the query is saved; applying it searches again with your current permissions.",
    "saved_err_SAVED_SEARCH_LIMIT": "You can keep up to 100 saved searches; delete some first",
    "saved_err_BAD_NAME": "The name must be 1–80 characters",
    "saved_err_FORBIDDEN": "Shared saved searches need an organization admin",
    "to_map": "Show these results on the map",
    "src_edge_box": "AI box",
    "src_device": "On-device AI",
    "node_none": "No node matches \"{{q}}\"",
    "tree_filters": "Filtering: {{list}}",
    "tree_field_node": "node \"{{name}}\"",
    "tree_field_view": "layout \"{{name}}\"",
    "tree_field_group": "group \"{{name}}\"",
    "node_error": "Node search failed — try again later (this is not \"no match\")",
    "node_partial": "Node search failed in one region; only results that loaded are listed",
    "tree_name_unknown": "{{id}} (name unknown)",
    "range": "Time range",
    "range_any": "Any time",
    "range_today": "Today",
    "range_yesterday": "Yesterday",
    "range_24h": "Last 24 hours",
    "range_custom": "Custom…",
    "range_from": "From",
    "range_to": "To",
    "syntax_btn": "ⓘ Syntax",
    "syntax_dates": "Dates (YYYY-MM-DD, in your time zone): after:D from the start of D (inclusive), before:D until the start of D (D excluded), on:D only that day.",
    "range_7d": "Last 7 days",
    "hist_tip": "{{at}} · {{n}}",
    "hist_hint": "Drag across the bars to set a time range; click one bar for that hour.",
    "term_as_class": "{{terms}} searched as event type: “{{cls}}” (incl. video loss, device removed or covered)"
  },
  "exports": {
    "title": "Exports & evidence",
    "help": "Export recordings as MP4 evidence packages (with a SHA-256 for every file and a platform signature); the source can be cloud, NVR / Station disk, or off-site backup. Every download re-checks permissions. Completed packages are kept free for 30 days; switch to long-term retention to keep them longer.",
    "new": "New export",
    "none": "No exports yet",
    "st_queued": "Queued",
    "st_running": "Processing",
    "st_done": "Done",
    "st_failed": "Failed",
    "st_expired": "Expired",
    "signed": "Signed",
    "unsigned": "Unsigned",
    "reason": "Reason",
    "download": "Download package",
    "share": "Share",
    "home": "$t(leaf.cur) / site",
    "cameras": "Cameras (up to {{max}})",
    "from": "Start",
    "minutes": "Length",
    "n_min": "{{n}} min",
    "reason_ph": "e.g. police request, case number… (required; recorded in the audit log and the package)",
    "create": "Create export",
    "export_this": "Export this",
    "share_title": "Share links",
    "ttl": "Valid for",
    "ttl_3600": "1 hour",
    "ttl_86400": "1 day",
    "ttl_604800": "7 days",
    "ttl_2592000": "30 days",
    "max_views": "View limit",
    "unlimited": "Unlimited",
    "share_password": "Password",
    "share_password2": "Confirm password",
    "optional": "Optional",
    "share_create": "Create link",
    "share_once": "This link is shown only once — copy it now.",
    "expires": "Expires {{at}}",
    "views": "{{n}} / {{max}} views",
    "has_password": "Password",
    "revoked": "Revoked",
    "expired": "Expired",
    "revoke": "Revoke",
    "err_REASON_REQUIRED": "A reason is required (at least 4 characters)",
    "err_BAD_RANGE": "Invalid range: one segment per camera, end after start, at most 1 hour, not in the future",
    "err_BAD_SOURCES": "Pick 1–4 cameras",
    "err_FORBIDDEN": "You may not export this camera",
    "err_EXPORT_NOT_READY": "The export isn't ready",
    "err_BAD_TTL": "Validity must be 1 hour to 30 days",
    "source": "Source",
    "src_cloud": "Cloud recording",
    "src_local": "NVR / Station disk",
    "src_backup": "Off-site backup",
    "src_cloud_help": "Export from cloud recording clips.",
    "src_local_help": "Asks the NVR / Kinio Station to upload this local recording for the export (used for this export only; it does not count as cloud recording or use a seat). The device must be online; camera SD cards are not supported yet.",
    "src_backup_help": "Export from verified off-site backup copies (integrity is checked again on read).",
    "local_waiting": "Waiting for the device to upload the local recording (up to 30 minutes)…",
    "fail_local_export_unsupported": "This device’s firmware does not support local recording export yet",
    "fail_local_upload_timeout": "The device did not finish uploading in time (it may be offline or the upload is too slow)",
    "fail_local_export_failed": "The device did not accept the export request (it may be offline)",
    "fail_no_recording": "No local recording in this period",
    "fail_codec_not_supported": "The video codec in this period cannot be exported (H.264 / H.265 only)",
    "tab_jobs": "Export jobs",
    "no_rec_in_source": "No {{src}} in this period",
    "recipient": "Recipient",
    "recipient_ph": "e.g. Officer Tanaka / tanaka@example.jp",
    "recipient_help": "One link per recipient. A masked form appears in the watermark on their screen.",
    "ttl_until_export": "Until the export expires ({{at}})",
    "share_export_expiry": "The export is kept until {{at}}; share links cannot outlast it.",
    "share_clamped": "The expiry was shortened to when the export expires ({{at}}).",
    "no_recipient": "(no recipient)",
    "err_EXPORT_EXPIRES_SOON": "This export expires in less than an hour. Export again before sharing.",
    "err_RECIPIENT_REQUIRED": "Enter a recipient (name or email, up to 100 characters)",
    "fail_signing_failed": "Signing the evidence package failed, so no unsigned package was produced. Export again later or contact the platform.",
    "block_not_enabled": "Evidence export isn't enabled for this organization yet. Contact your service provider to turn it on.",
    "block_worker_disabled": "Exports can't be created in this environment right now.",
    "block_tmp_space_low": "The export service is busy. Try again later.",
    "block_gateway_unreachable": "Exports can't be created right now. Try again later.",
    "max_views_help": "Defaults to {{n}}. Each time the recipient opens the share page counts as one view.",
    "fail_queue_timeout": "Waited too long in the queue without starting (the export service was off or busy). Create the export again.",
    "st_deleted": "Deleted",
    "archived": "Long-term",
    "kept_free": "Kept free until {{at}}",
    "kept_archive": "Long-term retention until {{at}}",
    "quota_line": "Free storage (shared by the organization): {{used}} of {{limit}} used",
    "block_quota_exceeded": "This organization's free export storage is full: delete packages you no longer need, or switch the ones to keep to long-term retention.",
    "delete": "Delete…",
    "delete_title": "Delete export package",
    "delete_help": "Deleting stops the package and its share links immediately and removes the files from the cloud. This can't be undone.",
    "delete_no_refund": "This package is in long-term retention: deleting it early does not refund the retention fee.",
    "delete_reason": "Reason (required, recorded in the audit log)",
    "delete_confirm": "Delete",
    "deleted_reason": "Deletion reason",
    "err_EXPORT_BUSY": "The export is still running; you can delete it once it finishes.",
    "err_EXPORT_GONE": "The package has already expired or been deleted.",
    "archive": "Keep long-term…",
    "archive_extend": "Extend retention…",
    "archive_title": "Switch to long-term retention",
    "archive_extend_title": "Extend long-term retention",
    "archive_help": "This package is {{size}} ({{cls}}). During long-term retention you can still download, verify and share it (each link is still at most 30 days); it is deleted when retention ends. Extensions start from the current end date.",
    "archive_size_5gb": "≤ 5 GB",
    "archive_size_20gb": "≤ 20 GB",
    "archive_size_50gb": "≤ 50 GB",
    "archive_period": "Retention period",
    "archive_p_90d": "90 days",
    "archive_p_1y": "1 year",
    "archive_p_3y": "3 years",
    "archive_after": "Kept until {{at}} after payment",
    "archive_reason": "Reason (required, recorded in the audit log)",
    "archive_no_refund": "One-time payment, prices exclude tax. Deleting the package or the $t(leaf.cur_lc) early does not refund the fee.",
    "archive_pay": "Continue to payment",
    "archive_processing": "Processing payment; this updates when it completes…",
    "archive_done": "Long-term retention is active.",
    "archive_failed": "The payment didn't complete; the package keeps its current retention.",
    "archive_canceled": "Payment canceled; the package keeps its current retention.",
    "archive_slow": "The payment result hasn't arrived yet. Refresh in a moment.",
    "err_ARCHIVE_TOO_LONG": "The new end date can't be more than 3 years from today.",
    "err_ARCHIVE_TOO_LARGE": "Packages over 50 GB can't be kept long-term.",
    "err_ARCHIVE_PENDING": "A checkout for this package is already in progress. Finish it or wait for it to expire (23 hours).",
    "err_EXPORT_NOT_DONE": "The export must finish before it can be kept long-term.",
    "err_STORE_NOT_CONFIGURED": "Online payment isn't available for this brand yet. Contact your provider.",
    "err_BAD_PERIOD": "The period must be 90 days, 1 year or 3 years."
  },
  "shares": {
    "tab": "Share links",
    "help": "Every external share link: who it went to, who created it, when it expires and how often it was viewed. The code is the 6 characters in the viewer's watermark.",
    "filter": "Show",
    "f_active": "Active",
    "f_all": "All",
    "revoke_picked": "Revoke {{n}} selected",
    "none_active": "No share links are open right now",
    "none_all": "No share links have been created yet",
    "pick_all": "Select all active",
    "pick": "Select {{code}}",
    "col_video": "Video",
    "col_recipient": "Recipient",
    "col_code": "Code",
    "col_by": "Created by",
    "col_created": "Created",
    "col_expires": "Expires",
    "col_views": "Views",
    "col_password": "Password",
    "col_status": "Status",
    "col_actions": "Actions",
    "by_me": "Me",
    "by_other": "Another member",
    "st_active": "Active",
    "st_expired": "Expired",
    "st_revoked": "Revoked",
    "st_used_up": "Views used up",
    "revoke_one_title": "The recipient will no longer be able to open this link",
    "revoke_body": "Recipient: {{who}} (code {{code}}). Takes effect within 30 seconds and cannot be undone; create a new link to share again.",
    "revoke_many_title": "Revoke {{n}} share links",
    "revoke_many_body": "These recipients lose access within 30 seconds; this cannot be undone. Any link that fails to revoke stays in the table with the reason."
  },
  "share": {
    "title": "Shared video",
    "need_password": "This video is password protected",
    "password": "Password",
    "wrong_password": "Wrong password",
    "open": "Open",
    "gone": "This share link is no longer valid (expired, revoked or out of views).",
    "not_found": "Share link not found.",
    "error": "Couldn't load right now — please try again later.",
    "expires": "Link expires {{at}}",
    "clip_n": "Clip {{n}}"
  },
  "verify": {
    "title": "Evidence verification",
    "help": "Checks an evidence package in your browser: whether each file's SHA-256 matches the manifest and whether the manifest's platform signature is valid. Nothing is uploaded.",
    "drop": "Drop the evidence ZIP here, or click to choose",
    "checking": "Checking…",
    "v_pass": "Verified: files intact, signature valid",
    "v_fail": "Verification failed: contents altered or signature invalid",
    "v_unsigned": "Files intact, but this package is unsigned",
    "job": "Export job",
    "exported_by": "Exported by",
    "reason": "Reason",
    "generated": "Generated",
    "signature": "Signature",
    "sig_valid": "Valid",
    "sig_invalid": "Invalid (manifest altered or not signed by the platform)",
    "sig_unsigned": "Unsigned",
    "sig_no_key": "No matching platform key",
    "missing": "File missing",
    "mismatch": "SHA-256 mismatch (altered)",
    "extra": "Extra file not in the manifest",
    "err_bad_zip": "Not a valid ZIP",
    "err_no_manifest": "manifest.json missing from the ZIP",
    "err_bad_manifest": "manifest.json is malformed",
    "tab": "Verify evidence package",
    "key": "Signing key",
    "fp_short": "fingerprint {{fp}}",
    "key_current": "In use",
    "key_retired": "Retired",
    "keys_title": "Platform verification keys ({{n}})",
    "keys_help": "After a key change, older packages are still verified with the key that signed them. Compare these fingerprints with the platform's public documentation."
  },
  "billing": {
    "subject": "Billing account",
    "subject_org": "Organization: {{name}}",
    "subject_home": "$t(leaf.cur): {{name}}",
    "no_subject": "You don't have an organization or $t(leaf.cur_lc) whose plan you can view.",
    "notice_ok": "Done",
    "notice_warn": "Note",
    "notice_err": "Error",
    "checkout_canceled": "Checkout canceled. You were not charged.",
    "checkout_processing": "Payment received — confirming (usually a few seconds)…",
    "checkout_done": "Purchase complete. Seats and quota are active.",
    "checkout_failed": "The payment didn't complete or has expired.",
    "checkout_slow": "Confirmation is taking longer than usual. Refresh in a moment; if you were charged, the seats will appear automatically.",
    "subscriptions": "Subscriptions",
    "no_subscriptions": "No subscriptions yet.",
    "items": "Items",
    "state": "Status",
    "period_end": "Renews / ends",
    "grace_until": "Grace period until {{at}}",
    "manage": "Manage payment & subscriptions",
    "manage_hint": "In Stripe's portal you can change the seat count, update your card, or cancel. Changes sync back within a minute.",
    "buy": "Buy",
    "draft_prices": "Prices are provisional",
    "store_not_configured": "Payments aren't set up for this brand yet, so purchasing is unavailable.",
    "need_org_billing": "Buying requires an organization admin or the Billing permission. You can view, but not buy.",
    "need_owner": "Only the $t(leaf.cur_lc)'s owner can buy.",
    "product": "Product",
    "price": "Price",
    "quantity": "Qty",
    "per_month": "month",
    "per_year": "year",
    "per_seat": "per seat",
    "buy_btn": "Buy ({{total}})",
    "seat_name": "Cloud recording seat: {{mode}}, {{days}}-day retention",
    "ai_name": "Cloud AI: {{n}} analyses/month",
    "pack_name": "Cloud AI add-on: {{n}} analyses",
    "pack_hint": "Valid this month (UTC)",
    "ai_already": "Cloud AI is already subscribed; buy an add-on for more quota",
    "mode_event": "Event recording",
    "mode_continuous": "Continuous recording",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "seats": "Cloud recording seats",
    "seats_summary": "Seats: {{total}} · unassigned: {{free}}",
    "no_seats": "No seats yet. After buying, assign them to devices or channels here.",
    "seat": "Seat",
    "source": "Source",
    "source_subscription": "Subscription",
    "source_grant": "Contract",
    "contract_until": "Contract until {{at}}",
    "assigned_to": "Assigned to",
    "unassigned": "Unassigned",
    "has_seat": "has a seat",
    "usage_month": "Uploaded this month",
    "usage": "{{clips}} clips · {{mb}} MB",
    "assigned": "Assigned to {{name}}. It starts uploading on this seat within {{within}} seconds.",
    "covered_by_plan": "{{name}} was already covered by the $t(leaf.cur_lc) plan; it now uses this seat's retention and mode.",
    "seats_hint": "A device (or one NVR channel) can hold one seat at a time. After reassigning, the old device stops uploading within 60 seconds; stored clips keep their original retention.",
    "ai": "Cloud AI quota",
    "ai_usage": "{{period}}: {{used}} / {{limit}} analyses used",
    "ai_packs": "(includes {{n}} add-on)",
    "ai_limit_reached": "This month's quota is used up. Analysis is paused; recording and events are unaffected. You can buy an add-on.",
    "ai_near_limit": "Over 80% of this month's quota is used.",
    "ai_feature_detect": "Object detection",
    "ai_feature_attributes": "Attributes",
    "ai_feature_caption": "Scene captions",
    "ai_feature_lpr": "License plates",
    "state_pending": "Awaiting payment",
    "state_active": "Active",
    "state_cancel_pending": "Cancels at period end",
    "state_grace": "Grace period",
    "state_on_hold": "On hold (payment failed)",
    "state_expired": "Expired",
    "state_revoked": "Revoked",
    "state_ended": "Ended",
    "err_generic": "Something went wrong ({{code}})",
    "err_FEATURE_DISABLED": "Continuous recording is coming soon; continuous seats cannot be purchased yet.",
    "coming_soon": "Coming soon",
    "err_STORE_NOT_CONFIGURED": "Payments aren't set up for this brand yet.",
    "err_ALREADY_ENTITLED": "Cloud AI is already subscribed; buy an add-on for more quota.",
    "err_REF_HAS_SEAT": "This device already has a seat. Unassign that seat first.",
    "err_SEAT_ENDED": "This seat has ended.",
    "err_PRODUCT_NOT_PURCHASABLE": "This product can't be bought right now (it may have been updated). Please refresh.",
    "err_BAD_RETURN_URL": "Return URL not allowed.",
    "err_DEVICE_NOT_FOUND": "This device isn't in any of this account's $t(leaf.cur_lc_pl).",
    "err_FORBIDDEN": "You don't have permission to do this.",
    "err_USE_ORG_BILLING": "Seats and AI for team organization $t(leaf.cur_lc_pl) are purchased by the organization.",
    "err_NO_CUSTOMER": "Nothing purchased yet, so there's no payment info to manage.",
    "err_STORE_ERROR": "The payment service is temporarily unavailable. Try again shortly.",
    "rate": "{{kbps}} kbps (last hour)",
    "uplink_title": "Measured upload for continuous recording (last hour, per site):",
    "uplink_home": "{{mbps}} Mbps — make sure the site's upload bandwidth is enough",
    "pick_title": "Whose plan and billing do you want to see?",
    "capsule": "Billed to: {{name}}",
    "home_plan_item": "{{name}} ({{where}})",
    "home_plan_cams_one": "Also recorded to the cloud by a $t(leaf.cur_lc) plan: {{names}}",
    "home_plan_cams_other": "Also recorded to the cloud by $t(leaf.cur_lc) plans ({{count}} cameras): {{names}}",
    "archives": "Long-term evidence retention",
    "archives_help": "Export packages are kept free for 30 days. To keep one longer, choose Keep long-term… on it under Exports & evidence; it's a one-time payment (USD, excluding tax).",
    "archive_size": "Package size",
    "no_archives": "No packages are in long-term retention.",
    "archive_job": "Export",
    "archive_period": "Period",
    "archive_ends": "Kept until",
    "archive_days": "{{n}} days",
    "archive_st_active": "Active",
    "archive_st_pending": "Checkout open",
    "archive_st_expired": "Checkout expired",
    "archive_st_revoked": "Refunded"
  },
  "backup": {
    "title": "Off-site backup",
    "help": "Encrypts NVR recordings and sends them to a NAS or another NVR. Destinations only store encrypted files and never get the keys; coverage means the last point in time that is confirmed delivered and verified.",
    "add_target": "Add destination",
    "new_policy": "New backup policy",
    "targets": "Destinations",
    "no_targets": "No backup destinations yet.",
    "policies": "Backup policies",
    "no_policies": "No backup policies yet.",
    "delete": "Delete",
    "test": "Test connection",
    "test_ok": "Connection OK",
    "test_first": "Test first",
    "save_target": "Register",
    "rotate": "Rotate credentials",
    "rotate_title": "Rotate write credentials for {{name}}",
    "rotate_help": "New credentials are escrowed by the platform and the old ones retired immediately. The destination returns to \"untested\"; test it again.",
    "in_use": "Still used by a policy; revoke the policy first",
    "confirm_delete_target": "Delete destination \"{{name}}\"? Its credentials are retired too.",
    "via_device": "Via Kinio device",
    "quota_used": "{{used}} used of {{quota}} quota",
    "cred_hint": "write {{write}}, read {{read}}",
    "policies_n": "{{n}} policies",
    "cat_ok": "OK",
    "cat_auth": "Authentication failed",
    "cat_network": "Network problem",
    "cat_permission": "Permission denied",
    "cat_space": "Out of space",
    "cat_config": "Configuration error",
    "cat_integrity": "Integrity mismatch",
    "cat_unsupported": "Needs a device to test",
    "cat_unknown": "Unknown error",
    "step_quota": "quota",
    "step_put": "write",
    "step_head": "check",
    "step_get": "read back",
    "step_delete": "delete",
    "kind_nas_s3": "NAS (S3-compatible)",
    "kind_nas_smb": "NAS (SMB)",
    "kind_nas_nfs": "NAS (NFS)",
    "kind_nvr": "Another NVR",
    "kind_help_nas_s3": "Built-in S3 service on Synology / QNAP, or MinIO; on-site or off-site. The NVR pushes ciphertext over the S3 API and verifies checksums.",
    "kind_help_nas_smb": "Same-site LAN only; always accessed through a Kinio device on that site.",
    "kind_help_nas_nfs": "Like SMB: same-site LAN only (Linux / macOS NAS).",
    "kind_help_nvr": "Another Kinio NVR in the same organization (team organization $t(leaf.cur_lc_pl)); both owners must approve, and it must be in a different fault domain.",
    "home": "$t(leaf.cur)",
    "kind": "Type",
    "name": "Name",
    "target_nvr": "Destination NVR",
    "endpoint_s3": "S3 endpoint",
    "endpoint_smb": "SMB path",
    "endpoint_nfs": "NFS path",
    "bucket": "Bucket",
    "prefix": "Prefix",
    "region": "Region",
    "path_style": "Path-style (most NAS need this)",
    "access_path": "How playback reads it",
    "ap_public": "NAS has a public HTTPS endpoint (VMS reads directly)",
    "ap_via_device": "Through another Kinio device on the same site",
    "proxy_device": "Proxy device",
    "quota_gb": "Quota (GB)",
    "quota_help": "A NAS cannot report free space, so the platform enforces this quota; when exceeded, new backups stop and unexpired copies are kept.",
    "credentials": "Credentials",
    "cred_help": "Credentials are sent once and escrowed (encrypted) by the platform; write credentials go only to the source NVR, read credentials only to playback. Use separate write/read keys limited to this bucket / prefix.",
    "separate_read": "Separate read credentials",
    "read_prefix": "Read",
    "username": "Username",
    "password": "Password",
    "access_key": "Access key",
    "secret_key": "Secret key",
    "fault_domain": "Failure domain",
    "fd_site": "Site",
    "fd_facility": "Room / building",
    "fd_power": "Power / UPS",
    "fd_network": "Uplink",
    "fd_help": "Sharing a room or power means the same failure domain (one fire or outage takes both). A different IP is not off-site.",
    "fd_required_nvr": "NVR-to-NVR backup needs site, room, power and uplink on both ends, confirmed on site.",
    "site_confirmed": "Failure domain confirmed on site",
    "wz1": "Source NVR and channels",
    "wz2": "Destination",
    "wz3": "Retention, rate, quota",
    "wz4": "Capacity estimate",
    "wz5": "Failure domain",
    "wz6": "Submit for approval",
    "source_nvr": "Source NVR",
    "no_nvr": "No multi-channel NVR in $t(leaf.cur_lc_pl) you own.",
    "channels": "Channels",
    "stream_main": "Main stream",
    "stream_sub": "Sub stream",
    "target": "Destination",
    "needs_target_approval": "The destination is in another $t(leaf.cur_lc); that $t(leaf.cur_lc)'s owner must approve after you submit.",
    "retention_days": "Retention (days)",
    "rate_limit": "Rate limit (Mbps)",
    "unlimited": "Unlimited",
    "policy_quota": "Policy quota (GB)",
    "auto": "= estimate",
    "estimate": "Estimate",
    "submit": "Submit and approve as source",
    "est_line": "Total {{bps}} × {{days}} days ≈ {{raw}}, plus {{oh}}% overhead and {{margin}}% margin = {{total}}",
    "est_assumed": "{{n}} channel(s) did not report a bitrate; assumed values used (main 2 Mbps, sub 512 kbps).",
    "est_note": "Estimated as full-time recording (upper bound); both uplink and destination writes need this bandwidth continuously.",
    "target_free": "{{free}} still allocatable on the destination",
    "not_offsite": "Not off-site",
    "incoming": "(backup from another $t(leaf.cur_lc))",
    "pst_draft": "Draft",
    "pst_pending_approval": "Pending approval",
    "pst_validating": "Validating",
    "pst_active": "Active",
    "pst_degraded": "Degraded",
    "pst_paused": "Paused",
    "pst_revoked": "Revoked",
    "cov_ok": "Protected",
    "cov_degraded": "Behind > 120 s",
    "cov_not_recording": "Source not recording",
    "cov_partial": "Source unreachable; known front only",
    "cov_unknown": "Unknown",
    "tst_untested": "Untested",
    "tst_ok": "OK",
    "tst_failed": "Test failed",
    "tst_disabled": "Disabled",
    "policy_line": "{{ch}} channels · {{days}} days · quota {{quota}} · rate {{rate}} · v{{v}}",
    "target_view": "Stores the other side's ciphertext only: {{n}} objects, {{bytes}} (no video access)",
    "cov_line": "Slowest channel protected until {{until}} · max lag {{lag}} · pending {{pending}} · {{missing}} gaps",
    "col_channel": "Channel",
    "col_state": "State",
    "col_protected": "Protected until",
    "col_lag": "Lag",
    "col_pending": "Pending",
    "col_missing": "Gaps",
    "col_verified": "Last verified",
    "approve_source": "Approve (source)",
    "approve_target": "Approve (destination)",
    "pause": "Pause",
    "resume": "Resume",
    "revoke": "Revoke",
    "confirm_revoke": "Revoke this policy? New backups stop; stored copies follow their original retention (this does not delete data).",
    "v_name": "Name is required",
    "v_quota": "Quota is required",
    "v_endpoint_s3": "Endpoint must be https://host[:port]",
    "v_bucket": "Invalid bucket name (lowercase letters, digits, dots, hyphens)",
    "v_creds": "Credentials are required",
    "v_proxy": "Choose a proxy device on the same site",
    "v_endpoint_smb": "SMB path must be //host/share",
    "v_endpoint_nfs": "NFS path must be host:/export",
    "v_nvr": "Choose the destination NVR",
    "v_kind": "Invalid type",
    "err_ESCROW_UNAVAILABLE": "Key escrow is not set up in this environment yet, so NAS credentials can't be stored.",
    "err_OWNER_REQUIRED": "Only the $t(leaf.cur_lc) owner can configure off-site backup",
    "err_SOURCE_UNSUPPORTED": "This NVR firmware does not support off-site backup yet",
    "err_TARGET_UNSUPPORTED": "The destination NVR firmware cannot receive backups yet",
    "err_CAPACITY_INSUFFICIENT": "Not enough capacity: {{message}}",
    "err_SAME_FAULT_DOMAIN": "Same failure domain: {{message}}",
    "err_FAULT_DOMAIN_REQUIRED": "{{message}}",
    "err_TARGET_IN_USE": "A policy still uses this destination",
    "err_POLICY_VERSION_MISMATCH": "The policy changed; refresh and approve again",
    "err_VERSION_CONFLICT": "Someone just changed it; refresh",
    "err_PERSONAL_NVR_BACKUP_UNSUPPORTED": "NVR-to-NVR backup is only for team organization $t(leaf.cur_lc_pl)",
    "err_SMB_LAN_ONLY": "SMB is same-site LAN only",
    "err_RATE_LIMIT_TOO_LOW": "{{message}}",
    "restore": "Restore",
    "restore_help": "Writes verified backup copies back to an NVR in this $t(leaf.cur_lc) (the repaired or replacement one). Each segment is verified and the job can be canceled; restored footage still belongs to the original camera, and camera credentials or network settings are not restored.",
    "restore_target": "Restore to NVR",
    "restore_start": "Start restore",
    "restore_line": "Restore to {{nvr}}: {{status}} ({{done}} / {{total}}, {{failed}} failed)",
    "rst_queued": "Queued",
    "rst_running": "Running",
    "rst_done": "Done",
    "rst_failed": "Failed",
    "rst_canceled": "Canceled",
    "from": "From",
    "to": "To",
    "purge": "Purge backup data",
    "confirm_purge": "Delete every copy of this policy on the destination? The policy is revoked as well. The NVR deletes the objects one by one; while the destination is offline they show as pending deletion. This cannot be undone.",
    "rs_deleting": "{{n}} deleting",
    "rs_deletion_pending": "{{n}} pending deletion (destination not confirmed)",
    "rs_deleted": "{{n}} deleted",
    "rs_corrupt": "{{n}} corrupt",
    "rs_lost": "{{n}} lost",
    "err_RESTORE_UNSUPPORTED": "This NVR firmware cannot restore backups yet",
    "err_NOTHING_TO_RESTORE": "No verified copies in this period",
    "need_target": "Add a destination first",
    "no_policies_need_target": "No backup policies yet. Add a destination above first, then create a policy."
  },
  "aiCloud": {
    "title": "Cloud AI",
    "no_subscription": "No Cloud AI subscription yet.",
    "go_billing": "Buy in Plans & billing →",
    "consented": "Consent given",
    "consented_at": "Agreed {{at}}",
    "excluded_help": "Exclude individual cameras (e.g. near bathrooms or private areas): checked cameras are never sent for cloud analysis.",
    "exclude": "Exclude",
    "revoke": "Withdraw consent",
    "revoke_help": "Sending stops within 60 seconds. Existing analyses are kept for the event's retention period.",
    "outdated": "The consent terms have changed. Please read and agree again.",
    "consent_body": "Cloud AI sends frames from the cloud recording around each motion event (the moment of the event and the next 2 seconds, 3 frames) for analysis:\n• Purpose: detect people, vehicles, animals and packages to filter false alarms; (if selected) generate a one-sentence scene description and attributes such as clothing or vehicle, for search.\n• Processors: Kinio's self-hosted object detection model (YOLOX); scene descriptions are generated by Anthropic's Claude.\n• Retention: results are kept with the event (30 days, or the clip's retention if longer); the frames sent are not stored separately.\n• Not done: face recognition or identity inference. Results are suggestions only and never control any device.\n• Only cameras with cloud recording can be analyzed. You can exclude cameras or withdraw at any time.",
    "agree": "I have read and agree to the above",
    "grant": "Agree and enable",
    "grant_help": "You'll be asked to verify your identity.",
    "need_org_admin": "An organization admin must give consent.",
    "need_owner": "The $t(leaf.cur_lc)'s owner must give consent.",
    "badge_confirmed": "Cloud AI confirmed: {{what}}",
    "badge_no_target": "Cloud AI: no person or vehicle",
    "label_person": "person",
    "label_vehicle": "vehicle",
    "label_animal": "animal",
    "label_package": "package",
    "err_CONSENT_TEXT_OUTDATED": "The consent terms changed. Refresh and agree again.",
    "err_NO_CONSENT": "No consent is active.",
    "err_VERSION_CONFLICT": "Someone just changed this; reloaded.",
    "err_USE_ORG_CONSENT": "Cloud AI consent for team organization $t(leaf.cur_lc_pl) is given by an organization admin.",
    "err_FORBIDDEN": "You don't have permission to do this.",
    "pick_subject": "Pick an organization or $t(leaf.cur_lc) to see its cloud AI consent and usage (this switches the scope at the top).",
    "no_subject": "No organization or $t(leaf.cur_lc) in the current scope can subscribe to cloud AI.",
    "consent_summary": "Cloud AI sends frames from the cloud recording at the moment of an event for analysis (people, vehicles, animals, packages; filters false alarms). No face recognition; you can exclude cameras or withdraw at any time.",
    "consent_more": "Read the full terms"
  },
  "dset": {
    "confirm_streams": "This setting affects existing recording and viewing (streams will renegotiate). Change it?",
    "timeout": "The device did not confirm within 25 s",
    "load_offline": "The device is offline or its settings are unavailable",
    "load_error": "Failed to load settings",
    "none": "This device has no settings that can be changed on the web",
    "use_app": "Use the device app",
    "owner_only": "Owner only",
    "pending": "Applying",
    "applied": "Applied",
    "adjusted": "The device applied a different value",
    "failed": "Failed",
    "unknown": "Not reported",
    "streams_title": "This affects existing recording and viewing",
    "streams_body": "Streams will renegotiate; live views and recording pause for a few seconds.",
    "tech_title": "A wrong technical setting can disconnect the device or stop recording",
    "tech_body": "This is an installer / engineering setting. Make sure you know what this value does.",
    "tech_help": "Installer / engineering settings: a wrong value can disconnect the device, stop recording or break regulations. Every change asks for confirmation.",
    "tech_none": "This device has no technical settings",
    "change_body": "Change “{{label}}” to {{value}}",
    "apply_change": "Change “{{label}}”",
    "segment_switch": "Switch to “{{label}}”",
    "depends_on": "Turn on “{{parent}}” first",
    "depends_value": "Available when “{{parent}}” is {{values}}",
    "advanced_n": "Advanced ({{n}})",
    "sections": "Setting sections",
    "val_free": " ({{v}} free)",
    "val_none": "None",
    "val_locked": "Not set",
    "val_unknown": "Unknown",
    "val_never": "Never expires",
    "vendor_fw": "Manufacturer firmware version",
    "auto_apply": "Changes apply to the device right away — there's no Save button.",
    "ch_summary": "{{online}} online / {{total}} channels",
    "ch_summary_label": "Channels",
    "val_on": "On",
    "val_off": "Off",
    "val_present": "Present",
    "val_absent": "None",
    "read_only_section": "This is information reported by the device; it can't be changed here.",
    "ttl_dut_model": "{{label}} ({{model}})",
    "ttl_dut_aid": "AID {{aid}}",
    "ttl_token_set_label": "UART (TTL) key set",
    "ttl_rx_at_label": "UART (TTL) last output",
    "quality_res_named": "{{name}} ({{dims}})"
  },
  "ddev": {
    "not_found": "Device not found, or you do not have access.",
    "back": "Back to devices",
    "tab_overview": "Overview",
    "tab_live": "Live & playback",
    "tab_channels": "Channels",
    "tab_settings": "Settings",
    "tab_recording": "Recording & storage",
    "tab_events": "Events",
    "tab_health": "Health & firmware",
    "tab_links": "Links",
    "status": "Status",
    "media_status": "Media status",
    "capabilities": "Capabilities",
    "storage": "Storage",
    "no_events": "No events in the last 24 hours",
    "links_hint": "Link this sensor to cameras: event cards and pop-ups show the linked cameras at the same moment.",
    "tab_site": "Site devices",
    "tab_ai": "AI",
    "tab_firmware": "Firmware",
    "tab_location": "Position",
    "tab_audit": "Audit",
    "ai_unavailable": "AI compute info is unavailable",
    "ai_none": "This camera isn't assigned to AI analytics yet",
    "ai_open": "Open AI analytics",
    "fw_unavailable": "Firmware status unavailable (or this device is not updated by the platform)",
    "fw_available": "Update available",
    "fw_latest": "Up to date",
    "fw_auto": "Auto update",
    "fw_update_now": "Update now",
    "fw_confirm": "Update firmware to {{v}} now? The device restarts during the update.",
    "fw_started": "Update sent. The device restarts after downloading",
    "fw_via_app": "This device is updated through the app. Finish it in the app",
    "site": "Site",
    "geo": "Map coordinates",
    "floorplan": "Floor plan",
    "open_map": "Open map",
    "tab_analytics": "Analytics",
    "tab_technical": "Technical",
    "tab_nodes": "Nodes",
    "tab_advanced": "Advanced",
    "maintenance": "Maintenance",
    "open_playback": "Open in playback",
    "last_seen": "last seen",
    "fw_short": "Firmware {{v}}",
    "fw_has_update": " (update available)",
    "fw_is_latest": " (latest)",
    "fw_all": "Firmware for all devices →",
    "path": "Position",
    "reboot_hint": "The device goes offline for about 1–2 minutes and does not record meanwhile.",
    "support_title": "Copy for support",
    "support_hint": "Copy this when support asks for it; these codes are not shown elsewhere.",
    "support_copy": "Copy",
    "support_copied": "Copied",
    "ai_provider_unnamed": "Unnamed AI device",
    "maintenance_sub": "Restart, unbind",
    "rec_settings": "Recording and storage settings",
    "ch_summary_one": "{{count}} channel",
    "ch_summary_other": "{{count}} channels",
    "ch_summary_off_one": "{{count}} offline",
    "ch_summary_off_other": "{{count}} offline",
    "ch_view": "View channels",
    "adv_diag": "Diagnostics",
    "adv_diag_sub": "Serial console terminal, for installers and developers",
    "adv_diag_dut": "connected to {{name}}",
    "ev_recording": "Recording clips",
    "ev_open_in_events": "Open in Events",
    "ev_only_recording": "Only recording clips in the last 24 hours, no events. Turn on “Recording clips” to see them.",
    "sd_no_capacity": "SD card · capacity unknown (the device didn't report it)",
    "sd_no_capacity_tip": "An SD card is inserted but the device hasn't reported its capacity; see Recording & storage for recording status.",
    "no_snapshot": "No snapshot yet",
    "watch_live": "Watch live",
    "rec_settings_fold_one": "Recording & storage settings ({{count}})",
    "rec_settings_fold_other": "Recording & storage settings ({{count}})",
    "ev_system_hint": "\"System\" rows are the device's own state changes (online / offline, restarts, streaming or recording start / end), not detections; usually nothing to do. These status records are listed only here and are not in the Events page search or counts (so its \"System\" count may be lower).",
    "ev_system_generic": "Device state change",
    "recent_events": "Recent events",
    "recent_none": "No events in the last 7 days.",
    "recent_all": "All events for this camera ▸",
    "ev_lasted": "(lasted {{dur}})",
    "ev_window": "Last 24 hours",
    "change_wifi": "Change Wi-Fi",
    "change_wifi_app": "Use the phone app to change it: with your phone next to the device, the app hands over the new Wi-Fi by Bluetooth or the device's hotspot."
  },
  "health": {
    "title": "Health",
    "level_ok": "OK",
    "level_warn": "Warning",
    "level_alert": "Fault",
    "level_unknown": "Not reported",
    "free": "free",
    "retention_days_one": "about {{count}} day of retention",
    "retention_days_other": "about {{count}} days of retention",
    "reason_smart": "SMART failure",
    "reason_disk_error": "disk error",
    "reason_disk_full": "disk full",
    "reason_no_disk": "no disk detected",
    "reason_almost_full": "less than 5% free (overwrite off)",
    "rate": "Current recording rate {{kbps}} kbps",
    "no_rate": "The device does not report its recording rate, so retention cannot be estimated",
    "disk_model": "Model / serial",
    "disk_state": "State",
    "capacity": "Free / total",
    "no_disks": "The device does not report individual disks",
    "online_rate": "Devices online",
    "recorders": "Recorders",
    "recorders_bad": "faulty / total",
    "min_retention": "Shortest retention",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "offline_list": "Offline devices ({{n}})",
    "smart_ok": "OK",
    "smart_warn": "Warning",
    "smart_fail": "Failing",
    "smart_unknown": "Unknown",
    "smart_temp": "{{c}} °C",
    "smart_poh": "{{h}} power-on hours",
    "smart_sectors": "Sectors — reallocated {{realloc}}, pending {{pending}}, uncorrectable {{uncorr}}",
    "smart_test_run": "Self-test",
    "smart_test_sent": "Self-test started (about 2 minutes)",
    "smart_test_running": "Self-test running",
    "smart_test_pass": "Last self-test: passed",
    "smart_test_fail": "Last self-test: failed",
    "smart_test_aborted": "Last self-test: aborted",
    "smart_test_weekly": "weekly automatic",
    "reason_smart_warn": "SMART warning",
    "overwrite": "Recording overwrite",
    "overwrite_auto": "Auto overwrite",
    "overwrite_off": "No overwrite (recording stops when full)",
    "overwrite_days_one": "Keep {{count}} day",
    "overwrite_days_other": "Keep {{count}} days",
    "rec_space": "Recording space",
    "disk_space": "Disk space",
    "kind_hdd": "HDD",
    "kind_ssd": "SSD",
    "kind_sd": "SD card",
    "kind_usb": "USB",
    "kind_flash": "Built-in flash",
    "kind_disk": "Disk",
    "disks_title": "Physical disks",
    "volume_title": "Recording volume",
    "legacy_note": "This device reports its recording volume (older format), without per-disk or storage pool details",
    "disk_kind": "Type",
    "disk_record": "Recording disk",
    "record_yes": "Yes",
    "record_no": "No",
    "physical_capacity": "Disk capacity",
    "pools_title": "Storage pools",
    "no_pools": "The device does not report storage pools",
    "pool_role": "Purpose",
    "role_record": "Recording",
    "role_system": "System",
    "role_index": "Index",
    "pool_disk": "Disk",
    "pool_part": "Partition",
    "pool_capacity": "Capacity",
    "pool_used": "Usage",
    "pool_in_use": "In use",
    "pool_idle": "Not in use yet",
    "retention_basis": "Retention is estimated from the {{total}} recording space, not the physical disk capacity",
    "cert": "Certificates expiring",
    "cert_note_one": "Expired or expiring within {{count}} day",
    "cert_note_other": "Expired or expiring within {{count}} days",
    "cert_expired": "Certificate expired ({{date}})",
    "cert_soon": "Certificate expires {{date}}",
    "firmware": "Firmware compliance",
    "firmware_note": "Up to date / all",
    "fw_update": "Firmware update available (now {{v}})",
    "seats": "Cloud recording seats",
    "seats_note": "Assigned / active",
    "ai": "AI quota (this month)",
    "backup": "Backup coverage",
    "backup_note": "Healthy / active policies",
    "backup_degraded": "{{n}} policies behind or stopped",
    "rec_gaps": "Recording gaps (24 h)",
    "rec_gaps_note": "With gaps / continuous-recording cameras",
    "rec_gap_item": "Recording gaps in the last 24 hours",
    "attention": "Needs attention",
    "not_enabled": "Not set up",
    "setup": "Set up",
    "unknown": "Unavailable",
    "unknown_n_one": "Unavailable ({{count}} device not reporting)",
    "unknown_n_other": "Unavailable ({{count}} devices not reporting)",
    "dstate_normal": "Normal",
    "dstate_ok": "Normal",
    "dstate_degraded": "Degraded",
    "dstate_error": "Error",
    "dstate_failed": "Failed",
    "dstate_missing": "Missing",
    "dstate_readonly": "Read-only",
    "dstate_full": "Full",
    "dstate_unformatted": "Not formatted",
    "seats_home_plan_one": "{{count}} more camera recorded by a $t(leaf.cur_lc) plan",
    "seats_home_plan_other": "{{count}} more cameras recorded by $t(leaf.cur_lc) plans",
    "watch_playback": "Open playback",
    "rec_gaps_off": "Only checks cameras with continuous cloud recording; there are none",
    "space_unknown": "Capacity not reported",
    "usb_stick": "USB flash drive",
    "cap_used_total_free": "{{used}} used of {{total}} ({{free}} free)",
    "cap_total": "{{total}} total",
    "reason_other": "Storage problem",
    "reason_sd_abnormal": "Memory card error",
    "reason_sd_no_space": "Memory card full; recording stopped",
    "reason_sd_needs_format": "Memory card needs formatting",
    "days_lt1": "under 1 day (about {{h}} h)",
    "retention_lt1": "under 1 day of retention (about {{h}} h)",
    "sd_looping": "{{total}} · Loop recording",
    "sd_looping_note": "When the card is full, the oldest recordings are overwritten automatically. Recording doesn’t stop.",
    "rec_gaps_off2": "No cameras with continuous cloud recording or local recording",
    "rec_gaps_note2": "Last 24 h · cloud {{cloud}}, local {{local}}",
    "gap_reason_source_unreachable": "no video",
    "gap_reason_storage_full": "disk full",
    "gap_reason_storage_error": "recording disk error",
    "gap_reason_recorder_restart": "recorder restarted",
    "gap_reason_unknown": "unknown cause",
    "rec_gaps_unreported_one": "{{count}} local channel not reporting",
    "rec_gaps_unreported_other": "{{count}} local channels not reporting"
  },
  "rpol": {
    "enable_cloud": "Enable cloud recording",
    "enable_sd": "Enable memory card recording",
    "confirm_cloud": "Enabling cloud recording will turn off memory card recording. Future recordings will only upload to the cloud (a memory card, if present, will still buffer recordings while offline).",
    "confirm_sd": "Enabling memory card recording will turn off cloud recording. Future recordings will only be stored on the memory card.",
    "confirm_sd_seat": " This camera has an assigned cloud seat. After cloud recording is turned off, the seat will be idle but still billed. You can reassign it on the Plans page.",
    "no_recording": "Currently not recording",
    "device_mode": "Device",
    "mode_continuous": "Around the clock",
    "mode_event": "Only on activity",
    "mode_unknown": "Not reported",
    "cloud": "Cloud recording",
    "cloud_on": "Active ({{mode}})",
    "cloud_off": "Not active",
    "retention": "Cloud retention",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "follows_plan": "set by plan / seat",
    "owner_only": "Only the $t(leaf.cur_lc) owner can change the recording policy.",
    "mode_scheduled": "Scheduled",
    "mode_off": "Off",
    "cloud_policy_note": "Cloud around-the-clock recording is on, so this device also records all day. Turning off cloud recording returns it to this schedule.",
    "cloud_mode": "When to record to the cloud",
    "continuous_coming_soon": "Continuous recording is coming soon",
    "err_FEATURE_DISABLED": "Continuous recording is coming soon; only event recording is available for now.",
    "capplied_applied": "applied on the device",
    "capplied_not_applied": "not yet applied on the device",
    "capplied_unknown": "waiting for the device to report",
    "capplied_days_one": "(device keeps {{count}} day)",
    "capplied_days_other": "(device keeps {{count}} days)",
    "src_seat": "Provided by a cloud recording seat of \"{{name}}\"",
    "src_seat_plain": "Provided by a cloud recording seat",
    "src_home_plan": "Provided by the $t(leaf.cur_lc) plan \"{{plan}}\"",
    "src_home_plan_plain": "Provided by the $t(leaf.cur_lc) plan",
    "src_grant": "Provided by the contract \"{{plan}}\"",
    "src_grant_plain": "Provided by a contract",
    "src_until": ", until {{date}}",
    "src_exempt": "No plan applied (development exemption)",
    "src_none": "No cloud recording seat assigned",
    "assign_seat": "Assign seat",
    "cloud_on_exempt": "Recording ({{mode}}) · no plan applied (development exemption)",
    "cloud_on_plain": "Active",
    "cloud_unsupported": "This camera doesn't support cloud recording (model limitation)",
    "reason_not_supported": "This camera doesn't support cloud recording (model limitation)",
    "reason_plan_no_cloud": "The $t(leaf.cur_lc)'s plan doesn't include cloud recording",
    "reason_home_disabled": "Cloud recording is paused for this $t(leaf.cur_lc) (contact your provider)",
    "reason_disabled": "Cloud recording is turned off for this camera",
    "reason_mode_not_in_plan": "The selected mode isn't in the plan; event recording is used instead",
    "reason_camera_limit": "The plan's camera limit is reached",
    "reason_continuous_paused": "Continuous recording is coming soon; event recording is used for now",
    "reason_other": "Cloud recording isn't active right now",
    "col_where": "Where",
    "col_when": "When",
    "where_sd": "Memory card",
    "where_recorder": "Recorder",
    "cloud_switch": "On",
    "status_label": "Status:",
    "platform_state": "platform: {{state}}"
  },
  "evd": {
    "watch_recording": "Watch recording",
    "sd_offline": "This recording is on the camera’s memory card. You can watch it when the camera reconnects.",
    "no_recording": "There was no recording when this event occurred",
    "open": "Details",
    "back": "Back to events",
    "time": "Time",
    "class": "Class",
    "device": "Device",
    "ai": "AI analysis",
    "phase_started": "Started",
    "phase_ended": "Ended",
    "phase_instant": "Instant",
    "fields": "Raw fields",
    "clip": "Clip around the event",
    "no_cloud_clip": "No cloud clip for this time; open Playback to view local recordings.",
    "open_playback": "Open in Playback",
    "related": "Linked cameras (same moment)",
    "cycle": "Start and end of this event",
    "not_found": "This event can't be found. It may be past its retention period or deleted.",
    "back_list": "Back to events",
    "looking": "Loading this event…",
    "cycle_dur": "This {{name}} lasted {{dur}}",
    "cycle_open": "This {{name}} hasn't ended yet (or the end record hasn't arrived)",
    "cycle_no_end": "Not ended",
    "cycle_this": "This record",
    "dur_s": "{{s}} s",
    "dur_ms": "{{m}} min {{s}} s",
    "dur_hm": "{{h}} h {{m}} min",
    "clip_suspect": "This cloud clip may be incomplete (its length doesn't match the event); the picture may be green or frozen. Only the 30 seconds around the event are played. Try another source on the Playback page.",
    "clip_suspect_local": "Watch {{src}} instead",
    "cycle_no_end_record": "No end record was received for this {{name}} (more than 10 minutes since it started); duration unknown",
    "cycle_end_only": "This is the end record of {{name}}; its start is not within 15 minutes before or after",
    "cycle_open_start": "Open the start record ▸",
    "clip_checking": "Checking for a cloud clip at this time…",
    "clip_unreadable": "Couldn’t load this clip.",
    "dur_lt1": "under 1 s"
  },
  "unbind": {
    "title": "Unbind device",
    "explain": "Remove this device from the $t(leaf.cur_lc).",
    "reset": "The device receives a reset command and returns to pairing mode (if offline, it resets on next connection).",
    "history": "Past recordings and events stay with this $t(leaf.cur_lc); they do not move with the device.",
    "children_one": "{{count}} channel / child device is removed as well.",
    "children_other": "{{count}} channels / child devices are removed as well.",
    "button": "Unbind",
    "confirm": "Unbind “{{name}}”? Type the last 4 characters of the device ID “{{code}}” to confirm.",
    "type_code": "Last 4 characters of the device ID"
  },
  "pair": {
    "open": "Add device",
    "title": "Add a Kinio device",
    "no_home": "You have no $t(leaf.cur_lc) where you can add devices (owner or admin required).",
    "method": "Pairing method",
    "method_lan": "Wired (enter a pairing code): NVR, Kinio Station or AI box — enter the code on its own screen",
    "method_qr": "Scan a QR code: the camera lens scans the Wi-Fi and pairing code shown on this page",
    "method_app": "Bluetooth or device hotspot (with the phone app): the app scans this QR, then the device label",
    "aid_hint": "On the label under the device, or under \"Device info\" on the NVR screen; format CNV-XXXXXXXXXXXXXXXX-X",
    "err_BAD_DEVICE_REF": "Invalid device ID format",
    "err_MODEL_NOT_AVAILABLE_FOR_BRAND": "Kinio Station / Kinio Node isn't available for this brand",
    "start": "Get pairing code",
    "bound": "{{aid}} has been added to the $t(leaf.cur_lc).",
    "open_device": "Open device",
    "status_failed": "Pairing failed",
    "status_canceled": "Canceled",
    "status_expired": "The pairing code has expired",
    "status_pending": "Waiting for the device",
    "status_connected": "Device connected, finishing binding",
    "again": "Pair again",
    "enter_on_device": "Enter this pairing code on the device’s “Cloud pairing” screen:",
    "code": "Pairing code",
    "url": "Redeem URL",
    "expires_in": "expires in {{m}}:{{s}}",
    "cancel": "Cancel pairing",
    "method_app_unavailable": "(this brand has no app portal, so no app link can be made)",
    "wifi_ssid": "Wi-Fi name",
    "wifi_psk": "Wi-Fi password (leave empty for an open network)",
    "wifi_note": "The Wi-Fi password only goes into the QR on this page; it is not sent to the cloud or stored.",
    "err_SSID_REQUIRED": "Enter the Wi-Fi name",
    "err_SSID_TOO_LONG": "The Wi-Fi name is longer than 32 bytes",
    "err_PSK_LENGTH": "The Wi-Fi password must be 8–63 characters (or 64 hex digits)",
    "err_BAD_SESSION": "Pairing data is incomplete; start again",
    "show_qr": "Show QR",
    "show_qr_again": "Show QR again",
    "hide_qr": "Hide QR",
    "qr_hidden": "The QR is hidden (it hides itself 5 minutes after being shown).",
    "qr_auto_hide": "hides in {{m}}:{{s}}",
    "scan_with_camera": "Put the camera in pairing mode and hold the QR 20–40 cm from the lens; after the beep, wait for it to connect.",
    "scan_with_app": "Scan this QR with “Add device” in the mobile app, then scan the device label when asked. The app user does not need to be a member of this $t(leaf.cur_lc).",
    "qr_alt_kwf": "Wi-Fi and pairing code QR for the camera",
    "qr_alt_app": "Pairing link QR for the app",
    "kind_camera": "Camera",
    "kind_doorbell": "Doorbell",
    "kind_nvr": "NVR",
    "kind_station": "Station",
    "kind_sensor": "Sensor",
    "kind_light": "Light",
    "kind_lock": "Lock",
    "kind_plug": "Plug",
    "kind_frame": "Frame",
    "kind_other": "Device",
    "bound_name_title": "Added to the $t(leaf.cur_lc). Give this device a name",
    "name_label": "Device name",
    "name_hint": "Notifications, the app and VMS show this name (1–32 characters). Skip to use the suggested name.",
    "err_INVALID_NAME": "Names are 1–32 characters with no control characters",
    "name_failed": "The name wasn't saved. Please try again",
    "name_forbidden": "You can't rename this device ($t(leaf.cur_lc) owner or admin only). Ask them to rename it later.",
    "name_skip": "Skip",
    "name_save": "Save name",
    "aid_label": "Device number",
    "aid_demo_title": "\"Device number\" on the label"
  },
  "layouts": {
    "pick": "Layouts…",
    "save": "Save layout",
    "save_as": "Save as",
    "delete": "Delete layout",
    "delete_confirm": "Delete layout “{{name}}”?",
    "name": "Name",
    "scope": "Visible to",
    "scope_user": "Only me",
    "scope_org": "Shared with {{org}}",
    "denied_dropped": "Cells you cannot view are not saved in the new layout.",
    "no_permission": "No permission",
    "err_CELL_FORBIDDEN": "A cell contains a camera you cannot view",
    "err_VERSION_CONFLICT": "Someone else changed this layout; reload it",
    "none": "No saved layouts yet",
    "manage": "Manage layouts…"
  },
  "bm": {
    "add": "Bookmark",
    "need_time": "Play or pick a time first",
    "title": "Title",
    "note": "Note",
    "length": "Length",
    "len_s": "{{n}} s",
    "len_point": "Point in time",
    "visibility": "Visible to",
    "vis_private": "Only me",
    "vis_home": "$t(leaf.cur) members",
    "list": "Bookmarks"
  },
  "subg": {
    "panel_hint": "{{n}} joined (limit {{max}}). Sub-devices with a QR label can only join by scanning it.",
    "region": "Region {{r}}",
    "add": "Add sub-device",
    "need_admin": "Adding sub-devices requires a $t(leaf.cur_lc) owner or admin.",
    "none": "No sub-devices yet.",
    "col_slot": "Slot",
    "col_mode": "Joined via",
    "mode_qr": "QR allowlist",
    "mode_permit": "Open window (unauthenticated)",
    "title": "Add sub-device",
    "method": "How to add",
    "method_scan": "Scan the QR on the sub-device with the camera",
    "method_manual": "Enter manually (QR text or EUI + install code)",
    "method_permit": "Sub-devices without a QR: open a join window",
    "qr_text": "QR text",
    "or_fields": "Or enter the EUI and install code from the label:",
    "is_code": "Install code (IS)",
    "is_hint": "26 characters (A–Z, 2–7), printed next to the QR on the label.",
    "smartstart": "SmartStart: the sub-device joins as soon as it powers up (24-hour window)",
    "permit_explain": "The gateway opens for 120 seconds; press the pairing button on the sub-device. Only for sub-devices without a QR; scan the QR for labelled ones.",
    "permit_warn": "This path has no install-code authentication: it stops passive eavesdropping but not active impersonation.",
    "start": "Start",
    "permit_start": "Open for 120 s",
    "wait_qr": "The gateway has allowlisted {{eui}}. Hold the button on the sub-device for 5 seconds (or insert its batteries).",
    "wait_qr_smart": "The gateway has allowlisted {{eui}} (SmartStart). The sub-device will join when it powers up.",
    "wait_permit": "The gateway is open for joining. Press the pairing button on the sub-device without a QR.",
    "left": "{{m}}:{{s}} left",
    "closed_found": "The join window is closed; {{n}} joined this time.",
    "closed_none": "The join window is closed and no sub-device joined. Keep it near the gateway, hold its button for 5 seconds and try again.",
    "stop": "Stop",
    "again": "Add another",
    "joined": "New sub-device: CH{{slot}}",
    "name_for": "Name for CH{{slot}}",
    "location": "Position (site)",
    "location_keep": "(not set)",
    "location_personal": "This $t(leaf.cur_lc)'s organization has a single site, so no location is needed; you can place it on the map page.",
    "to_map": "Open map",
    "saved": "Saved \"{{name}}\"",
    "scan_unsupported": "This browser cannot scan with the camera (use Chrome / Edge); enter the code manually instead.",
    "scan_denied": "The camera is unavailable (no permission or no camera); enter the code manually instead.",
    "scan_hint": "Point the camera at the QR on the sub-device.",
    "scan_start": "Turn on camera",
    "err_other": "Could not add ({{code}})",
    "err_qr_not_subg": "This is not a Kinio sub-device QR (it must start with KSG:1).",
    "err_qr_version": "This QR version is not supported.",
    "err_qr_format": "The QR text is malformed.",
    "err_qr_eui": "The EUI must be 16 hex characters.",
    "err_qr_is": "The install code is invalid (26 characters, A–Z and 2–7).",
    "err_INVALID_QR": "The QR text or install code is invalid.",
    "err_QR_DEVICE_NOT_ALLOWED": "Sub-devices with a QR label cannot use the open window; scan the QR.",
    "err_CAPABILITY_NOT_SUPPORTED": "This device cannot take sub-devices.",
    "err_GATEWAY_OFFLINE": "The gateway is offline.",
    "err_GATEWAY_TIMEOUT": "The gateway did not respond.",
    "err_GATEWAY_ERROR": "The gateway refused (allowlist full or busy); try again later.",
    "err_FORBIDDEN": "Not allowed.",
    "err_INVALID_NAME": "The name must be 1–64 characters.",
    "remove": "Remove",
    "removing": "Removing (waiting for the gateway)",
    "remove_confirm": "Remove \"{{name}}\"? It is unpaired the next time it reports; scan its QR again to add it back."
  },
  "inbox": {
    "title": "Notifications",
    "title_n": "Notifications ({{n}} unread)",
    "mark_all": "Mark all as read",
    "mark_read": "Mark as read",
    "empty": "No notifications",
    "failed": "Notification inbox is temporarily unavailable",
    "mfa_alarm_title": "Alert from {{from}}",
    "mfa_alarm_body": "Turn on two-step verification and sign in again to view it.",
    "mfa_alarm_back": "I've set it up — back to this alert",
    "mfa_alarm_someone": "the delegating organization",
    "alarm_title": "Alarm · {{name}}",
    "untitled": "Notification",
    "view": "View",
    "open": "Open",
    "dismiss_tip": "Dismiss (stays unread)",
    "more_n_one": "{{count}} more notification",
    "more_n_other": "{{count}} more notifications",
    "bell_tip": "{{n}} unread notifications (not the same as the unhandled alarm count next to Events & alarms)",
    "times_n": "× {{n}} (first {{since}})",
    "times_only": "× {{n}}",
    "empty_alarms": "No new notifications; {{count}} alarms still need handling.",
    "go_alarms": "Handle"
  },
  "devpolicy": {
    "title": "MyCam device and AI policy",
    "hint": "Applies to phone cameras and computer recorders at every site in this organization. Each item saves when changed (re-verification required).",
    "k_soft_device_require_attestation": "Only accept devices that pass integrity checks (verified)",
    "k_soft_device_lock_settings": "Lock settings (phone users cannot change locked settings)",
    "k_soft_device_allow_audio_record": "Allow audio recording",
    "k_ai_byo_cloud_allowed": "Allow bring-your-own cloud AI",
    "k_soft_device_allow_personal_account": "Allow personal accounts to add devices",
    "by_platform": "Checked by the platform at activation",
    "by_app": "Enforced by the MyCam app",
    "by_pending": "Whether members can use a personal phone as this organization's MyCam device is not decided yet, so it cannot be changed"
  },
  "dhealth": {
    "cert": "Certificate expiry",
    "cert_expired": "Expired",
    "cert_soon": "Expires within 30 days",
    "wifi": "Wi-Fi signal",
    "temperature": "Device temperature",
    "mac": "MAC address",
    "netifs": "Network interfaces",
    "if_name": "Interface",
    "if_kind": "Type",
    "if_kind_wifi": "Wi-Fi",
    "if_kind_wired": "Wired",
    "if_kind_cellular": "Cellular",
    "if_up": "Link",
    "if_up_yes": "Up",
    "if_up_no": "Down"
  },
  "tour": {
    "open": "Tour",
    "title": "Tour settings",
    "interval": "Time per page",
    "seconds": "{{n}} s",
    "mode": "Tour through",
    "mode_cameras": "Camera list",
    "mode_layouts": "Layouts",
    "cameras_hint": "Paged by the current {{size}} cells: {{pages}} pages",
    "no_layouts": "No saved layouts yet",
    "start": "Start tour",
    "running": "Touring: page {{i}} / {{n}}",
    "next_in": "next in {{s}} s",
    "pause": "Pause",
    "resume": "Resume",
    "stop": "Stop"
  },
  "nset": {
    "global_title": "My notifications",
    "home_title": "$t(leaf.cur) notifications",
    "home": "$t(leaf.cur)",
    "no_home": "No $t(leaf.cur_lc) to configure notifications for",
    "unavailable": "Notification settings are unavailable",
    "quiet": "Quiet hours",
    "quiet_start": "Start",
    "quiet_end": "End",
    "quiet_clear": "Turn off quiet hours",
    "quiet_hint": "Time zone {{tz}}; during quiet hours only the inbox gets them, alarms still go out",
    "email_alerts": "Also email event notifications",
    "hide_details": "Hide details on the lock screen",
    "thumbnails": "Include thumbnails",
    "category": "Category",
    "ch_inbox": "Inbox",
    "ch_push": "App push",
    "ch_email": "Email",
    "forced": "Always on",
    "per_device": "Detection notifications per camera",
    "follow_home": "Follow $t(leaf.cur_lc) setting",
    "cat": {
      "security_alarm": "Alarms (while armed)",
      "device_detection": "Detections (people, vehicles, motion…)",
      "device_doorbell": "Doorbell",
      "device_call": "Device calls",
      "device_status": "Device status (offline, storage, recording, backup)",
      "device_ota": "Firmware updates",
      "security_mode": "Arm / disarm changes",
      "home_access": "$t(leaf.cur) members and devices",
      "account_security": "Account security",
      "billing_subscription": "Subscription and billing",
      "support_reply": "Support replies",
      "care_service": "Care reminders",
      "andrew_insight": "AI assistant tips and reminders",
      "automation_notify": "Automation rules",
      "hw_review": "Hardware review",
      "org_notice": "Organization notices",
      "account_privacy": "Privacy and data requests",
      "sleep_report_ready": "Sleep report"
    },
    "ai_confirmed_only": "Only notify detections confirmed by cloud AI (when the camera uses cloud AI; sent anyway after 60 s without a result)",
    "cat_other": "Other notifications",
    "part_local": "Pop-ups (this computer)",
    "part_receive": "What I get notified about",
    "part_subs": "Subscribed sites and groups",
    "float_intro": "Floating notifications appear bottom-right. Alarms always use the alarm card (snapshot first, handle it in place, press Watch live to open video); other notifications follow the level below. Each one pops once and collapses to a thin bar after 20 seconds without interaction."
  },
  "rules": {
    "no_home": "No $t(leaf.cur_lc) to set up rules for",
    "home": "$t(leaf.cur)",
    "unavailable": "Rules are unavailable",
    "from_template": "From template",
    "new_json": "Advanced: edit as JSON",
    "enabled": "Enabled",
    "kind_automation": "Automation",
    "kind_scene": "Scene",
    "placement_cloud": "Runs in the cloud",
    "placement_local": "Runs locally",
    "pending_sync": "Not synced to device yet",
    "never": "Never run",
    "result_ok": "Last run OK",
    "result_failed": "Last run failed",
    "result_skipped": "Last run skipped",
    "fires": "{{n}} runs",
    "run": "Run",
    "runs": "Run log",
    "edit": "Edit",
    "delete": "Delete",
    "delete_confirm": "Delete rule \"{{name}}\"?",
    "last_error": "Action {{n}} failed: {{reason}}",
    "runs_local": "Local rules keep their log on the device; only the last result is shown here",
    "run_time": "Time",
    "run_trigger": "Trigger",
    "run_status": "Result",
    "run_error": "Failure reason",
    "trigger_manual": "Manual",
    "run_error_at": "Action {{n}}: {{reason}}",
    "runs_empty": "No runs in 7 days",
    "status_pending": "Pending",
    "status_running": "Running",
    "status_done": "Done",
    "status_failed": "Failed",
    "status_canceled": "Canceled",
    "reason_device_offline": "Device offline",
    "reason_running": "Previous run still going",
    "reason_forbidden": "Not permitted",
    "template": "Template",
    "tpl_door_record_notify": "Door opens → record + notify",
    "tpl_door_record_notify_text": "A door was opened",
    "tpl_door_record_notify_hint": "When a door/window sensor opens, the linked camera records and a notification is sent (pop-ups are set in the device Links tab)",
    "tpl_armed_pir_siren": "Armed PIR → siren + notify",
    "tpl_armed_pir_siren_text": "Motion while armed",
    "tpl_armed_pir_siren_hint": "When armed Away / Night and the PIR triggers: sound the siren and notify",
    "tpl_ai_person_notify": "AI detects a person → notify",
    "tpl_ai_person_notify_text": "Person detected",
    "tpl_ai_person_notify_hint": "Notify when the camera AI detects a person",
    "role_sensor": "Sensor",
    "role_camera": "Camera",
    "role_siren": "Siren",
    "optional": "(optional)",
    "pick": "Select",
    "none_capable": "No suitable device in this $t(leaf.cur_lc)",
    "name": "Name",
    "notify_text": "Notification text",
    "notify_off": "Rule notifications aren't offered in this environment; the template only creates device actions",
    "create": "Create",
    "edit_title": "Edit \"{{name}}\"",
    "json_hint": "A rule has three parts: triggers, conditions and actions. The format is checked before saving; the system decides whether the rule runs on the device or in the cloud.",
    "json": "Rule JSON",
    "bad_json": "Invalid JSON",
    "valid": "Valid: {{placement}}",
    "validate": "Validate",
    "err_RULE_INVALID": "The rule is invalid; see the problems",
    "err_RULE_RUNNING": "The previous run is still going",
    "err_RULE_DISABLED": "The rule is disabled",
    "err_VERSION_CONFLICT": "Someone just changed it; reopen and try again",
    "handoff_old_device": "the previous device",
    "handoff_pending": "Handing over: {{to}} takes over after {{from}} comes online and stops the old version",
    "handoff_disabled": "Disabled (takes effect when {{from}} comes back online)",
    "handoff_deleting": "Deleting (stops when {{from}} comes back online)",
    "shared_devices_note": "Devices shared with you can’t be used in automations",
    "err_RULE_HANDOFF_PENDING": "This rule is being handed over; it can run once the old device comes online and stops the old version",
    "handoff_cloud": "the cloud",
    "more": "More rule actions",
    "empty_intro": "No rules yet. Rules let devices react on their own — record and notify you when a door opens, sound the siren when someone shows up while armed. Start from a template:",
    "use_template": "Use this template",
    "tpl_door_record_notify_needs": "Needs a door/window sensor — this $t(leaf.cur_lc) doesn't have one yet",
    "tpl_armed_pir_siren_needs": "Needs a motion (PIR) sensor — this $t(leaf.cur_lc) doesn't have one yet",
    "tpl_ai_person_notify_needs": "Needs a camera with person detection — this $t(leaf.cur_lc) doesn't have one yet",
    "reason_other": "no reason given",
    "tpl_cannot_create": "{{what}}, so this can't be created yet. Add the needed device under Devices first, or pick another template.",
    "tpl_pick_first": "Choose a {{what}} first"
  },
  "armed": {
    "label": "Arming mode",
    "home": "Home",
    "night": "Night",
    "away": "Away",
    "unsynced_one": "{{count}} device not synced yet (sent when it comes online)",
    "unsynced_other": "{{count}} devices not synced yet (sent when they come online)"
  },
  "dctl": {
    "siren_on": "🔔 Sound siren",
    "siren_off": "Stop siren",
    "light_on": "💡 Floodlight on",
    "light_off": "Floodlight off",
    "reboot": "Restart",
    "reboot_confirm": "Restart \"{{name}}\"? It goes offline for a minute or two.",
    "sent": "Sent",
    "err_FORBIDDEN": "Not permitted",
    "err_DEVICE_OFFLINE": "Device offline",
    "err_DEVICE_WAKING": "Device is waking up, try again shortly",
    "err_DEVICE_ASLEEP": "Device is asleep",
    "err_COMMAND_TIMEOUT": "Device did not respond in time",
    "err_RENEW_ONLY": "Device certificate expired; it only accepts renewal",
    "siren_confirm": "Sound {{name}}'s siren for 30 seconds?",
    "siren_confirm_body": "The siren will sound on site. Press Stop siren to end it early.",
    "siren_action": "Sound siren",
    "more": "More"
  },
  "alarm": {
    "section": "Alarm handling",
    "state_open": "Unhandled",
    "state_acknowledged": "Seen",
    "state_claimed": "In progress",
    "state_resolved": "Resolved",
    "state_false_alarm": "False alarm",
    "act_acknowledged": "Seen",
    "act_claimed": "I'll handle it",
    "act_take_over": "Take over",
    "act_resolved": "Resolved",
    "act_false_alarm": "False alarm",
    "act_open": "Reopen",
    "claimed_by": "{{name}} is handling",
    "claimed_by_me": "You are handling",
    "someone": "Someone",
    "note_btn": "Note",
    "note_label": "Note",
    "note_placeholder": "Note (one line, up to {{max}} characters)",
    "note_invalid": "Notes are one line, up to {{max}} characters",
    "last_note": "Note: {{note}}",
    "conflict": "Already handled by {{name}}; refreshed",
    "conflict_anon": "Already handled by someone else; refreshed",
    "failed": "Update failed: {{msg}}",
    "history": "History",
    "history_empty": "Nobody has handled it yet",
    "read_only": "You can view but not change the handling state",
    "unhandled_n": "{{n}} unhandled alarms",
    "handle_menu": "Handle",
    "note_add": "Add a note",
    "also_done": "Applied to all {{n}} in this burst",
    "more_actions": "More (false alarm, note)",
    "unhandled_counting": "Counting unhandled alarms",
    "age_just_now": "Just now",
    "age_min_one": "Open {{count}} min",
    "age_min_other": "Open {{count}} min",
    "age_hour_one": "Open {{count}} hour",
    "age_hour_other": "Open {{count}} hours",
    "age_day_one": "Open {{count}} day",
    "age_day_other": "Open {{count}} days",
    "recovered_dur": "↺ Recovered {{at}} (down for {{dur}})",
    "act_resolve_recovered": "Recovered, close",
    "resolve_recovered_tip": "The condition has cleared; mark it as handled",
    "recovered_lt1": "↺ Recovered {{at}} (down for under a second)"
  },
  "popup": {
    "title": "Alarm pop-ups",
    "help": "Bring video up automatically when something happens. This is a setting of this computer (browser), not of your account.",
    "sensor": "Sensor triggers",
    "sensor_help": "When a door contact / PIR triggers, show its linked cameras (links are set on the device page)",
    "alarm": "Alarms",
    "alarm_help": "Smoke, tamper, or detections configured to alarm while armed → show the source camera",
    "detection": "AI detections",
    "detection_help": "Also show the source camera for ordinary detections such as people and vehicles (can be very frequent on busy sites)",
    "target": "Show in",
    "target_float": "Floating window (bottom right)",
    "target_cell": "A fixed cell on the video wall",
    "cell": "Cell number",
    "cell_help": "While you are on the video wall, the source camera is moved into this cell (swapped if it is already on the wall); elsewhere a floating window is used."
  },
  "sync": {
    "title": "Synchronized playback",
    "open": "Multi-camera sync",
    "help": "Up to {{max}} cameras, played on one shared clock: cameras with cloud recording play from the cloud, the others from local recording (NVR / Station disk, SD card). A camera with no recording at that moment shows a gap.",
    "cameras": "Cameras ({{n}} / {{max}})",
    "load": "Load",
    "play": "Play",
    "pause": "Pause",
    "speed": "Speed",
    "position": "Position",
    "gap": "No cloud recording at this time",
    "end": "No cloud clips after this time (the cloud keeps event clips only)",
    "no_cloud_scope": "None of the cameras in this scope has cloud recording or local recording (NVR / Station disk, SD card) in the last two months, so there is nothing to play in sync.",
    "no_cloud_cam": "No cloud recording and no local recording (disk / SD card)",
    "aligned": "None of these cameras have recordings at {{at}}; starting at the earliest recording, {{from}}.",
    "no_cloud_legend": "Cameras with a lock have no cloud recording in the last two months (cloud recording not supported, or no seat / plan) and no local recording (NVR / Station disk, SD card).",
    "skip_to": "Skip to {{time}}",
    "jump_all": "Synced playback shares one clock: every tile moves to that time",
    "jumped": "Moved every tile to {{name}}'s next clip ({{at}}).",
    "none_later": "No cloud clips in the next {{h}} hours",
    "event_only": "Event clips only",
    "event_only_hint": "This camera stores event clips only in the cloud, so most of the synced timeline will be empty (use Go there to reach the next clip)",
    "clip_suspect": "⚠ This cloud clip may be incomplete; the picture may be green or frozen",
    "open_single": "Open in single view for other sources",
    "gap_next": "No cloud recording at this time (next clip {{time}})",
    "src_cloud": "Cloud",
    "src_nvr": "Disk",
    "src_sd": "SD card",
    "gap_local": "No local recording at this time",
    "gap_next_local": "No local recording at this time (next at {{time}})",
    "end_local": "No local recording after this time"
  },
  "chcopy": {
    "title": "Copy settings to other channels",
    "help": "Writes one channel’s settings to other channels, then reads each one back to confirm. Only settings that exist on both sides and that you may change are copied; custom editors (schedules, detection zones) and commands are excluded.",
    "source": "Source channel",
    "targets": "Target channels",
    "all": "Select all others",
    "compare": "Compare",
    "items": "Settings to copy",
    "nothing": "The source channel has no settings that can be copied",
    "col_channel": "Channel",
    "col_diff": "Different settings",
    "col_result": "Result",
    "diff_n": "{{n}}",
    "copy": "Copy",
    "retry": "Retry failed ({{n}})",
    "same": "Already the same",
    "applied_n": "{{n}} applied",
    "not_applied": "Not applied: {{list}}"
  },
  "aiset": {
    "open": "Settings",
    "title": "AI settings: {{name}}",
    "zone_help": "Click on the picture to outline the detection zone (up to {{max}} points; drag a vertex to adjust). No outline = the whole picture.",
    "line_help": "Click twice on the picture to draw the crossing line (A → B).",
    "zone_points": "Zone: {{n}} points",
    "zone_full": "Whole picture",
    "undo": "Undo last point",
    "clear": "Clear",
    "line_first": "Click to set start point A",
    "line_second": "Click again to set end point B",
    "line_set": "Line set (click the picture to redraw)",
    "direction": "Direction",
    "dir_both": "Both ways",
    "dir_a_to_b": "From A’s left to right",
    "dir_b_to_a": "From A’s right to left",
    "schedule": "Schedule",
    "always": "All day",
    "start": "Start",
    "end": "End",
    "schedule_help": "Device local time; an end earlier than the start means past midnight",
    "day_0": "Sun",
    "day_1": "Mon",
    "day_2": "Tue",
    "day_3": "Wed",
    "day_4": "Thu",
    "day_5": "Fri",
    "day_6": "Sat",
    "err_sensitivity": "Sensitivity must be 10–100",
    "err_zone_points": "A zone needs 3–16 points",
    "err_line_required": "Draw the crossing line for this model first",
    "err_line_short": "The line is too short",
    "err_schedule_days": "Pick at least one day",
    "err_schedule_time": "Invalid schedule time (start and end cannot be the same)"
  },
  "diag": {
    "title": "Remote diagnostics consent",
    "help": "When support needs a read-only remote check of this device (status, settings summary, recent device records), an owner or admin must approve. Approval is time-limited and can be withdrawn at any time. Raw logs are not available for download.",
    "none": "No diagnostics requests",
    "st_requested": "Waiting for approval",
    "st_granted": "Approved",
    "st_denied": "Denied",
    "st_revoked": "Withdrawn",
    "st_expired": "Expired",
    "by_brand": "{{brand}} support",
    "until": "until {{at}}",
    "runs": "{{n}} checks run",
    "minutes": "Approve for",
    "approve": "Approve",
    "deny": "Deny",
    "revoke": "Withdraw"
  },
  "batch": {
    "open": "Batch actions ({{n}})",
    "title_one": "Batch actions: {{count}} device",
    "title_other": "Batch actions: {{count}} devices",
    "pick": "Select {{name}}",
    "pick_all": "Select all",
    "mode_rename": "Rename",
    "mode_firmware": "Update firmware",
    "rule": "Naming rule",
    "start": "Start number",
    "rule_help": "{name} = current name, {n} = sequence number, {n:02} = zero-padded to 2 digits. Example: 1F-{n:02} {name}",
    "fw_help_one": "Checks {{count}} device and starts the firmware update if one is available (channels follow their NVR). Devices without an update are skipped; owner permission is required.",
    "fw_help_other": "Checks {{count}} devices and starts the firmware update where one is available (channels follow their NVR). Devices without an update are skipped; owner permission is required.",
    "fw_confirm_one": "Start the firmware update on {{count}} device? It goes offline briefly while updating.",
    "fw_confirm_other": "Start the firmware update on {{count}} devices? Devices go offline briefly while updating.",
    "col_new": "New name",
    "col_result": "Result",
    "run": "Start ({{n}})",
    "same": "Name unchanged",
    "st_pending": "Waiting",
    "st_running": "Working…",
    "summary": "{{ok}} done, {{skipped}} skipped, {{failed}} failed, {{left}} remaining",
    "err_BAD_NAME": "Invalid name (empty or longer than 64 characters)",
    "err_FORBIDDEN": "Not permitted",
    "mode_settings": "Apply settings",
    "settings_source": "Use this device as the template",
    "settings_help": "Writes the template device's settings to the other selected devices of the same model, then reads each one back. Only settings both devices have and you are allowed to change are copied; schedules, detection zones and commands are not. Devices of a different model are skipped.",
    "settings_confirm_one": "Apply the settings of “{{name}}” to {{count}} device? Stream settings affect existing recording and viewing.",
    "settings_confirm_other": "Apply the settings of “{{name}}” to {{count}} devices? Stream settings affect existing recording and viewing.",
    "skip_model": "Different model",
    "skip_same": "Already the same",
    "mode_location": "Assign position",
    "loc_site": "Position",
    "loc_pick": "Choose a site…",
    "loc_help": "Assign the selected devices / channels to this site (it must be under the $t(leaf.cur_lc)’s anchor site). Devices of one $t(leaf.cur_lc) are sent together: if one fails, nothing in that $t(leaf.cur_lc) changes.",
    "loc_need_org": "Locations apply only to devices in $t(leaf.cur_lc_pl) of the same team organization that you can manage.",
    "err_BATCH_REJECTED": "Another device in the same batch failed; nothing was changed",
    "err_VERSION_CONFLICT": "The position was just changed by someone else; refresh and retry",
    "err_OUT_OF_ANCHOR": "This site is not under the $t(leaf.cur_lc)’s anchor",
    "err_BAD_TARGET": "The device is not in this $t(leaf.cur_lc)",
    "no_manage": "You can't manage this device (only the $t(leaf.cur_lc)'s owner or admin can; shared devices can't be managed)",
    "no_maintain": "You can't maintain this device (needs $t(leaf.cur_lc) owner / admin, or node admin / maintainer; shared devices can't)",
    "denied": "Skipped — no permission: {{why}}",
    "denied_n_one": "{{count}} device has no permission and will be skipped.",
    "denied_n_other": "{{count}} devices have no permission and will be skipped.",
    "mode_reboot": "Restart",
    "reboot_help": "Restart {{n}} connected devices. The server checks permission for each one; any without permission are listed with the reason and the rest continue.",
    "reboot_confirm_one": "Restart {{count}} device? Recording and live view stop while it restarts.",
    "reboot_confirm_other": "Restart {{count}} devices? Recording and live view stop while they restart.",
    "picked_one": "{{count}} selected",
    "picked_other": "{{count}} selected",
    "clear": "Clear selection"
  },
  "fwm": {
    "open": "Firmware",
    "title": "Firmware",
    "back": "Back to devices",
    "help": "Firmware version and update schedule for each device. Devices with automatic updates on install new versions during their maintenance window (device local time). Which version is rolled out, staging and pauses are controlled by the platform's release settings. Only owners can change these settings.",
    "st_latest": "Up to date",
    "st_available": "Update available",
    "st_updating": "Updating",
    "st_unknown": "Unavailable",
    "count_one": "{{count}} device",
    "count_other": "{{count}} devices",
    "empty": "No devices with managed firmware in this scope.",
    "home_failed": "Could not read firmware status for {{home}}",
    "col_model": "Model",
    "col_state": "Status",
    "col_window": "Maintenance window",
    "updating": "Updating to {{v}} ({{p}}%)",
    "available": "{{v}} available",
    "critical": "critical",
    "auto_of": "Automatic updates for {{name}}",
    "window_of": "Maintenance window for {{name}}",
    "saved": "Saved",
    "batch_schedule": "Apply schedule ({{n}})",
    "batch_update": "Update now ({{n}})",
    "batch_schedule_help": "Writes automatic updates and the maintenance window to the selected devices. Window format HH:MM-HH:MM (may cross midnight); leave empty to keep the current one.",
    "batch_update_help": "Starts the update on the selected devices; devices with no update or already updating are skipped. Devices go offline briefly while updating.",
    "keep": "Keep",
    "skip_updating": "Already updating",
    "retry": "Retry failed ({{n}})",
    "err_FORBIDDEN": "Not allowed (owner only)",
    "err_FIRMWARE_NOT_CONFIGURED": "Firmware service is not enabled in this environment",
    "err_daily_cap": "Today's update limit was reached; try again tomorrow",
    "err_offline": "Device is offline",
    "report": "Update report",
    "period": "Period",
    "period_1": "Last 24 hours",
    "period_7": "Last 7 days",
    "period_30": "Last 30 days",
    "report_build": "Build report",
    "report_csv": "Download CSV",
    "report_summary": "Last {{days}} days: {{success}} succeeded, {{failed}} failed, {{other}} other",
    "report_unread_one": "(history unavailable for {{count}} device)",
    "report_unread_other": "(history unavailable for {{count}} devices)",
    "report_empty": "No updates in this period.",
    "csv_at": "Time",
    "csv_home": "Site",
    "csv_device": "Device",
    "csv_aid": "Device ID",
    "csv_from": "From",
    "csv_to": "Version",
    "csv_status": "Result",
    "csv_reason": "Reason",
    "csv_trigger": "Trigger",
    "csv_finished": "Finished",
    "job_success": "Succeeded",
    "job_failed": "Failed",
    "job_rolled_back": "Rolled back",
    "job_deferred": "Deferred",
    "job_canceled": "Canceled",
    "job_pending": "Pending",
    "job_sent": "Sent",
    "job_accepted": "Accepted",
    "job_downloading": "Downloading",
    "job_installing": "Installing",
    "job_rebooting": "Rebooting",
    "trigger_auto": "Scheduled (automatic)",
    "trigger_user_now": "Update now",
    "trigger_admin_push": "Admin push",
    "trigger_legacy_check": "Device check",
    "trigger_dev_pin": "Developer pin",
    "reason_timeout": "timed out",
    "reason_download_failed": "download failed",
    "reason_verify_failed": "verification failed",
    "reason_suspected_brick": "no report after install",
    "reason_outside_window": "outside maintenance window",
    "reason_battery_low": "battery low",
    "reason_busy": "device busy",
    "st_unknown_offline": "Unavailable (offline)",
    "only_outdated": "Only devices with an update",
    "how_saved": "Auto-update saves as soon as you flip it; for the maintenance window, press Save or Enter after editing. Devices update themselves only inside the window; to update now, tick them and press Update now."
  },
  "chmx": {
    "title": "Compare channel settings",
    "help": "Settings of every channel side by side; cells that differ from most channels are marked. Editable cells can be changed in place (written to that channel and read back). To align many channels at once, use “Copy settings to other channels” below. Schedules and detection zones are edited on the channel's own settings page.",
    "load_one": "Compare {{count}} channel",
    "load_other": "Compare {{count}} channels",
    "reload": "Reload",
    "only_diff": "Only settings that differ",
    "diff_count": "{{n}} settings differ between channels",
    "unread": "Could not read settings: {{list}}",
    "col_setting": "Setting",
    "custom": "Settings page",
    "save_cell": "Save {{name}}"
  },
  "tier": {
    "filter": "Show",
    "common": "Common",
    "advanced": "Advanced",
    "technical": "Technical"
  },
  "scope": {
    "src_own": "Mine",
    "src_org": "From my organizations",
    "src_shared": "Shared with me",
    "external": "Shared with the organization",
    "personal_org": "My home",
    "sharer_unknown": "Someone",
    "notice_mfa_required": "Two-step verification required",
    "notice_org_suspended": "Organization suspended",
    "notice_ip_not_allowed": "Not allowed from this network",
    "notice_session_reauth": "Sign in again",
    "notice_body_mfa_required": "This organization requires two-step verification. Turn it on and sign in again to see its devices; your own devices and other organizations are not affected.",
    "notice_body_org_suspended": "This organization has been suspended; its devices are hidden for now.",
    "notice_body_ip_not_allowed": "This organization only allows access from specific networks; its devices are hidden on this network.",
    "notice_body_session_reauth": "This organization requires you to sign in again to keep using its devices.",
    "go_settings": "Go to settings",
    "load_failed": "The device list could not be loaded. Please try again later.",
    "notice_delegator_mfa_required": "delegator requires two-step verification",
    "hint_all": "All",
    "hint_device": "This device is in {{path}}, outside the current scope ({{scope}}).",
    "hint_event": "This event is from {{path}}, outside the current scope ({{scope}}).",
    "hint_switch": "Switch scope to {{name}}",
    "switched_to": "Scope switched to {{name}}",
    "all_n_orgs_one": "All ({{count}} organization)",
    "all_n_orgs_other": "All ({{count}} organizations)",
    "count_one": "{{count}} device",
    "count_other": "{{count}} devices",
    "count_tip": "Devices you can access (NVR channels not counted)",
    "search": "Search organizations, sites, $t(leaf.cur_lc_pl)",
    "create_org": "+ Create organization",
    "loading": "Loading scope…",
    "all_n_orgs_homes_one": "All ({{count}} organization, {{homes}} home)",
    "all_n_orgs_homes_other": "All ({{count}} organizations, {{homes}} home(s))",
    "notice_sso_required": "Company sign-in required",
    "go_sso": "Verify with company account"
  },
  "access": {
    "shared_by": "Shared by {{name}}",
    "expires": "Expires {{date}}",
    "also_via": "Also via: {{list}}"
  },
  "deny": {
    "not_granted": "Not permitted",
    "org_mfa_required": "Two-step verification required",
    "org_suspended": "The organization is suspended",
    "ip_not_allowed": "Your organization does not allow access from this network",
    "session_reauth": "Sign in again to continue",
    "share_expired": "The share expired on {{date}}",
    "share_expired_nodate": "The share has expired",
    "share_suspended": "The share is paused",
    "alarm_window": "Only within {{n}} minutes after an alarm",
    "armed": "Only while armed",
    "schedule": "Outside the permitted hours",
    "before_share_start": "Data from before the share started is not available",
    "org_unverified": "The provider's verification has lapsed",
    "parent_restricted": "Only some channels are shared",
    "duty_no_export": "Duty accounts cannot export",
    "action_not_available": "This feature isn't offered in this environment",
    "device_offline": "The device is offline"
  },
  "shr": {
    "tab": "Sharing",
    "title": "Sharing for {{name}}",
    "hint": "Share this $t(leaf.cur_lc)'s devices one by one with people or organizations (installers, security, monitoring centers…). Shares can only be narrowed or revoked; video stops within 30 seconds of revoking. Recipients can't share them further.",
    "to_person": "Share with a person",
    "to_org": "Share with an organization",
    "people": "Shared with people",
    "orgs": "Shared with organizations",
    "none": "Nothing shared yet.",
    "no_homes": "You have no $t(leaf.cur_lc) where you can manage sharing (you need to be the $t(leaf.cur_lc)'s owner or admin).",
    "no_expiry": "No expiry",
    "renew": "Renew",
    "renew_of": "Renew \"{{name}}\"",
    "renew_hint": "Enter the renewal code from the organization: the scope stays the same and the period is extended. If the scope changes, use \"Share with an organization\" to approve again.",
    "revoke_confirm": "Revoke the share with \"{{name}}\"? Takes effect within 30 seconds.",
    "someone": "Someone",
    "an_org": "An organization",
    "person_hint": "Enter their email. If they have an account they see it right away and get notified; if not, they get an invitation email and the share starts after they sign up. They don't need to accept and can remove it at any time.",
    "no_reshare": "Only \"view\" is on by default; recipients can't share further.",
    "expires": "Expiry date (optional)",
    "expires_hint": "Leave empty to keep it until you revoke it.",
    "send": "Send",
    "sent": "Sent to {{email}}.",
    "unverified": "Not verified",
    "is_renewal": "This is a renewal request: same scope, longer period.",
    "access_log": "Share access log",
    "access_log_hint": "Every live view, playback and device control through a share is recorded here. All $t(leaf.cur_lc) members can see it and it can't be changed.",
    "grantee": "Shared with",
    "grantee_user": "Person",
    "grantee_org": "Organization",
    "wrong_env": "This code belongs to another environment ({{env}}), so this $t(leaf.cur_lc) can't approve it.",
    "requested_devices": "Requested devices",
    "unknown_device": "Removed device"
  },
  "mine": {
    "shared_tab": "Shared with me",
    "shared_title": "Shared with me",
    "shared_hint": "Devices people shared with you personally. No need to accept, and you can remove them at any time. Devices shared with your organizations aren't listed here.",
    "shared_none": "Nobody has shared devices with you.",
    "remove": "Remove",
    "remove_confirm": "Remove the devices {{name}} shared with you?",
    "remove_body": "You won't see these devices anymore; ask them to share again if you need them.",
    "access_log": "Access log",
    "access_log_hint": "Your live views, playback and device controls through shares with you. The people who shared can see these too.",
    "access_log_empty": "No records yet.",
    "result": "Result",
    "result_ok": "Allowed",
    "result_denied": "Denied"
  },
  "inv": {
    "tab_unassigned": "Unassigned devices",
    "tab_detected": "Detected devices",
    "title": "Inventory of {{name}}",
    "hint": "Devices the organization owns that aren't in a $t(leaf.cur_lc) yet: claim them and pre-assign them to a $t(leaf.cur_lc) at a site; they join automatically when they come online. Inventory gives nobody video access.",
    "detected_hint": "Devices found on site that haven't joined yet (nearby new devices, PoE cameras asking for an address, ONVIF discovery); inventory devices can be added in one click.",
    "coming_soon": "Coming soon.",
    "no_org": "You have no organization where you can manage inventory.",
    "claim": "Claim devices",
    "col_name": "Name",
    "col_serial": "Serial number",
    "col_status": "Status",
    "col_target": "Assigned / $t(leaf.cur_lc)",
    "empty": "No devices in inventory.",
    "status_offline": "Not online",
    "status_online_unpaired": "Online, not added",
    "status_assigned": "Assigned, waiting to come online",
    "status_joined": "Added",
    "claim_help": "Enter serial and order numbers (pasting a packing list works): one device per line, serial and order number separated by a space or comma. A line that does not match just says \"no match\" — it does not say which part is wrong.",
    "claim_lines": "Serial  Order no. (one per line)",
    "claim_placeholder": "SN2505A0012 PO-20261009-01",
    "claim_bad_lines": "Line {{lines}}: expected two columns, \"serial order-no\"",
    "claim_over": "Up to {{n}} lines at a time; the rest are not sent",
    "claim_run": "Claim {{n}}",
    "claim_st_pending": "Working…",
    "claim_st_ok": "✓ Added to inventory ({{model}})",
    "claim_st_already": "✓ Already in inventory ({{model}})",
    "claim_st_not_found": "Serial or order number doesn't match",
    "claim_st_rate_limited": "Too many failed attempts — try again in an hour",
    "claim_st_error": "Can't claim right now ({{code}})",
    "assign_to": "Assign to… ({{n}})",
    "assign_title": "Assign {{n}} to a $t(leaf.cur_lc)",
    "assign_help": "Pick the $t(leaf.cur_lc) to install in: devices join when they come online; ones already online join right away. Assigning gives no one access to video.",
    "assign_search": "Find $t(leaf.cur_lc)",
    "assign_home": "$t(leaf.cur)",
    "assign_no_home": "No matching $t(leaf.cur_lc_pl) ($t(leaf.cur_lc_pl) must sit under a node)",
    "assign_run": "Assign",
    "assign_st_assigned": "✓ Assigned, waiting for the device to come online",
    "assign_st_joined": "✓ Already in this $t(leaf.cur_lc)",
    "err_NOT_FOUND": "Not in this organization's inventory",
    "err_DEVICE_ALREADY_BOUND": "In another $t(leaf.cur_lc) of this organization; unbind it first to change $t(leaf.cur_lc_pl)",
    "err_ECOSYSTEM_MISMATCH": "Ecosystem mismatch",
    "err_UNAVAILABLE": "Temporarily unavailable, try again later",
    "err_INTERNAL": "Failed, try again later",
    "unassign": "Cancel assignment",
    "unassign_n": "Cancel assignment ({{n}})",
    "unassign_confirm": "Cancel the pre-assignment of {{n}} device(s)? They stay in inventory and can be assigned again.",
    "filter_all_status": "All statuses",
    "filter_all_models": "All models",
    "search_serial": "Search serial",
    "filter_node": "Only: {{name}}",
    "filter_node_clear": "Show whole organization",
    "select_all": "Select all",
    "col_source": "Source",
    "more": "More devices — narrow it down with filters.",
    "source_admin": "Platform allocation",
    "source_shop": "Store order",
    "source_claim": "Serial claim",
    "source_dealer": "Dealer shipment",
    "source_org_link": "Developer org delivery",
    "source_transfer": "Org transfer",
    "det_node": "Scope node",
    "det_scope_node": "Node in current scope",
    "det_scan": "Scan ONVIF",
    "det_scanning": "Scanning… (up to ~15 s)",
    "det_nearby_pending": "This lists devices asking a Station / NVR for a network address, and cameras found by the ONVIF scan.",
    "det_scan_result": "Scanned {{gateways}} gateway(s), found {{found}} ({{failed}} gateway(s) didn't respond)",
    "det_col_kind": "Type",
    "det_col_what": "Model / vendor",
    "det_col_seen_by": "Seen by",
    "det_col_sources": "Source",
    "det_col_seen_at": "Last seen",
    "det_kind_kinio": "Kinio device",
    "det_kind_third_party": "Third-party ONVIF",
    "det_kind_address_request": "Asking for an address",
    "det_in_inventory": "In inventory",
    "det_gateway": "Gateway",
    "det_src_onvif": "ONVIF discovery",
    "det_src_station_dhcp": "Address request",
    "det_src_nearby_wifi": "Nearby (Wi-Fi)",
    "det_src_nearby_lan": "Nearby (LAN)",
    "det_add": "Add",
    "det_add_onvif": "Add via ONVIF",
    "det_approve": "Approve address",
    "det_suspect": "May be an uplink-network device — check before approving",
    "det_empty": "No new devices detected. Use \"Scan ONVIF\" to look for cameras on the network.",
    "det_col_ident": "Tail / MAC",
    "det_lease_error": "Detection isn't running (the list may be stale):",
    "det_adopt_title": "Add inventory device to a $t(leaf.cur_lc)",
    "det_adopt_help": "Pick the $t(leaf.cur_lc) (under this node). If the device is online it joins now; otherwise it joins as soon as it comes online.",
    "det_adopt_joined": "Added.",
    "det_adopt_assigned": "Assigned — it will join when it comes online."
  },
  "ot": {
    "dot": " · ",
    "you": "You",
    "reauth_suffix": " (re-verify)",
    "optional": "(optional)",
    "reason": "Reason",
    "next": "Next",
    "next_preview": "Next: review impact",
    "name": "Name",
    "owner": "Owner",
    "personal": "Personal",
    "org_owned": "Organization",
    "add": "Add",
    "clear": "Clear",
    "details": "Details",
    "now": "now",
    "forever": "No expiry",
    "until": "Until {{date}}",
    "window": "{{from}}–{{to}}",
    "until_date": "Expiry date",
    "term": "Term",
    "only_window": "Only during this time window",
    "window_from": "From",
    "window_to": "To",
    "expand": "Expand",
    "collapse": "Collapse",
    "no_results": "No matches",
    "n_people": "{{n}} people",
    "n_people_paren": "({{n}} people)",
    "n_people_link": "{{n}} people ›",
    "n_assignments": "{{n}} assignments",
    "n_homes_devices": "Homes: {{homes}} · devices: {{devices}}",
    "n_grantees": "{{n}} assignees",
    "member_group_n": "Member group · {{n}} people",
    "member_group_paren": "(member group · {{n}} people)",
    "delegation": "Delegation",
    "delegations": "Delegations",
    "verified": "Verified: {{kinds}}",
    "org_code": "Org code {{code}}",
    "org_code_line": "Your org code: {{code}} (the other side sees the same code when creating the delegation, so you can confirm it verbally)",
    "whole_org": "Entire organization",
    "whole_org_name": "{{org}} (entire organization)",
    "whole_org_short": "{{org}}",
    "whole_org_of": "{{org}} (entire organization)",
    "whole_org_now_later": "(current and future nodes and homes)",
    "whole_org_check": "Entire organization (current and future nodes and homes)",
    "leaf_default": "Location",
    "leaf_personal": "Home",
    "leaf_default_lc": "location",
    "leaf_default_pl": "Locations",
    "leaf_default_lc_pl": "locations",
    "leaf_personal_lc": "home",
    "leaf_personal_pl": "Homes",
    "leaf_personal_lc_pl": "homes",
    "unassigned": "Unassigned",
    "scope_custom": "(current scope)",
    "level": "Level name",
    "not_in_list": "No longer in list",
    "lvl_site": "Site",
    "lvl_building": "Building",
    "lvl_floor": "Floor",
    "lvl_zone": "Zone",
    "act_view": "View",
    "act_playback": "Playback",
    "act_events": "Events",
    "act_alarm": "Alarms",
    "act_talk": "Talk",
    "act_control": "Control",
    "act_arm": "Arm",
    "act_disarm": "Disarm",
    "act_maintain": "Maintenance",
    "act_export": "Export",
    "act_profile": "$t(leaf.cur) profile",
    "role": "Role",
    "role_node_admin": "Node admin",
    "role_operator": "Operator",
    "role_viewer": "Viewer",
    "role_installer": "Installer",
    "role_maintainer": "Maintainer",
    "role_custom": "Custom",
    "role_owner": "Owner",
    "role_admin": "Admin",
    "role_member": "Member",
    "role_desc_node_admin": "All data actions (incl. arm / disarm) + maintenance + child nodes and assignments; excludes sharing, $t(leaf.cur_lc) roles, recording settings, unbinding, formatting",
    "role_desc_operator": "View, talk, playback, events, control, handle alarms",
    "role_desc_viewer": "View, events; cannot handle alarms, no alarm push",
    "role_desc_installer": "View, control",
    "role_desc_node_admin_d_tail": " + assign your members in this subtree; disarm and maintenance must be ticked separately; cannot change {{from}}'s node structure",
    "role_node_admin_excl": "(no sharing, $t(leaf.cur_lc) roles, recording settings, unbinding, formatting)",
    "role_effective_title": "Role · effective = role ∩ delegated scope ({{scope}})",
    "extra_recording_export": "Also: download / export recordings",
    "extra_alarm_receive": "Also: handle alarms",
    "extra_security_arm": "Also: remote arm",
    "extra_security_disarm": "Also: remote disarm",
    "extra_device_maintain": "Also: maintenance (firmware update, reboot, rename)",
    "tab_tree": "Org tree",
    "tab_views": "Layouts",
    "tab_groups": "Groups",
    "panel_collapse": "Collapse panel",
    "panel_expand": "Expand org tree / layouts / groups",
    "tree_dlg_changed": "{{from}} changed the delegation scope",
    "auth_changed": "Permissions were updated",
    "dlg_ended_short": "{{from}} ended the delegation",
    "tree_search": "Search nodes, $t(leaf.cur_lc_pl), devices",
    "search_min": "Type at least 2 characters",
    "search_more": "More results — narrow your search",
    "tree_empty": "No devices yet.",
    "count_tip": "Devices you can access",
    "dlg_label": "Delegated: {{from}}",
    "dlg_label_whole": "Delegated: {{from}} (entire organization)",
    "dlg_tip": "Delegated by {{from}}, {{until}}",
    "mfa_needed": "{{from}} requires two-step verification. Turn it on to see these devices.",
    "setup_mfa": "Set up two-step verification",
    "dlg_ended_line": "{{from}} ended the delegation at {{time}}",
    "no_assignment_yet": "You have not been assigned any node in {{org}} yet. Contact an admin of {{org}}.",
    "more_actions": "More actions for {{name}}",
    "notify_me_node": "Notify me about this node",
    "notify_me_group": "Notify me about this group",
    "add_to_view": "Add to layout…",
    "add_to_group": "Add to group…",
    "open_in_wall": "Open on video wall",
    "no_devices": "No devices you can see",
    "place_on_wall": "Put on video wall",
    "you_can_view_hint": "A feed is a camera or a channel; an NVR counts once per channel (the tree counts devices)",
    "live_empty": "No cameras you can see in this scope.",
    "live_dlg_ended": "{{from}} ended the delegation at {{time}}; this view has stopped",
    "live_dlg_changed": "{{from}} changed the delegation scope; you can no longer view this camera",
    "prev_page": "Previous page",
    "next_page": "Next page",
    "page_n": "Page {{n}} / {{total}}",
    "views_hint": "A layout only organizes devices; it never lets anyone see devices they have no access to",
    "groups_hint": "Groups grant no access; everyone sees only the devices they can access",
    "view_new": "New layout",
    "group_dev_new": "New device group",
    "no_views": "No layouts yet.",
    "no_dev_groups": "No device groups yet.",
    "view_label": "Layout: {{name}}",
    "group_prefix": "Group: {{name}}",
    "edit_named": "Edit {{name}}",
    "unavailable_n_one": "{{count}} item can no longer be referenced",
    "unavailable_n_other": "{{count}} items can no longer be referenced",
    "group_batch": "Batch actions",
    "view_edit_title": "Edit layout: {{name}}",
    "group_edit_dev_title": "Edit device group: {{name}}",
    "org_view_of": "Organization: {{org}}",
    "source_personal": "Source (what I can see)",
    "source_org": "Source (your org structure and delegated nodes; names only)",
    "source_structure": "Your organization structure",
    "view_content": "Layout contents",
    "group_content": "Group contents",
    "add_folder": "Add folder",
    "new_folder": "New folder",
    "folder": "Folder",
    "top_level": "Top level",
    "editor_empty": "Add items with ＋ from the source on the left.",
    "ref_folder": "folder",
    "ref_node": "node",
    "ref_home": "$t(leaf.cur_lc)",
    "ref_device": "device",
    "ref_group": "group",
    "add_ref": "Add {{name}}",
    "items_from_ended_one": "From an ended delegation: {{from}} ({{count}} item)",
    "items_from_ended_other": "From an ended delegation: {{from}} ({{count}} items)",
    "items_gone_one": "{{count}} item can no longer be referenced",
    "items_gone_other": "{{count}} items can no longer be referenced",
    "add_to_view_title": "Add \"{{name}}\" to a layout",
    "add_to_group_title": "Add \"{{name}}\" to a group",
    "no_editable_views": "No layouts you can edit. Create one on the Layouts tab first.",
    "no_editable_groups": "No groups you can edit. Create one on the Groups tab first.",
    "subs_title": "Nodes and groups",
    "subs_hint": "Nodes in the org tree do not push regular detections by default; subscribe to get push / inbox. Without a subscription they only appear in the Events list.",
    "subs_mine": "My subscriptions",
    "subs_none": "No node or group subscriptions yet.",
    "subs_target": "Node / group",
    "subs_detection": "Detections",
    "subs_inactive": "Not in effect",
    "subs_add": "+ Subscribe to a node or group",
    "subscribe": "Subscribe",
    "unsubscribe": "Unsubscribe",
    "ch_push": "Push",
    "ch_inbox": "Inbox",
    "ch_email": "Email",
    "implicit_title": "You get these without subscribing",
    "implicit_alarm": "Alarms",
    "implicit_device_status": "Device issues",
    "implicit_alarm_push": "pushed per your usual preferences",
    "implicit_alarm_feed": "not pushed; visible in the Events list",
    "implicit_alarm_generic": "Where your role can handle alarms, pushed per your usual preferences; where you are a viewer, not pushed but visible in Events",
    "implicit_status": "Where you are node admin or handle maintenance: offline, recording stopped, storage issues are pushed; OTA and others go to the inbox",
    "implicit_mfa": "If a delegating org requires two-step verification and you have not turned it on: alarms are still pushed, but only say \"<delegator> has an alarm; turn on two-step verification to see it\"",
    "structure_title": "Organization structure",
    "structure_moved": "Nodes, $t(leaf.cur_lc_pl), assignments and inheritance blocking are managed in Organization structure.",
    "open_structure": "Open organization structure",
    "no_structure_access": "You have no nodes to manage.",
    "level_settings": "Level names",
    "struct_tree_head": "Structure (numbers = structural totals)",
    "struct_tree": "Structure tree",
    "struct_search": "Search nodes, {{leaf}}",
    "struct_count_tip": "Structural total (devices)",
    "blocked_tip": "Inheritance blocked: assignments and delegations from above do not apply",
    "select_home": "Select {{name}}",
    "pick_node": "Pick a node on the left.",
    "struct_totals": "Below here: nodes {{nodes}}, homes {{homes}}, devices {{devices}} (structural totals)",
    "add_child": "+ Child node",
    "add_home": "+ {{leaf}}",
    "rename_level": "Rename / level",
    "move": "Move",
    "archive": "Archive",
    "archive_title": "Archive \"{{name}}\"?",
    "archive_body": "The node must have no $t(leaf.cur_lc_pl) or child nodes. Assignments on it end; delegations only drop this node.",
    "archived": "Archived \"{{name}}\"",
    "block_label": "Block inheritance (assignments and delegations from above no longer apply below this node)",
    "this_node_assignments": "Assignments on this node",
    "no_assignments": "No assignments on this node.",
    "add_assignment": "+ Assign",
    "inherited_title": "Inherited from above (read-only)",
    "delegated_out_title": "Delegated to other organizations (read-only)",
    "col_who": "Who",
    "col_role": "Role",
    "col_role_before": "Role before",
    "col_term": "Term / schedule",
    "col_from": "From",
    "col_to_org": "Delegated to",
    "col_from_org": "Delegated by",
    "col_scope": "Scope",
    "col_how": "How",
    "col_granted_by": "Granted by",
    "col_lost_actions": "Actions lost",
    "col_effective": "Effective",
    "col_effective_now": "Effective now",
    "col_after_apply": "Added after applying",
    "col_node": "Node",
    "col_grantees": "Assignees",
    "col_assigned": "Assigned",
    "n_selected": "{{n}} {{leaf}} selected",
    "move_to": "Move to…",
    "assign_manager": "Assign manager…",
    "only_unassigned": "Only unassigned homes can be selected",
    "batch_max": "Up to {{n}} homes at a time",
    "node_name": "Node name",
    "level_hint": "Level names are only for display and filtering; they do not grant access.",
    "create": "Create",
    "add_child_of": "Add a node under \"{{name}}\"",
    "rename_title": "Rename / level: {{name}}",
    "node_created": "Created \"{{name}}\"",
    "node_saved": "Saved",
    "add_home_at": "Add a {{leaf}} in \"{{name}}\"",
    "manager": "Manager",
    "manager_none": "Unassigned (assign later)",
    "manager_member": "Assign a member",
    "manager_me": "Make me the manager",
    "home_name": "{{leaf}} name",
    "creator_not_manager": "The creator does not become the manager of this home; who can see it is decided by node assignments.",
    "cover_summary": "Assignments that will cover this home: {{list}}",
    "cover_part": "{{node}}: {{n}}",
    "cover_dlg": "Delegated: {{org}}",
    "no_one_covers": "No one can see video from this home yet",
    "whole_org_hint": "Need to watch every new site yourself? Assign yourself once on \"Entire organization\" (self-grant); new ones are covered automatically",
    "unassigned_install": "You can install devices before assigning a manager: org admins and members with inventory permission can pre-assign, adopt and pair devices (binding gives no one data access); recording uses the device default (continuous or event, by model); to change recording settings, share or unbind, assign a manager first (you can assign many homes at once later).",
    "self_manager_yellow": "You will become the manager of this {{leaf}} and get all its recordings and events.",
    "create_home": "Create {{leaf}}",
    "home_created": "Created {{leaf}} \"{{name}}\"",
    "pick_target_hint": "Choose the destination node (only nodes you manage are listed).",
    "move_node_title": "Move \"{{name}}\"",
    "move_node_confirm": "Move \"{{name}}\" to \"{{to}}\"?",
    "move_node_intro": "Moving changes which assignments and delegations cover this subtree.",
    "move_action": "Move",
    "move_self_action": "Move and gain access",
    "moved": "Moved \"{{name}}\"",
    "move_homes_title_one": "Move {{count}} home to…",
    "move_homes_title_other": "Move {{count}} homes to…",
    "move_homes_confirm_one": "Move {{count}} home to \"{{to}}\"?",
    "move_homes_confirm_other": "Move {{count}} homes to \"{{to}}\"?",
    "move_homes_intro": "One preview, one confirmation; all succeed or nothing changes.",
    "move_homes_action_one": "Move {{count}} home",
    "move_homes_action_other": "Move {{count}} homes",
    "homes_moved_one": "Moved {{count}} home",
    "homes_moved_other": "Moved {{count}} homes",
    "manager_dialog_title_one": "Assign a manager for {{count}} home",
    "manager_dialog_title_other": "Assign a manager for {{count}} homes",
    "manager_pick": "New manager (member of this org)",
    "manager_effect_one": "{{name}} will become the manager ($t(leaf.cur_lc) owner) of {{count}} home: can see all recordings and events ($t(leaf.cur_lc) roles are not limited by the coverage start, including before the assignment), change recording settings, share and unbind; existing node assignments stay the same",
    "manager_effect_other": "{{name}} will become the manager ($t(leaf.cur_lc) owner) of these {{count}} homes: can see all recordings and events ($t(leaf.cur_lc) roles are not limited by the coverage start, including before the assignment), change recording settings, share and unbind; existing node assignments stay the same",
    "all_or_nothing": "All succeed or nothing changes.",
    "self_manager_batch_one": "You chose yourself: this is a self-grant and gives you all recordings of {{count}} home; other admins get one notification and it is audited.",
    "self_manager_batch_other": "You chose yourself: this is a self-grant and gives you all recordings of these {{count}} homes; other admins get one notification and it is audited.",
    "manager_submit_one": "Assign manager for {{count}} home",
    "manager_submit_other": "Assign manager for {{count}} homes",
    "managers_done_one": "{{name}} is now the manager of {{count}} home",
    "managers_done_other": "{{name}} is now the manager of {{count}} homes",
    "levels_hint": "Your org keeps a list of level names and each node picks one; the same depth can use different names. Up to 12, each 1–20 characters.",
    "level_n": "Level name {{n}}",
    "from_builtin": "Was built-in",
    "add_level": "+ Level name",
    "leaf_label": "Name for $t(leaf.cur_lc_pl) (e.g. unit, site, store)",
    "levels_preview": "Preview",
    "levels_no_perm": "Names do not grant access.",
    "levels_builtin_warn": "Built-in names become text in your current language, and members using other languages will see this text too; nodes using them change together.",
    "levels_saved": "Level names saved",
    "levels_err_too_many": "At most 12 level names",
    "levels_err_length": "Each name must be 1–20 characters",
    "levels_err_at_prefix": "Custom names cannot start with @",
    "levels_err_duplicate": "Names must be unique",
    "previewing": "Calculating impact…",
    "preview_again": "Preview again",
    "preview_restaled": "Something changed since the preview. It has been refreshed and changed rows are highlighted; please confirm again.",
    "losing_title": "Will lose access via the org tree ({{n}} people incl. group members · {{orgs}} delegated orgs)",
    "gaining_title": "Will gain access ({{n}} people)",
    "history_from": "People who gain access start from {{time}} and cannot see earlier recordings or events.",
    "remaining_title": "Will still have access (not via the org tree; blocking inheritance does not stop these)",
    "other_paths": "Still has access another way (see below)",
    "target_still": "{{name}} still sees it through this",
    "granter_still": "grantor still has access via {{path}}",
    "keep": "Kept",
    "also_revoke": "Also revoke",
    "path_home_role": "$t(leaf.cur) role",
    "path_site_grant": "Site grant",
    "path_share_user": "Shared with a person",
    "path_share_org": "Shared with an org",
    "path_assignment": "Assignment inside the subtree",
    "path_delegation": "Delegation inside the subtree",
    "granted_by_target_title": "Assignments granted by them that are still active",
    "still_visible": "Afterwards {{n}} people can still see {{target}}: {{who}}",
    "more_rows": "and {{n}} more",
    "impact_scope": "Affected: homes {{homes}}, devices {{devices}}",
    "active_streams": "{{n}} people watching now (stops within 30 seconds)",
    "dlg_gained": "The delegation to {{org}} will cover {{n}} more homes; the owner and all admins of your org and the delegate org will be notified.",
    "dlg_lost": "The delegation to {{org}} will cover {{n}} fewer homes (immediately; both sides are notified).",
    "self_gain_generic": "This change gives you new data access (self-grant): a reason is required; other org admins and the owner are notified and it is audited.",
    "block_on_title": "Block inheritance at \"{{name}}\"?",
    "block_off_title": "Unblock inheritance at \"{{name}}\"?",
    "block_on_intro": "Once blocked, assignments and delegations from above no longer apply below {{name}} ({{homes}} homes, {{devices}} devices); assignments on {{name}} itself still apply. Node admins above will no longer see {{name}} (counts, access and audit exclude it).",
    "block_off_intro": "Once unblocked, assignments and delegations from above cover {{name}} again; people who regain access start from now.",
    "block_on_action": "Block inheritance",
    "block_on_action_revoke": "Block inheritance and revoke {{n}}",
    "block_off_action": "Unblock inheritance",
    "block_off_self_action": "Unblock and gain access",
    "block_on_note": "If you unblock later, people who regain access start from that moment and cannot see recordings from the blocked period.",
    "blocked_done": "Inheritance blocked at \"{{name}}\"",
    "unblocked_done": "Inheritance unblocked at \"{{name}}\"",
    "revoke_assign_title": "Revoke {{who}}'s assignment on \"{{node}}\"?",
    "revoke_assign_body": "Will lose: {{what}} (new requests are refused immediately; live video stops within 30 seconds)",
    "revoke_assign": "Revoke assignment",
    "revoke_node_admin_intro": "Before revoking a node admin, review the assignments they granted that are still active; you can revoke them too. Unticked ones stay active.",
    "revoked": "Revoked",
    "steps": "Steps",
    "step_who": "Who",
    "step_role": "Role",
    "step_term": "Term / schedule",
    "step_confirm": "Confirm",
    "assign_title": "Assign on \"{{node}}\"",
    "assign_edit_title": "Edit assignment of {{name}}",
    "assign_d_title": "Assign \"{{path}}\" to your members",
    "who": "Person or member group",
    "who_search": "Search people, member groups",
    "d_node_label": "Node (within the delegated subtree; child nodes allowed; names and counts only)",
    "covers_now": "Covers {{homes}} homes and {{devices}} devices now (structural totals);",
    "covers_subtree": "Covers every home in this node's subtree;",
    "covers_tail": "new ones are covered too; child nodes with blocked inheritance are not.",
    "effective_now": "Effective: {{what}}",
    "not_effective": "Will not take effect: {{what}}",
    "not_effective_paren": "(won't take effect: {{what}})",
    "out_of_scope": "Outside the delegated scope: {{what}}",
    "ignored_box": "\"{{role}}\" includes \"{{what}}\", which {{from}} did not delegate: that part will not take effect.",
    "pick_template": "pick a template (its actions apply)",
    "assign_done": "Assigned.",
    "assign": "Assign",
    "assign_self": "Assign myself",
    "self_yellow": "You will gain video (incl. recordings) for \"{{scope}}\".",
    "self_notify_others": "Other org admins and the owner are notified and it is audited.",
    "self_notify_owner": "The owner is notified and it is audited.",
    "self_notify_audit_only": "It is recorded in the audit log.",
    "self_notify_d": "The owner and admins of {{from}} are notified too.",
    "self_suggest_term": "Setting an expiry is recommended.",
    "reason_needed_self": "This gives you access yourself (self-grant); please enter a reason.",
    "d_visible_to_delegator": "{{from}} can see the assignee's display name, role and activity.",
    "member_groups": "Member groups",
    "member_groups_hint": "Member groups are only used as targets of node assignments (e.g. night guards); one level, no nesting. Changing members requires re-verification; adding yourself to a group that has assignments gives you access (self-grant).",
    "group_new": "New member group",
    "no_groups": "No member groups yet.",
    "group_name": "Group name",
    "group_members": "Members",
    "group_used": "Used by",
    "group_edit_title": "Edit member group: {{name}}",
    "group_delete_title": "Delete member group \"{{name}}\"?",
    "group_delete_body": "The {{n}} assignments using this group stop working; members stop watching through them within 30 seconds.",
    "group_delete": "Delete group",
    "self_group_yellow": "You are adding yourself to a group with {{n}} assignments and will gain video for those nodes.",
    "dlg_out": "Delegated out",
    "dlg_in": "Delegated to us",
    "dlg_out_of": "Delegated out ({{org}})",
    "dlg_in_of": "Delegated to us ({{org}})",
    "no_dlg_out": "No delegations to other organizations yet.",
    "no_dlg_in": "No organizations have delegated to you yet.",
    "dlg_scope": "Scope",
    "dlg_forever_short": "No expiry",
    "dlg_new_by_code": "Add with the other org's delegation code",
    "still_needed": "Still needed",
    "reviewed": "Reviewed: delegation to {{org}} is still needed",
    "tag_review": "Review due",
    "tag_expiring": "Expiring soon",
    "tag_suspended": "Suspended",
    "tag_ended": "Ended",
    "delegator_paren": "(by {{name}})",
    "dlg_mfa_note": "{{from}} requires two-step verification: assigned members must turn it on too",
    "expandable": "Scope expanded: {{n}} assignments can be expanded",
    "apply_ellipsis": "Apply…",
    "assign_members": "Assign members",
    "gen_code": "Generate delegation code",
    "gen_code_hint": "Give the code, QR or link to the organization that will delegate to you; valid for 7 days and single-use.",
    "code_note": "Note",
    "code": "Delegation code",
    "code_qr": "Delegation code QR",
    "code_valid": "Valid until {{date}}",
    "my_codes": "Codes I generated",
    "code_expires": "Expires {{date}}",
    "code_cancel": "Withdraw",
    "dlg_new_title": "New delegation",
    "wz_code": "Code",
    "wz_nodes": "Nodes",
    "wz_scope": "Scope and term",
    "wz_confirm": "Confirm",
    "dlg_code_input": "The other org's delegation code",
    "dlg_code_hint": "The code the other org generated under \"Delegated to us\"; make sure it comes from someone you know.",
    "requested_by": "Requested by {{name}} ({{domain}})",
    "unverified_warn": "This organization is not verified by the platform; make sure the code comes from someone you know",
    "single_home_hint": "To delegate a single home: create a node, move the home into it, then delegate that node.",
    "scope_view": "View (live video)",
    "scope_event_read": "Events",
    "scope_recording_read": "Playback",
    "scope_alarm_receive": "Handle alarms",
    "scope_media_talk": "Talk",
    "scope_device_control": "Control",
    "scope_security_arm": "Remote arm",
    "scope_security_disarm": "Remote disarm",
    "scope_device_maintain": "Maintenance (firmware update, reboot, rename)",
    "scope_home_profile_read": "$t(leaf.cur) profile (address, time zone, map, floor plan)",
    "scope_recording_export": "Download / export recordings",
    "dlg_fixed_1": "Unbinding, formatting, permissions and node structure always stay with you.",
    "dlg_fixed_2": "The other org's API / webhooks do not get these devices (only their member accounts).",
    "dlg_fixed_3": "Your two-step verification requirement applies to their members; your IP allowlist and idle timeout do not.",
    "dlg_forever": "No expiry (both sides reminded to review every 12 months)",
    "dlg_until": "Expiry date (reminders 30 / 7 days before)",
    "dlg_history": "History",
    "dlg_history_now": "Only from when the delegation starts",
    "dlg_history_back": "Go back (up to 30 days)",
    "days_back": "days back",
    "history_days_one": "{{count}} day back",
    "history_days_other": "{{count}} days back",
    "history_since": "From {{date}}",
    "dlg_notify": "After creation, notifications go to the owner and all org admins of {{from}}, and the owner and admins of {{to}}",
    "dlg_self_related": "You are also a member of {{to}}: this is treated like a self-grant; a reason is required and the audit marks it.",
    "dlg_create": "Create delegation",
    "dlg_created": "Delegated to {{org}}",
    "dlg_detail_out": "Delegated to {{org}}",
    "dlg_detail_in": "Delegated to us by {{org}}",
    "edit_scope": "Edit scope",
    "extend_term": "Extend / set expiry",
    "revoke_dlg": "Revoke delegation",
    "end_dlg": "End delegation",
    "end_dlg_title": "End the delegation from {{from}}?",
    "end_dlg_body": "Your members' access through this delegation stops immediately (video within 30 seconds) and your assignments under it end; both sides record it in the audit log.",
    "created_reviewed": "Created / reviewed",
    "expanded_at": "expanded {{date}}",
    "reviewed_at": "last reviewed {{date}}",
    "created_by": "created by {{name}}",
    "policy": "Policies applied",
    "policy_mfa": "{{from}} requires two-step verification (IP allowlist and idle timeout do not apply)",
    "policy_none": "No extra requirements",
    "grantees_title": "Assignees at {{org}} (read-only)",
    "no_grantees": "They have not assigned any members yet.",
    "via_group": "via group {{ref}}",
    "recent_ops": "Activity through this delegation in the last 30 days: {{n}}",
    "open_audit": "Open audit log",
    "my_assignments_title": "Our assignments",
    "no_d_assignments": "No members assigned yet.",
    "can_expand": "Can expand",
    "delegator_sees_list": "{{from}} can see this list (display name, role, effective actions, node, term; no email)",
    "revoke_dlg_title": "Revoke the delegation to {{org}}?",
    "will_lose": "{{org}} will lose ({{n}} assignees)",
    "revoke_dlg_note": "The owner and admins of {{org}} are notified; their members see \"delegation ended\", not just \"permissions updated\".",
    "dlg_revoked": "Revoked the delegation to {{org}}",
    "edit_scope_title": "Edit delegation scope for {{org}}",
    "extend_term_title": "Delegation term for {{org}}",
    "edit_dlg_hint": "Narrowing takes effect immediately and notifies them; expanding needs no consent, and their existing assignments only expand after they apply.",
    "save_scope": "Save scope",
    "save_term": "Save term",
    "dlg_updated": "Delegation updated",
    "apply_title": "Apply the scope {{from}} expanded",
    "apply_hint": "{{from}} expanded the delegation; nothing changes until you apply. Tick the assignments to expand.",
    "apply_n": "Apply {{n}}",
    "applied": "Applied to {{n}} assignments",
    "d_revoke_title": "Revoke {{who}}'s assignment on \"{{where}}\"?",
    "d_revoke_lose": "Will lose: {{what}}",
    "d_revoke_streams": "Watching through this assignment now: {{n}} (stops within 30 seconds)",
    "d_revoke_notify": "Device issue notifications stop from the next one.",
    "d_revoke_yellow": "{{from}}'s delegation details will drop them; both sides record it in the audit log.",
    "err_rate_limited_one": "Too many previews; try again in {{count}} second",
    "err_rate_limited_other": "Too many previews; try again in {{count}} seconds",
    "err_depth": "Nodes can be at most {{n}} levels deep",
    "err_limit": "Limit reached ({{n}})",
    "err_busy": "The org tree is being updated; try again shortly",
    "err_not_empty": "The node still has {{homes}} homes and {{nodes}} child nodes; move them first",
    "err_team_org": "Only team organizations can use node assignments and delegations",
    "err_use_node_assignment": "The \"site admin\" template is retired; use a node assignment instead",
    "err_code_gone": "The delegation code expired, was withdrawn or already used; ask for a new one",
    "err_scope_exceeded": "This role has nothing in common with the delegated scope; the assignment would do nothing",
    "err_cycle": "You cannot move a node under itself",
    "err_out_of_anchor": "Some device positions are outside the new node; adjust device positions first",
    "err_exceeds_actions": "You cannot grant actions beyond your own",
    "err_exceeds_expires_at": "The term cannot exceed your own assignment",
    "err_exceeds_schedule": "The schedule cannot exceed your own assignment",
    "err_preview_stale": "Something changed since the preview; preview again",
    "err_home_assigned": "Some selected homes already have a manager; only unassigned homes can be chosen",
    "err_conflict": "A matching delegation or setting already exists",
    "err_history_max_one": "You can go back at most {{count}} day",
    "err_history_max_other": "You can go back at most {{count}} days",
    "err_root_node": "This cannot be done on the entire organization",
    "err_invalid": "Invalid input",
    "err_forbidden_self_modify": "You cannot change or revoke your own assignment",
    "err_forbidden_inheritance_boundary": "Only the owner and org admins can move into or out of a blocked subtree",
    "err_forbidden_orgtree_not_open": "Node assignments and delegations are not yet open for this organization",
    "pair_joined_no_access": "Joined. You do not have video access to this home",
    "batch_mode": "Move / assign managers in bulk",
    "batch_mode_move": "Move in bulk",
    "select_done": "Done selecting",
    "select_hint": "Tick the {{leaf}} to work on",
    "struct_count_head": "Number = all devices below this level (including ones you can't watch)",
    "site_tab_devices": "Devices",
    "site_tab_access": "Who has access",
    "site_tab_settings": "Site settings",
    "site_access_hint": "Assignments here, inherited from above (read-only), delegated out (read-only), $t(leaf.cur_lc) roles and shares.",
    "maint_title": "Maintenance",
    "block_short": "Block inheritance",
    "block_is_on": "On",
    "block_is_off": "Off",
    "archive_desc": "An archived node no longer shows in the tree. Nodes that still have homes or child nodes can't be archived.",
    "site_dev_count": "You can see {{n}} devices ({{homes}} homes below here)",
    "site_dev_name": "Name",
    "site_dev_model": "Model",
    "site_dev_status": "Status",
    "site_dev_home": "Home",
    "site_dev_online": "Online",
    "site_dev_offline": "Offline",
    "site_dev_channels_one": "({{count}} channel)",
    "site_dev_channels_other": "({{count}} channels)",
    "site_dev_empty": "No devices below here yet.",
    "site_dev_hidden": "{{n}} more homes you have no video access to (devices not listed): {{names}}",
    "set_name": "Name and level",
    "set_tz": "Time zone",
    "set_tz_inherit": "Same as parent (not set)",
    "set_tz_hint": "Used for time windows, schedules and reports; follows the parent when not set.",
    "set_geo": "Address and coordinates",
    "set_address": "Address",
    "set_lat": "Latitude",
    "set_lng": "Longitude",
    "set_geo_bad": "Fill in both latitude and longitude as numbers.",
    "set_saved": "Saved.",
    "set_offline": "Works offline (local VMS)",
    "set_offline_on": "When the internet is down, computers at this site can still use the local VMS to watch Kinio Station cameras",
    "set_offline_hours": "Longest offline time (hours)",
    "set_offline_hint": "When on, members at this site can register a computer in My account › Local VMS. Team organizations: up to 72 hours.",
    "set_offline_saved_on": "Offline use turned on.",
    "set_offline_saved_off": "Offline use turned off.",
    "set_computers": "Computers registered for local VMS",
    "set_computer_updated": "last updated {{date}}",
    "views_empty": "Saved video wall layouts and your own camera lists live here; [Save as] on the video wall or [New layout] saves here.",
    "groups_empty": "A group is a list of cameras you can use for tours, notification subscriptions, or opening on the video wall in one go.",
    "layout_cells_one": "Layout · {{count}} tile",
    "layout_cells_other": "Layout · {{count}} tiles",
    "layout_open_tip": "Open on the video wall with this layout",
    "struct_totals2": "{{nodes}} nodes, {{homes}} homes, {{dev}} below (structure totals)",
    "struct_dev_incl_one": "{{count}} device (incl. channels)",
    "struct_dev_incl_other": "{{count}} devices (incl. channels)",
    "struct_dev_split": "{{devices}} devices, {{channels}} channels",
    "struct_count_tip_incl": "Structure total (currently includes NVR channels)",
    "struct_count_tip_split": "Structure total (devices, excluding {{channels}} channels)",
    "struct_count_head_incl": "; currently includes NVR channels",
    "set_autosave": "Changes save automatically when you leave a field — no Save button.",
    "you_can_view_wall": "This scope has {{n}} feeds; {{x}} of them are on the wall",
    "tree_btn": "Org tree",
    "you_can_view_wall_paged": "This scope has {{n}} feeds: {{x}} on this page, {{rest}} more on the next",
    "home_devices": "{{count}} devices (structure total)",
    "home_delete": "Delete this {{leaf}}",
    "home_delete_desc": "Devices are removed and reset to factory settings, and recordings and events are deleted. This can’t be undone.",
    "home_delete_title": "Delete \"{{name}}\"?",
    "home_delete_warn_n": "The {{count}} devices in this {{leaf}} will be removed and reset to factory settings. ",
    "home_delete_warn_empty": "This {{leaf}} has no devices. ",
    "home_delete_tail": "Recordings and events will be deleted, and members will be notified. This can’t be undone.",
    "home_delete_archives_n": "This {{leaf}} has {{count}} export packages in long-term retention (until {{date}} at the latest). They will be deleted too; retention fees already paid are not refunded.",
    "home_delete_archives_n_nodate": "This {{leaf}} has {{count}} export packages in long-term retention. They will be deleted too; retention fees already paid are not refunded.",
    "home_delete_archives_unknown": "Any export packages in long-term retention for this {{leaf}} will be deleted too; retention fees already paid are not refunded.",
    "home_delete_action": "Delete this {{leaf}} (re-verification required)",
    "home_deleting": "Deleting…",
    "home_deleted": "Deleted \"{{name}}\"",
    "err_home_unbind_failed": "Some devices couldn’t be unbound, so this {{leaf}} wasn’t deleted. Try again later.",
    "err_home_not_found": "This {{leaf}} no longer exists, or you can’t see it.",
    "err_home_delete_forbidden": "Only the organization owner / admins or the manager of this {{leaf}} can delete it.",
    "high_risk_badge": "High risk: reason required",
    "high_risk_reason_note": "(high-risk delegation: a reason is required; takes effect on submit)",
    "reason_required_body": "This expands a high-risk delegation (whole organization, export or disarm): enter a reason. It takes effect on submit and notifies the owners and admins of both organizations.",
    "err_high_risk_reason": "High-risk delegations need a reason",
    "dlg_notify_high_risk": "High-risk delegation: takes effect on submit. Notifies the owner and all org admins of {{from}}, and the owner and admins of {{to}} (with the creator and reason)",
    "local_playback_full": "Can play back local recordings (SD card / hard drive), including ones made before this access",
    "local_playback_full_hint": "When on, this person can play back every local recording on the device, including ones recorded before the share or assignment. Cloud recordings and events still start from when access began. Only organization owners and admins can change this.",
    "lpf_on": "Yes",
    "lpf_off": "No",
    "hm_title": "Members",
    "hm_you": "(you)",
    "hm_default_role": "Follows organization role",
    "hm_add": "Add member",
    "hm_pick": "Choose an organization member",
    "hm_add_submit": "Add",
    "hm_no_candidates": "No organization members left to add",
    "hm_added": "Added {{name}} as {{role}}",
    "hm_role_changed": "Changed {{name}} to {{role}}",
    "hm_remove": "Remove",
    "hm_remove_title": "Remove {{name}} from “{{home}}”?",
    "hm_remove_body": "{{name}} will no longer see this home’s devices but stays in the organization.",
    "hm_removed": "Removed {{name}}"
  },
  "aiLocal": {
    "title": "Who analyzes each camera",
    "help": "Shows who runs AI analysis for each camera. Cameras assigned to local AI (AI box, NVR, Kinio Station for PC) are skipped by Cloud AI by default and don't use cloud quota.",
    "local_too": "Analyze with both local and cloud AI",
    "local_too_help": "Cameras assigned to local AI are also sent to Cloud AI (uses cloud quota; turning this on requires re-authentication)",
    "col_camera": "Camera",
    "col_analyzer": "Analyzed by",
    "col_detail": "Details",
    "who_local": "Local AI",
    "who_cloud": "Cloud AI",
    "who_both": "Local + cloud",
    "who_none": "None",
    "offline": "Local AI is offline; events aren't analyzed for now",
    "excluded": "Excluded from Cloud AI",
    "status_pending": "Applying",
    "status_running": "Running",
    "status_degraded": "Reduced",
    "status_unreachable": "Can't get video",
    "status_rejected": "Rejected by provider",
    "who_unknown": "Unknown",
    "providers_failed": "Couldn't read local AI status for this $t(leaf.cur_lc)",
    "not_queried": "Local AI status isn't visible for this $t(leaf.cur_lc) (shared with you)",
    "cloud_failed": "Couldn't read Cloud AI consent or usage",
    "status_starting": "Starting",
    "status_detector_error": "Detector error",
    "status_other": "Status: {{status}}"
  },
  "poeports": {
    "intro": "Power and connected devices for each PoE port on this Station. Values the Station does not report show as \"Unknown\".",
    "none": "This Station reports no PoE ports.",
    "unknown": "Unknown",
    "col_port": "Port",
    "col_power": "Power",
    "col_meas": "Measurements",
    "col_link": "Link",
    "col_devices": "Connected devices",
    "col_actions": "Actions",
    "st_disabled": "Turned off",
    "st_powered": "Powered",
    "st_idle": "Not powered",
    "class": "Class",
    "temp": "Temp",
    "link_up": "Up",
    "link_down": "Down",
    "not_home": "Not matched to a channel in this $t(leaf.cur_lc)",
    "macs_more": "More devices (first 4 shown)",
    "act_on": "Turn on power",
    "act_off": "Turn off power",
    "act_cycle": "Power cycle",
    "confirm_on": "Turn on power for port {{port}}?",
    "confirm_off": "Turn off power for port {{port}}?",
    "confirm_cycle": "Power cycle port {{port}}?",
    "confirm_body": "The device on this port loses power; a camera stops recording until it finishes restarting.",
    "sending": "Sending…",
    "done": "Port {{port}} updated.",
    "not_persistent": "Ports you turn off get power again when the Station restarts.",
    "err_FORBIDDEN": "You need maintenance permission to control PoE ports.",
    "err_UNSUPPORTED_COMMAND": "This Station does not support PoE port control.",
    "err_BAD_PARAMS": "Invalid port number.",
    "err_HAL_ERROR": "The Station did not apply the change. Try again.",
    "err_DEVICE_OFFLINE": "The Station is offline.",
    "err_COMMAND_TIMEOUT": "The Station did not respond. Check the port status in a moment.",
    "err_other": "Failed ({{code}})."
  },
  "apikeys": {
    "title": "API keys",
    "count": "{{n}} / {{limit}}",
    "hint": "A key acts as you. What Claude does with it is the same as you doing it here, and is recorded under your name. Don't paste keys into chats, code or documents; if one leaks, revoke it right away. Keys here only work with VMS (including Kinio Node / Station); create a separate one in the developer portal for that.",
    "created": "Created “{{name}}” — the key is shown only this once:",
    "copy": "Copy",
    "setup_hint": "Open a terminal on your computer (Terminal on macOS, PowerShell on Windows) and run this line to add Kinio VMS to Claude (nothing to install). Do not paste it into a Claude chat — the key would stay in the chat history:",
    "saved": "I've saved it",
    "name": "Name",
    "name_placeholder": "e.g. Claude on my laptop",
    "scopes": "Scopes",
    "last_used": "Last used",
    "expires": "Expires",
    "never_used": "Never used",
    "revoke": "Revoke",
    "revoke_confirm": "Revoke “{{name}}”? Claude using this key stops working within 5 minutes.",
    "revoke_all": "Revoke all",
    "revoke_all_confirm": "Revoke all {{n}} keys? They stop working within 5 minutes.",
    "revoked": "Revoked",
    "expired": "Expired",
    "empty": "Create a key so Claude can look up devices, events and alarms with your permissions.",
    "need_mfa": "Turn on two-step verification (authenticator app or passkey) before creating an API key.",
    "create": "Create key",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "limit_hint": "A key can never do more than you can right now; team organizations need an admin to allow API keys in the security policy. Creating, changing scopes, rotating and revoking require verifying your identity within the last 5 minutes.",
    "media_confirm": "I understand Claude can download images and recording clips from these devices to my computer (every download is logged)",
    "console_confirm": "I understand: AI assistants or tools can read and write the serial port of the device attached to the Kinio Node",
    "control_confirm": "I understand: AI assistants or tools can control devices I have access to and change settings as me, including Kinio Node commands and Kinio Station local settings",
    "pairing_confirm": "I understand: Claude or tools can use my linked developer account quota to start \"allocate AID during pairing\" sessions for me (DEV cloud only)",
    "scope_devices_read": "Devices",
    "scope_devices_read_hint": "Devices, $t(leaf.cur_lc_pl) and the org tree, status and settings, OTA status, Kinio Node / Station",
    "scope_events_read": "Events and alarms",
    "scope_events_read_hint": "Event list, alarms and handling state",
    "scope_recordings_read": "Recording timeline",
    "scope_recordings_read_hint": "When there is recorded video (no video itself)",
    "scope_alarms_handle": "Handle alarms",
    "scope_alarms_handle_hint": "Mark alarms as seen / handling / resolved / false alarm",
    "scope_devices_console": "Kinio Node console",
    "scope_devices_console_hint": "Read and write the serial port of the device attached to a Kinio Node (writing needs a management role), including LAN direct tokens",
    "scope_devices_control": "Control devices",
    "scope_devices_control_hint": "Turn devices on/off, PTZ, recording settings, automations, Kinio Node commands and Kinio Station local settings, as you (per your role). Deleting, factory reset, formatting and other data-erasing actions are not allowed",
    "scope_pairing_allocate": "Allocate AID during pairing (dev only)",
    "scope_pairing_allocate_hint": "Start an \"allocate AID during pairing\" session in your DEV $t(leaf.cur_lc) using the quota of your linked developer account; the device still has to be set up on site",
    "scope_media_snapshot_read": "Snapshots",
    "scope_media_snapshot_read_hint": "Event snapshots, the latest snapshot, live capture and recording thumbnails (up to 60 per hour)",
    "err_API_KEY_MFA_REQUIRED": "Turn on two-step verification before creating an API key.",
    "err_API_KEY_LIMIT": "You can have at most 5 active keys; revoke one you no longer use.",
    "err_API_KEY_PROD_WRITE": "Keys in this environment can only have read scopes.",
    "err_FEATURE_DISABLED": "API keys aren't offered in this environment.",
    "err_default": "Didn't work ({{code}})",
    "scope_media_clip_read": "Recording clips",
    "scope_media_clip_read_hint": "Download links for up to 60 seconds of cloud recording (up to 20 a day, 10 minutes total; needs export permission)",
    "rotate": "Rotate",
    "rotate_confirm": "Rotate “{{name}}”? A new key with the same name, scopes and lifetime is created (shown only once). The old key stops working after 24 hours and works as usual until then.",
    "rotated": "Rotated",
    "rotated_until": "stops working {{at}}",
    "rotated_created": "Rotated “{{name}}” — the new key is shown only this once:",
    "rotated_old_until": "The old key keeps working until {{at}}. Once Claude uses the new key, you can revoke the old one from the list.",
    "err_API_KEY_ROTATED": "This key has already been rotated; use the new one.",
    "edit_scopes": "Change scopes",
    "edit_scopes_title": "Change scopes of “{{name}}”",
    "edit_scopes_hint": "The key stays the same, so Claude needs no changes; takes effect within 5 minutes.",
    "save_scopes": "Save scopes",
    "scopes_saved": "Scopes updated. Claude needs no changes; takes effect within 5 minutes.",
    "err_NOT_FOUND": "This key doesn't exist or has been revoked / expired.",
    "err_INVALID_ARGUMENT": "Invalid scopes; please select again.",
    "scope_devices_maintain": "Rename and update firmware",
    "scope_devices_maintain_hint": "Rename devices, update firmware now and change auto-update settings (needs maintenance permission)",
    "maintain_confirm": "I understand: AI assistants or tools can rename my devices and update firmware now (devices go offline for a few minutes while updating)",
    "scope_vms_organize": "Organize VMS",
    "scope_vms_organize_hint": "My layouts, views, device groups, saved searches, bookmarks and preferences; rooms, floor plans and placements of a $t(leaf.cur_lc)",
    "group_read": "Read",
    "group_media": "Images (off by default)",
    "group_write": "Write (off by default)"
  },
  "zed": {
    "snapshot_loading": "Loading the latest snapshot…",
    "live_connecting": "Loading live video…",
    "no_snapshot": "No snapshot yet. Select View live to load the picture",
    "live_unavailable": "Live video unavailable. You can still edit",
    "snapshot_shown": "Background is the latest event snapshot",
    "view_live": "View live",
    "back": "Back",
    "clear_all": "Clear all",
    "saving": "Saving…",
    "saved": "Saved",
    "mode_full": "Full frame",
    "mode_zones": "Selected zones",
    "kept_hint": "Your {{count}} drawn zones are kept; switch back to Selected zones to use them",
    "surface": "Detection zone editor",
    "zone_label": "Zone {{n}}",
    "delete": "Delete zone {{n}}",
    "full_frame": "Full frame",
    "count_one": "1 zone",
    "count": "{{count}} zones",
    "limit_counter": "{{count}} / {{max}}",
    "read_only": "Detection zones can't be changed right now.",
    "limit": "Up to {{max}} zones",
    "reported_updated": "Updated to what the device reported.",
    "hint": "Drag on an empty area to draw a zone; select a zone to move it or drag its corners to resize. Press Delete to remove it.",
    "hint_full": "Full-frame detection: the whole picture can trigger. Choose Selected zones to limit it.",
    "discard_title": "Discard unsaved changes?",
    "discard_body": "Your detection zone changes haven't been saved and will be lost.",
    "discard_body_schedule": "Your schedule changes haven't been saved and will be lost.",
    "discard": "Discard",
    "tpl_all_day": "All day",
    "tpl_night": "Night (18:00-06:00)",
    "tpl_office": "Office hours (Mon-Fri 09:00-18:00)",
    "tpl_clear": "Clear",
    "device_tz": "Device time zone: {{tz}}",
    "read_only_schedule": "The schedule can't be changed right now.",
    "hint_schedule": "Drag to paint: starting on an off cell turns cells on, starting on an on cell turns them off. Each cell is 30 minutes.",
    "sum_all_day": "All day",
    "sum_off": "Off",
    "sum_custom": "Custom",
    "edit": "Edit",
    "view": "View",
    "offline": "The device is offline. Changes are unavailable for now",
    "no_write": "You don't have permission to change this setting",
    "load_failed": "Couldn't read the device's current zone settings, so this is view-only for now. Try again later",
    "layers": "Layers",
    "mask_off": "Off",
    "mask_count_one": "1 mask",
    "mask_count": "{{count}} masks",
    "mask_mode_off": "Off",
    "mask_mode_on": "On",
    "mask_kept_hint": "Your {{count}} drawn masks are kept; switch back to On to use them",
    "mask_warn": "Masks are blacked out on the device before encoding: they are hidden in live video, recordings and snapshots and cannot be removed later. Motion inside a mask does not trigger detection.",
    "mask_label": "Mask {{n}}",
    "mask_delete": "Delete mask {{n}}",
    "mask_limit": "Up to {{max}} masks",
    "mask_hint": "Drag on an empty area to draw an area to hide; select a mask to move it or drag its corners to resize. Press Delete to remove it.",
    "mask_hint_off": "Privacy masks are off: nothing is hidden. Choose On to hide areas.",
    "read_only_masks": "Privacy masks can't be changed right now.",
    "discard_body_masks": "Your privacy mask changes haven't been saved and will be lost.",
    "grid_full_frame": "Full frame",
    "grid_custom": "Partial area",
    "grid_cells": "Detecting {{count}} of {{total}} cells",
    "grid_fill": "Select all",
    "grid_clear": "Clear",
    "grid_cell": "Row {{row}}, cell {{col}}",
    "grid_hint": "Drag across cells: start on an unselected cell to add, on a selected cell to remove. No cells selected means full-frame detection."
  },
  "poe": {
    "title": "{{n}} new cameras are asking for an address",
    "new_camera": "New camera detected",
    "port": "PoE port {{port}}",
    "asked": "Asked {{count}} times (first {{first}}, last {{last}})",
    "suspect_uplink_ip": "This address looks like a device on the uplink network (such as a router or a computer), not a camera on a PoE port. It can't be added in one step; enter a reason to add it anyway.",
    "suspect_uplink_arp": "This device is visible on the uplink network (it may be connected upstream). It can't be added in one step; enter a reason to add it anyway.",
    "suspect_other": "This may not be a camera on a PoE port. It can't be added in one step; enter a reason to add it anyway.",
    "approve": "Add",
    "ignore": "Ignore",
    "force_reason": "Reason for adding anyway (at least 5 characters)",
    "force": "Add anyway",
    "waiting_ip": "Approved. Waiting for the camera to get an address (up to 2 minutes)…",
    "got_ip": "The camera got address {{ip}}. Enter the camera's username and password to connect it to a channel.",
    "own_camera": "This is a Kinio camera. The NVR connects it to a channel by itself; no password needed.",
    "add_channel": "Connect to a channel",
    "added": "Connected to a channel.",
    "no_ip": "The camera didn't get an address within 2 minutes. Check the cable and power, then try again.",
    "err_SUSPECT_UPLINK": "This device may be on the uplink network. Enter a reason to add it anyway",
    "err_NOT_PENDING": "This device is no longer waiting for approval (someone may have handled it)",
    "err_BAD_IP": "That address can't be used (outside the PoE network or already assigned)",
    "err_default": "The action failed ({{code}})",
    "wait_again": "Wait again",
    "block_title": "New PoE cameras (open to check for approvals)",
    "none": "No PoE cameras are waiting for approval.",
    "unsupported": "This device doesn't support PoE approvals; use “Add ONVIF camera” instead."
  },
  "moment": {
    "title": "Same moment",
    "help": "Pick a moment to see every camera in scope at that time: cloud thumbnails where there is a cloud recording, otherwise the frame from the NVR disk or SD card. Click a tile to play back from that moment.",
    "at": "Time",
    "browser_tz": "Time is picked in your browser time zone ({{tz}}); each tile shows the site's local time",
    "filter": "Filter camera names",
    "none": "No cameras you can play back in this scope",
    "no_frame": "No cloud frame",
    "more": "{{n}} more cameras not shown (up to {{max}} at a time). Filter or change the scope to narrow it down",
    "all_empty": "None of these cameras has a frame at this moment (nothing from cloud, NVR disk or SD card). Try another time, or use single playback to see recordings before and after.",
    "go_single": "Single playback",
    "clip_suspect": "⚠ Cloud clip may be incomplete",
    "clip_suspect_hint": "The cloud clip at this moment has an implausible length; the thumbnail may be green or frozen. Playback will look for other sources first.",
    "no_cloud_at": "No cloud recording at this time",
    "from_local": "Frame from {{src}} (no cloud recording at this time)",
    "no_rec_at": "No recording at this time",
    "local_has": "The {{src}} has a recording at this time (no thumbnail)",
    "local_unknown": "No cloud recording; couldn’t read the {{src}} (open Playback to check)",
    "no_cloud_scope": "No camera in this scope has cloud recording in the last two months; cameras with local recording (NVR / Station disk, SD card) show a local frame."
  },
  "hnodes": {
    "intro": "Kinio Node boards attached to this Host. Power, reset and flashing are done by an admin of the organization that holds the Host.",
    "none": "No nodes are attached to this Host.",
    "unknown": "Unknown",
    "col_node": "Node",
    "col_health": "Health",
    "col_fw": "Firmware",
    "col_seen": "Last response",
    "col_thing": "Node device",
    "h_healthy": "Healthy",
    "h_busy": "In use",
    "h_unhealthy": "Unhealthy",
    "h_unknown": "Unknown",
    "not_visible": "Not in this $t(leaf.cur_lc), or no access",
    "no_aid": "Node AID not read yet"
  },
  "localvms": {
    "tab": "Local VMS",
    "title": "Local VMS when the internet is down",
    "intro": "If the internet goes down, this site's Station can still show live video and hard-drive playback in a browser. Register each computer once while it is online.",
    "no_stations": "No Station can be registered. Sites you can access through an organization share or delegation are cloud-only.",
    "col_station": "Recorder",
    "col_home": "$t(leaf.cur)",
    "col_offline": "Offline use",
    "not_allowed": "Offline use is off for this site",
    "allowed": "On",
    "max_hours": "Up to {{n}} h",
    "open_here": "Open local VMS on this computer",
    "ask_admin": "Ask an organization admin to turn it on in the site settings",
    "not_ready": "Local address not ready yet (the Station must be online)",
    "fixed_ip_hint": "Reserve a fixed address (fixed IP) for the Station on your router so the backup address keeps working.",
    "enrolled_title": "Registered computers",
    "enrolled_empty": "No computers registered yet.",
    "col_computer": "Computer",
    "col_updated": "Last updated",
    "col_expires": "Expires",
    "fallback_update": "Backup address needs update",
    "expired": "Expired",
    "expires_in": "Expires in {{n}} d",
    "days_left": "{{n}} d left",
    "pin_locked": "PIN locked (until {{until}})",
    "reset_pin": "Reset PIN",
    "redo": "Register again",
    "redo_unavailable": "This Station cannot be registered now (offline use is off, or the local address is not ready)",
    "revoke": "Revoke",
    "revoke_confirm": "Revoke \"{{label}}\"?",
    "revoke_body": "This computer will no longer open the local view of \"{{station}}\" when offline. If the Station is offline now, it stops when the Station reconnects or the offline period ends, whichever comes first.",
    "revoked": "Revoked \"{{label}}\".",
    "pin_lock_hint": "Too many wrong PINs lock it for a while. While online, Reset PIN (requires verifying your identity) makes it usable right away. While offline, a store admin can unlock it on the Station screen.",
    "pin_reset_done": "PIN for \"{{label}}\" has been reset.",
    "reset_pin_title": "Reset local PIN for \"{{label}}\"",
    "reset_pin_body": "The new PIN takes effect when the Station is online, and the error count is cleared.",
    "pin_label": "Local PIN for this computer (6 digits, entered when signing in offline)",
    "stepup_note": "Next you will verify your identity (password + verification code).",
    "pin_invalid": "The PIN must be exactly 6 digits.",
    "reset_pin_submit": "Verify and reset",
    "err_default": "Not completed ({{code}}). Please try again.",
    "err_REAUTH_REQUIRED": "Identity verification is required to finish.",
    "err_OFFLINE_NOT_ALLOWED": "Offline use is off for this site.",
    "err_CLOUD_REQUIRED": "This site is cloud-only for you (access through an organization share or delegation).",
    "err_NOT_FOUND": "This registration was not found.",
    "req_missing_title": "Registration not found",
    "req_missing": "The link is incomplete. Go back to Settings > Local VMS and start again.",
    "back": "Back to Local VMS settings",
    "done_title": "This computer is registered",
    "done_body": "Go back to the local tab of \"{{station}}\"; it will show that registration is complete. When offline, open the main address (bookmarked); if the name does not resolve, open the backup address (view only).",
    "expired_title": "This registration expired",
    "expired_body": "Registration must be completed within 5 minutes. Go back to the list and start again.",
    "no_tab_title": "The new tab did not open the local view?",
    "no_tab_body": "This computer must be on the local network of \"{{station}}\" (the same in-store network) to register.",
    "no_tab_continue": "If the new tab did open, continue there.",
    "waiting_title": "Waiting for the local view",
    "waiting_body": "The local view of \"{{station}}\" opened in a new tab. When you finish there, this page switches to the confirmation step automatically.",
    "popup_blocked": "The browser blocked the new tab. Click Open again.",
    "reopen": "Open again",
    "confirm_title": "Let this computer view \"{{station}}\" offline?",
    "computer_name": "Computer name",
    "computer_name_ph": "e.g. Control room PC-1",
    "confirm_body": "How long it works offline follows the site setting. While online the platform refreshes it daily, so this computer does not need to stay on. Access follows your role in this $t(leaf.cur_lc). Bound to this computer only; register again at least every 30 days.",
    "code_main": "Check code (main address):",
    "code_hint": "Continue only if it matches the local tab",
    "fallback_label": "Backup address:",
    "fallback_attached": "Added (view only)",
    "fallback_waiting": "Waiting",
    "fallback_hint": "Used when the name does not resolve; offline sign-in also needs the PIN below. If it still says Waiting when you confirm, the backup address is not registered.",
    "approve": "Verify and register",
    "with_fallback": "with backup address (view only)",
    "pin_locked_plain": "PIN locked",
    "someone": "User ...{{id}}",
    "home_title": "Other registrations in this $t(leaf.cur_lc)",
    "home_hint": "As the $t(leaf.cur_lc) owner or admin you can revoke computers other people registered on these Stations. This only stops local VMS on that computer; their app is not affected.",
    "col_person": "Registered by",
    "err_LOCAL_VMS_LIMIT": "This Station has reached its computer limit ({{limit}}). Revoke a computer you no longer use first.",
    "err_LOCAL_VMS_REQUEST_EXPIRED": "This registration expired (5 minutes). Please start again.",
    "err_LOCAL_VMS_ALREADY_APPROVED": "This registration was already confirmed.",
    "err_LOCAL_VMS_KEY_PENDING": "The local tab has not finished setting up this computer yet. Continue in the local tab.",
    "err_LOCAL_VMS_ENROLLMENT_EXPIRED": "This computer's registration has expired. Please register again.",
    "err_INVALID_ARGUMENT": "A computer name is required (up to 64 characters) and the PIN must be 6 digits.",
    "not_allowed_short": "Off",
    "not_allowed_banner_one": "{{count}} recorder is in a site without offline access, so it can't be enrolled yet. Ask an org admin to turn it on in Org & sites › Site settings.",
    "not_allowed_banner_other": "{{count}} recorders are in sites without offline access, so they can't be enrolled yet. Ask an org admin to turn it on in Org & sites › Site settings."
  },
  "nenr": {
    "tab": "Kinio Node enrollment",
    "title": "Kinio Node enrollment — {{name}}",
    "just_now": "just now",
    "min_ago": "{{n}} min ago",
    "hour_ago": "{{n}} h ago",
    "quota_title": "Enrollment credits",
    "no_quota": "This organization has no Kinio Node enrollment credits yet. Credits are allocated by the platform; contact your reseller or the platform.",
    "quota_line": "{{type}}: {{n}} left",
    "alloc_line": "Allocated {{date}}, {{n}} left",
    "find_title": "Find a node",
    "find_help": "On the node console, run enroll_status and paste the whole line, or just the 16 characters after fp=.",
    "enroll_url": "This platform's enrollment URL: {{url}}",
    "find_placeholder": "state=pending url=… keypwd=1 … fp=…",
    "find": "Find",
    "name_hint": "The node's Wi-Fi / Bluetooth name only shows the last 6 characters of the MAC and can't be used here.",
    "bad_fp": "Couldn't find the 16 hex characters after fp=.",
    "wrong_platform": "This board enrolls with a different platform. Use fac_set enroll on the console to set it to {{url}}.",
    "not_found": "No node that can be enrolled was found",
    "check_fp": "You pasted the 16 characters after fp= (or the whole enroll_status line)",
    "check_pending": "The node is still enrolling (enroll_status shows state=pending)",
    "check_url": "The node's url= is this platform's enrollment URL {{url}}",
    "check_quota": "This organization has credits for this model",
    "contact": "Still stuck? Contact the platform with: fingerprint prefix {{fp8}}, time {{at}}.",
    "fw": "Firmware",
    "last_seen": "Last check-in",
    "maybe_offline": "The node may be offline",
    "mac_conflict": "This MAC has two enrollment records. Contact the platform.",
    "keypwd_missing": "The board has no enrollment password yet: run fac_set keypwd … on the console first.",
    "identify": "Blink",
    "identify_waiting": "Waiting for the node to check in (within about a minute); it will blink white for 30 s",
    "identify_blinking": "Blinking white (30 s)",
    "identify_missed": "The node didn't check in within 90 s and may be offline",
    "approve": "Enroll…",
    "approve_title": "Enroll Kinio Node",
    "alloc": "Allocation",
    "alloc_pick": "Choose one",
    "note": "Note (optional)",
    "note_placeholder": "One line, up to 200 characters; no email, phone or address",
    "note_bad": "The note must be one line, up to 200 characters",
    "approve_explain": "This uses one of {{name}}'s enrollment credits ({{n}} left after this) and the board will belong to {{name}}. You can't undo it yourself; contact the platform if it was a mistake.",
    "confirm": "I confirm this board belongs to our organization (the fingerprint came from its console, or I saw it blink)",
    "approve_do": "Enroll",
    "wait_online": "Enrolled. Waiting for the node to come online (it picks up its identity at the next check-in, within about a minute)",
    "now_online": "Online",
    "not_online_long": "The node isn't online yet. The enrollment password (keypwd) on the board may not match this allocation; contact the platform.",
    "approved_title": "Enrolled by this organization",
    "approved_empty": "No nodes enrolled yet.",
    "col_at": "Enrolled at",
    "col_model": "Model",
    "col_by": "Enrolled by",
    "col_note": "Note",
    "col_state": "Status",
    "by_member": "A member",
    "by_platform": "Platform",
    "online": "Online",
    "last_online": "Last online {{at}}",
    "revoked": "Revoked",
    "revoked_hint": "After the platform revokes it, run fac_cred clear on the board's console and reboot for it to enroll again.",
    "pair_hint": "To put it in a $t(leaf.cur_lc), add it to the $t(leaf.cur_lc) with the app's local network pairing.",
    "err_gone": "This node can't be enrolled now (it may have been enrolled or handled by the platform). Find it again.",
    "err_lookup_limit": "Too many unsuccessful searches. Try again after {{at}}.",
    "err_daily_cap": "You've enrolled 100 nodes in the last 24 hours. Try again after {{at}}, or ask an organization admin.",
    "err_no_quota": "This allocation is used up. Choose another or ask the platform.",
    "err_alloc": "This allocation can't be used for this node.",
    "err_mac_in_use": "This MAC already belongs to another active device identity. Contact the platform.",
    "err_forbidden": "Your permissions have changed. Refresh the page.",
    "err_unavailable": "Enrollment is temporarily unavailable. Try again later."
  },
  "ncon": {
    "close": "Close",
    "status_idle": "Not connected",
    "status_ticket": "Requesting ticket…",
    "status_connecting": "Connecting…",
    "status_opening": "Waiting for the device…",
    "status_open": "Connected",
    "status_reconnecting": "Device reconnecting…",
    "status_closed": "Disconnected",
    "reason_device_offline": "Device offline",
    "reason_data_lost": "Some output could not be recovered",
    "reason_session_superseded": "Replaced by a newer connection (firmware cannot resume)",
    "reason_device_revoked": "Device revoked",
    "reason_DEVICE_OFFLINE": "Device is offline; try again when it is back",
    "reason_RATE_LIMITED": "Too many attempts; try again shortly",
    "reason_NOT_FOUND": "You do not have access to this device",
    "reason_NOT_SUPPORTED": "This device has no terminal",
    "reason_NETWORK": "Cannot reach Kinio",
    "role_me": "You can type",
    "role_other": "Someone else is typing; view only",
    "role_none": "Nobody is typing",
    "take": "Take control",
    "release": "Release control",
    "lost": "{{n}} bytes were lost while reconnecting.",
    "rebooted": "The device rebooted.",
    "dropped": "Network too slow; {{n}} output chunks dropped.",
    "in_dropped": "The device could not keep up; {{n}} input bytes were not delivered.",
    "err_NOT_WRITER": "You do not have control",
    "err_RATE_LIMITED": "Typing too fast; try again shortly",
    "err_DEVICE_RECONNECTING": "Device reconnecting; try again shortly",
    "input_ro": "Take write control to type (keys are not sent)",
    "title": "Terminal",
    "via_platform": "via Kinio platform",
    "auto_reconnect": "Connection lost, reconnecting",
    "clear": "Clear",
    "reconnect": "Reconnect",
    "popout": "New window",
    "tunnel": "Copy connect command",
    "tunnel_hint": "Run this in your own terminal. nodectl picks the route automatically: direct when you are on the same LAN as the Kinio Node, otherwise relayed through the Kinio platform. Ctrl-] to quit.",
    "tunnel_step_download": "Get nodectl: the Kinio Node package under Platform tools in the developer portal (macOS, Linux, Windows).",
    "tunnel_step_key": "Key: set your own VMS key as KINIO_VMS_KEY; the key needs the \"Kinio Node LAN console\" scope.",
    "tunnel_key_link": "Go to API keys",
    "tunnel_step_writer": "If the web terminal is open at the same time, its write control works as usual; a direct nodectl connection does not go through it.",
    "copy": "Copy",
    "copied": "Copied",
    "direct": "Advanced: connect directly with your own tool",
    "direct_hint": "Only if you want to connect to this Kinio Node with your own tool: get a short-lived direct token and the LAN address (8788, kttl/2). Normally use the web terminal or the nodectl command above; they route automatically.",
    "direct_confirm": "I understand: whoever has the token can read and write the serial port of the device wired to this Kinio Node",
    "direct_get": "Get direct token",
    "direct_addr": "LAN address",
    "direct_token": "Token",
    "direct_no_lan": "The node has not reported a LAN address; connect through the platform (nodectl ttl relays automatically)",
    "direct_token_once": "Shown only once ({{id}}), expires {{at}}",
    "reason_FIRMWARE_UNSUPPORTED": "Node firmware too old (needs 1.0.52+)",
    "connect_ro": "Connect (read-only)",
    "intro": "This is the serial console (root shell) of the device attached to this Kinio Node, for installers and developers. Once connected you can see commands and output from anyone else using it. You connect read-only first; take write access when you need to type.",
    "take_ellipsis": "Take write access…",
    "take_confirm_title": "Type commands on {{name}}'s serial console?",
    "take_confirm_body": "What you type goes straight to the device as root. Anyone else connected becomes read-only.",
    "take_confirm_others": "Someone else is connected now; this takes write access away from whoever is typing.",
    "others_n_one": "{{count}} other person connected",
    "others_n_other": "{{count}} other people connected",
    "need_admin": "Only admins can type here (org admins, node admins, installers, or the $t(leaf.cur_lc) owner / admin). You can still watch the output.",
    "write_forbidden": "Your role can't type on this device; an admin is needed (org admin, node admin, installer, or the $t(leaf.cur_lc) owner / admin). Switched back to read-only.",
    "reason_FORBIDDEN": "Only admins can get a direct token (it allows typing on this device)"
  },
  "devacct": {
    "tab": "Developer account",
    "title": "Developer account",
    "hint": "Link a developer portal account to this account: enter the 8-character code generated under [App account links] in the developer portal. The developer account can then use its AID quota to pair devices in this account, but it cannot see your video, events or recordings.",
    "code_label": "Link code (8 characters)",
    "next": "Next",
    "where": "In the developer portal: Account & security › App account links › Generate link code.",
    "where_dev": "In the DEV developer portal: Account & security › App account links › Generate link code (valid for 10 minutes, single use).",
    "confirm_title": "Link this developer account?",
    "confirm_who": "{{email}} (developer account) wants to link this account. Confirm only if both accounts are yours; never confirm a code someone else sent you.",
    "confirm_can_dev": "After linking, this developer account can: use its AID quota to pair devices without an AID in this account; put cloud emulated dev devices into DEV homes you own or manage; let members of its developer organizations push dev firmware to their models in your DEV homes; let this account create homes in the DEV cloud. It cannot see your video, events or recordings. You can unlink any time under “Developer account”.",
    "confirm_can_prod": "After linking, this developer account can: use its AID quota to pair devices without an AID in this account; add this account to its product test rounds. It cannot see your video, events or recordings. You can unlink any time under “Developer account”.",
    "confirm": "Confirm link",
    "linked_done": "Linked {{email}}.",
    "linked_at": "Linked {{date}}",
    "unlink": "Unlink",
    "unlink_confirm": "After unlinking, AIDs can no longer be allocated through this account and the developer cannot push firmware to its dev devices.",
    "kind_grant": "Quota grant",
    "grant_title": "Accept this developer account’s AID quota grant?",
    "grant_who": "{{email}} (developer account) wants to grant its AID quota to this app account. This is not necessarily your own account — confirm only if you recognize it and agree to let it pair devices with your account; if unsure, do not confirm and report it to {{brand}}.",
    "grant_can": "After accepting, this developer account can: use its AID quota to pair devices without an AID in your account (there is a daily limit, and you are notified every time). It cannot see your devices, video, events or recordings, and cannot push firmware, place emulators, or create homes in your account. You can unlink any time under “Developer account”.",
    "grant_confirm": "Confirm grant",
    "grant_done": "Accepted the AID quota grant from {{email}}.",
    "grant_linked_at": "Grant accepted {{date}}",
    "grant_unlink_confirm": "After unlinking, this developer account can no longer use its quota to pair devices with your account. Paired devices stay with you.",
    "err_LINK_CODE_GONE": "The link code is invalid or expired. Generate a new one in the developer portal.",
    "err_gone_dev_hint": "If the code came from the DEV developer portal, confirm it with a DEV cloud account.",
    "err_LINK_POOL_MISMATCH": "This code must be confirmed with an account of another app.",
    "err_APP_ACCOUNT_LINKED": "This account is already linked to another developer account. Unlink it first.",
    "err_APP_LINK_EXISTS": "That developer account is already linked to another account of this app. Unlink it in the developer portal first.",
    "err_LINK_TARGET_MISMATCH": "This code is not for this account. Ask the sender to generate a new one with this app account’s email.",
    "err_RATE_LIMITED": "Too many attempts, please try again later.",
    "err_INVALID_ARGUMENT": "The link code is 8 letters or digits.",
    "err_REAUTH_REQUIRED": "Verify your identity again before confirming.",
    "err_WRONG_ACCOUNT_POOL": "A developer account cannot confirm here. Sign in with an app account.",
    "err_default": "Not completed ({{code}})"
  },
  "navg": {
    "watch": "Monitor",
    "manage": "Devices & sites",
    "org": "Organization"
  },
  "orggate": {
    "capsule": "Organization: {{name}}",
    "pick_title": "Which organization do you want to manage?",
    "pick_body": "The current scope is All. Pick an organization; the scope at the top switches to it too.",
    "your_role": "Your role: {{role}}",
    "devices_one": "{{count}} device",
    "devices_other": "{{count}} devices"
  },
  "time": {
    "just_now": "Just now",
    "min_ago_one": "{{count}} minute ago",
    "min_ago_other": "{{count}} minutes ago",
    "hour_ago_one": "{{count}} hour ago",
    "hour_ago_other": "{{count}} hours ago",
    "day_ago_one": "{{count}} day ago",
    "day_ago_other": "{{count}} days ago"
  },
  "user": {
    "me": "Me",
    "menu": "Account menu",
    "tz": "Time shown in",
    "tz_site": "Site time zone",
    "tz_browser": "My time zone",
    "version": "{{brand}} · version {{version}} (web {{build}})",
    "version_copy": "Copy version info",
    "version_copied": "Copied",
    "map_provider": "Map provider",
    "map_auto": "Automatic by region"
  },
  "gsearch": {
    "label": "Search",
    "placeholder": "Search devices, sites, people, pages…  {{key}}",
    "g_pages": "Pages",
    "g_devices": "Devices",
    "g_places": "Sites & $t(leaf.cur_lc_pl)",
    "g_people": "People",
    "g_events": "Events",
    "in_events": "Search events for “{{q}}”",
    "places_failed": "Couldn't search sites and $t(leaf.cur_lc_pl); other results are shown",
    "seats": "Cloud recording seats",
    "syn_overview": "home,dashboard,health",
    "syn_live": "video wall,cameras,live view",
    "syn_playback": "recordings,timeline",
    "syn_events": "alarms,detections,alerts",
    "syn_map": "floor plan,location",
    "syn_exports": "export,download,evidence,verify",
    "syn_devices": "cameras,NVR,add device,pair",
    "syn_firmware": "firmware,update,OTA,version",
    "syn_inventory": "inventory,claim,serial,unassigned,detected",
    "syn_enroll": "enroll,Kinio Node,node",
    "syn_sites": "sites,structure,nodes,floors,assign",
    "syn_rules": "rules,automation,scenes",
    "syn_backup": "backup,off-site",
    "syn_people": "members,permissions,roles,sharing,delegation,invite",
    "syn_audit": "audit,log,history",
    "syn_billing": "plan,billing,payment,subscription,purchase",
    "syn_seats": "seats,cloud recording",
    "syn_org": "organization,security policy,MyCam policy,level names",
    "syn_account": "account,settings,two-step verification,password,passkey,sessions",
    "syn_apikeys": "API keys,API,token",
    "syn_notify": "notification settings,do not disturb,email",
    "syn_verify": "verify,evidence,SHA-256,signature",
    "syn_access": "access,permissions,grant,$t(leaf.cur_lc) members,share,assign",
    "syn_external": "external,delegation,delegation code,shared with organization",
    "g_other": "Other scopes",
    "only_other": "Nothing in the current scope; {{n}} result(s) in other scopes (opening one switches scope)",
    "syn_shares": "share,link,recipient,revoke,watermark"
  },
  "devtabs": {
    "all": "All devices",
    "firmware": "Firmware",
    "inventory": "Inventory",
    "add": "Add",
    "add_kinio": "Add a Kinio device",
    "add_onvif": "Add an ONVIF camera",
    "add_enroll": "Enroll a Kinio Node",
    "add_claim": "Claim by serial number",
    "enroll": "Enrollment",
    "add_kinio_channel": "Put a Kinio camera on a recorder channel"
  },
  "toastpref": {
    "title": "Pop-up notifications",
    "help": "Whether new notifications pop up at the bottom right. Only this computer; everything still appears under the bell.",
    "alarm": "Alarms only (recommended)",
    "alarm_help": "Detections while armed, sensor triggers, doorbell, account security",
    "alarm_detect": "Alarms and detections",
    "alarm_detect_help": "Also ordinary motion, person and vehicle detections",
    "none": "Never",
    "none_help": "Bell only (no alarm cards either; the video-wall cell still works)"
  },
  "iam": {
    "tab_access": "Access",
    "tab_external": "External",
    "left_member": "Former member",
    "a_group": "Member group",
    "an_org": "Another organization",
    "org_role_other": "Other role",
    "home_role": "$t(leaf.cur) {{role}}",
    "src_org_role": "Org role",
    "src_home_role": "$t(leaf.cur) role",
    "src_site_grant": "Site grant",
    "src_node_assignment": "Node assignment",
    "src_share": "Share",
    "src_delegation": "Delegation",
    "col_who": "Who",
    "col_where": "Where",
    "col_what": "Can do",
    "col_source": "Source",
    "col_term": "Until",
    "inherited_from": "Inherited from \"{{path}}\" (read-only)",
    "filter_who": "Filter by person",
    "filter_who_all": "Everyone",
    "filter_where": "Filter by place",
    "filter_where_all": "Everywhere",
    "filter_source": "Filter by source",
    "filter_source_all": "All sources",
    "grant_btn": "+ Give access",
    "empty": "No matching access.",
    "more": "Load more",
    "details": "Details",
    "revoke": "Revoke",
    "revoke_title": "Revoke {{who}}'s access to \"{{where}}\"?",
    "revoke_body": "They lose live view, playback and control here within 30 seconds.",
    "revoke_body_home_role": "They are removed from this $t(leaf.cur_lc)'s members; anything they are watching stops within 30 seconds.",
    "revoke_body_share": "The share ends; they can't see these devices within 30 seconds.",
    "revoke_body_site_grant": "The site grant is revoked; they lose access to these devices within 30 seconds.",
    "revoke_action": "Revoke access",
    "revoke_gone": "This access no longer exists. Please reload.",
    "revoked": "Revoked {{who}}'s access.",
    "refresh": "Refresh",
    "refresh_hint": "Re-expand to the devices there now (devices added later aren't included automatically)",
    "refreshed": "Re-expanded {{who}}'s access to the current devices.",
    "all_now": "All devices in this home right now (devices added later aren't included automatically)",
    "grant_title": "Give access",
    "step_who": "Who",
    "step_where": "Where",
    "step_what": "What",
    "step_term": "How long",
    "kind_member": "Member of this organization",
    "kind_member_desc": "Someone in the organization",
    "kind_group": "Member group",
    "kind_group_desc": "A group of people at once (nodes only)",
    "kind_org": "Another organization",
    "kind_org_desc": "Delegate sites to them, or share devices with a service provider",
    "kind_person": "Someone outside the organization",
    "kind_person_desc": "Share devices of one home by email",
    "person_hint": "Takes effect right away if they have an account; otherwise they get an invitation. The screen always just says \"Sent\".",
    "org_delegation": "With their delegation code",
    "org_delegation_desc": "Let another organization manage sites; they assign their own people",
    "org_share": "With their share request code",
    "org_share_desc": "Share a home's devices with an installer, guard company or monitoring center",
    "where_hint": "Pick a node (including its sub-sites and homes) or a home.",
    "where_hint_group": "Member groups can only be given nodes (including sub-sites and homes).",
    "picked": "Selected: {{where}}",
    "size_node": "Homes: {{homes}} · devices: {{devices}}",
    "size_home_one": "{{count}} device",
    "size_home_other": "{{count}} devices",
    "size_list": "{{n}} chosen devices",
    "devices_all": "All devices in this home right now (devices added later aren't included automatically)",
    "devices_list": "Only some devices",
    "devices_list_na": "Only some devices (you have no video access to this home, so you can't pick them)",
    "role_node_admin": "Manage this site (node admin)",
    "role_operator": "View and operate (operator)",
    "role_viewer": "View only (viewer)",
    "role_installer": "Install and adjust (installer)",
    "role_maintainer": "Device maintenance (maintainer)",
    "role_custom": "Custom…",
    "role_custom_desc": "Actions from a custom role template",
    "term_n_days": "Days",
    "term_max": "up to 90 days",
    "term_window_label": "Only at certain times",
    "term_days_one": "{{count}} day",
    "term_days_other": "{{count}} days",
    "term_window": "daily {{from}}–{{to}}",
    "site_grant_term": "Access to a single home always has an end date (up to 90 days); you can extend it before it ends.",
    "summary": "{{who}} can {{verb}} {{where}}{{size}}, {{term}}",
    "verb_node_admin": "manage",
    "verb_operator": "view and operate",
    "verb_viewer": "view",
    "verb_installer": "install and adjust",
    "verb_maintainer": "maintain devices",
    "verb_custom": "use \"{{name}}\" on",
    "verb_share": "\"{{what}}\" on",
    "grant_submit": "Give access",
    "done": "Gave {{who}} access to \"{{where}}\".",
    "done_share": "Share sent to {{email}}.",
    "done_org_share": "Share request approved.",
    "drawer_title": "What {{name}} can do",
    "org_role": "Org role",
    "powers": "Org permissions",
    "no_powers": "No organization permissions (see what they can access below)",
    "can_all_org": "Everything in the organization (sites, members, billing, audit, inventory, problem reports)",
    "can_org_sites": "Can manage sites and people",
    "can_org_devices": "Can manage device inventory",
    "can_org_audit": "Can view the audit log",
    "can_org_billing": "Can manage billing",
    "can_svc": "Service role: {{role}}",
    "duty": "Duty console account",
    "drawer_access": "Access by place",
    "drawer_hint": "Includes node assignments of their member groups. Each row can be revoked.",
    "drawer_need_admin": "Only organization owners and admins can see the full access list.",
    "what_can": "What {{name}} can do",
    "change_role": "Change role…",
    "edit_perms": "Org permissions…",
    "more_of": "More actions for {{name}}",
    "suspend_title": "Suspend {{name}}?",
    "suspend_body": "Their live view and playback stop within 30 seconds and they can't enter this organization. You can reactivate them later.",
    "change_role_of": "Change {{name}}'s role",
    "new_role": "New role",
    "role_before": "Before: {{role}} — {{desc}}",
    "role_after": "After: {{role}} — {{desc}}",
    "change_role_action": "Change role",
    "org_role_desc_owner": "Everything in the organization, including appointing admins",
    "org_role_desc_org_admin": "Organization, site tree, members, billing, audit, inventory; video needs separate access",
    "org_role_desc_member": "Organization member; what they see comes from node assignments, site grants, $t(leaf.cur_lc) roles or shares",
    "org_role_desc_guest": "Sees no devices by default; needs separate access",
    "org_role_desc_developer": "Developer account (develop portal work)",
    "org_role_desc_factory_ops": "Production line account (factory test and shipping)",
    "roles_hint": "Each role has one line of what it can do and one of what it can't. To give someone access, use [+ Give access] on the Access tab.",
    "roles_export_note": "Downloading / exporting recordings always has to be ticked separately; no role includes it automatically.",
    "col_layer": "Level",
    "col_can": "Can",
    "col_cannot": "Can't",
    "layer_org": "Organization",
    "layer_site": "Site",
    "layer_home": "$t(leaf.cur)",
    "layer_custom": "Custom roles",
    "custom_cannot": "Unticked actions",
    "rl_owner_name": "Owner",
    "rl_owner_how": "Org role",
    "rl_owner_can": "Everything in the organization, including appointing admins",
    "rl_owner_cannot": "—",
    "rl_org_admin_name": "Org admin",
    "rl_org_admin_how": "Org role",
    "rl_org_admin_can": "Organization, site tree, members, billing, audit, inventory and adoption",
    "rl_org_admin_cannot": "No video by itself; can't manage devices shared into the organization",
    "rl_member_name": "Member / guest",
    "rl_member_how": "Org role",
    "rl_member_can": "Membership; what they see comes from site roles, $t(leaf.cur_lc) roles or shares",
    "rl_member_cannot": "Organization matters",
    "rl_auditor_name": "Auditor",
    "rl_auditor_how": "Org permission \"can view the audit log\"",
    "rl_auditor_can": "Audit log, events",
    "rl_auditor_cannot": "Live view, playback",
    "rl_node_admin_name": "Node admin",
    "rl_node_admin_how": "Node assignment",
    "rl_node_admin_can": "All data actions in scope incl. arm / disarm, maintenance, child nodes and assignments",
    "rl_node_admin_cannot": "Sharing, $t(leaf.cur_lc) roles, recording settings, unbinding, formatting",
    "rl_operator_name": "Operator",
    "rl_operator_how": "Node assignment or site grant",
    "rl_operator_can": "Live and playback, talk, PTZ, siren, handling alarms",
    "rl_operator_cannot": "Export, settings, access",
    "rl_viewer_name": "Viewer",
    "rl_viewer_how": "Node assignment or site grant",
    "rl_viewer_can": "Live and events",
    "rl_viewer_cannot": "Playback, export, control, handling alarms (no alarm push)",
    "rl_installer_name": "Installer",
    "rl_maintainer_name": "Maintainer",
    "rl_installer_how": "Node assignment or site grant",
    "rl_maintainer_how": "Node assignment, or a site grant for single devices",
    "rl_installer_can": "Focus, aim, settings",
    "rl_maintainer_can": "See devices and status, OTA, restart, rename, see Kinio KMS monitoring",
    "rl_installer_cannot": "Playback, export, event history",
    "rl_maintainer_cannot": "Video, talk, events, playback, export, settings, access; KMS settings and actions",
    "rl_home_roles_name": "$t(leaf.cur) owner / admin / member / guest",
    "rl_home_roles_how": "$t(leaf.cur) role",
    "rl_home_roles_can": "Owner: everything in the $t(leaf.cur_lc) incl. unbinding and sharing; admin: settings, access, recording policy; member: view, playback, events, control; guest: only shared devices",
    "rl_home_roles_cannot": "Depends on role",
    "ext_out_desc": "Let another organization manage your sites; they assign their own people.",
    "ext_in_desc": "Sites other organizations let you manage.",
    "ext_shares_title": "Shared with this organization",
    "ext_shares_desc": "Devices other $t(leaf.cur_lc_pl) share with your organization show up here; you decide which members can see them.",
    "size_struct": "{{x}} (structure total)",
    "here": "This level",
    "maintenance": "Maintenance",
    "maintenance_hint": "Suspending removes all of this person's access in this organization for now; removing them is permanent and they would need a new invitation.",
    "email_need": "Enter the person's email",
    "assign_site_role": "Assign site role",
    "subtree_scope": "Covers devices in this site and inheriting child sites and $t(leaf.cur_lc_pl), including future devices. Child sites with inheritance blocked are excluded.",
    "site_admin_help": "Can view, play back, control, arm/disarm and maintain devices, and manage child sites and role assignments. Download/export requires a separate grant.",
    "site_scope_help": "Current scope: {{scope}}. To let a member manage devices here, choose “Assign site role”, then “Manage this site”. Each grant below may cover a different scope; a child-site assignment does not grant access to the whole organization.",
    "can_org_support": "Can report problems and see the organization's reports",
    "err_dup_assignment": "{{who}} already has an assignment at “{{where}}”: {{role}}, {{term}}. To change the role or term, edit that one on the Access tab instead of adding another.",
    "err_dup_assignment_unknown": "This person or group already has an assignment at “{{where}}”. To change the role or term, edit that one on the Access tab instead of adding another.",
    "dup_until": "until {{date}}",
    "dup_schedule": "limited to set hours"
  },
  "notfound": {
    "title": "Page not found",
    "body": "{{path}} isn't a VMS page. The address may be mistyped, or the page has moved.",
    "home": "Back to overview"
  },
  "nuart": {
    "row": "Device on UART (TTL)",
    "open": "Open its page",
    "label_was": "Name given when wired: {{label}}",
    "not_visible": "Not matched to a Kinio device you can see (it may not be a Kinio device, may be in another $t(leaf.cur_lc), or you lack view access), so there is no link",
    "unset": "No device has been set as connected",
    "howto": "Whoever wired it can send ttl_config with dut from fleet control, or type this on the Node console:",
    "howto_name": "name",
    "howto_model": "model",
    "old_fw": "This Node runs firmware {{v}}, which does not report the connected device yet. Update to {{min}} or later (update available: {{next}})",
    "see_fw": "See firmware",
    "rx_none": "No output received from the connected device yet",
    "rx_just_now": "The connected device printed output just now",
    "rx_recent": "The connected device printed output {{when}}",
    "rx_quiet": "No output from the connected device for over 24 hours (last {{at}}). It may be unplugged or powered off",
    "rx_node_offline": "Last output received before the Node went offline: {{when}}",
    "summary": "Device on UART (TTL): {{name}}",
    "old_fw_unreleased": "This Node’s firmware ({{v}}) does not report the connected device yet; a version that does ({{min}} or later) has not been released to the update channel"
  },
  "kinioch": {
    "title": "Kinio camera on a recorder channel",
    "help": "A Kinio Station pulls a Kinio camera into one of its channels with its own identity; the channel records, detects motion and shows on the video wall like any other. The camera doesn't need to be in the same home or site — you only need to be able to see its live view.",
    "no_station": "No Kinio Station you can manage in this scope (owner or admin needed).",
    "station": "Recorder",
    "camera": "Camera",
    "pick_camera": "Pick a camera whose live view you can see",
    "no_camera": "No Kinio camera whose live view you can see.",
    "channel": "Channel (empty = first free)",
    "channel_auto": "Auto",
    "add": "Connect",
    "whose": "Access follows the person who sets it: if you later lose this camera (a share is revoked, you leave the organization…), the channel stops until someone sets it again or removes it.",
    "added": "Connected to CH{{ch}}: {{name}}",
    "current": "Kinio camera channels on this recorder",
    "none": "None yet",
    "by_me": "Set by you",
    "by_other": "Set by someone else",
    "ok": "Working",
    "remove": "Remove",
    "denied": "The person who set it can no longer view this camera",
    "denied_not_granted": "The person who set it no longer has access to this camera",
    "denied_org_mfa_required": "The camera's organization requires two-step verification: the person who set it signs in with it and sets it again",
    "denied_ip_not_allowed": "The camera's organization doesn't allow the network it was set from",
    "denied_session_reauth": "The person who set it needs to sign in again and set it again",
    "denied_share_expired": "The share has expired",
    "denied_share_suspended": "The share is paused",
    "denied_alarm_window": "Only viewable right after an alarm",
    "denied_armed": "Only viewable while armed",
    "denied_schedule": "Outside the granted hours",
    "denied_org_suspended": "The camera's organization is suspended",
    "denied_station_rebound": "The recorder was re-bound; set it again",
    "denied_device_unbound": "The camera was unbound",
    "denied_no_assignment": "Not set",
    "err_DEVICE_NOT_FOUND": "Camera not found, or you can't see it",
    "err_FORBIDDEN": "You don't have live view access to this camera",
    "err_KINIO_SOURCE_SELF": "Can't use this recorder's own channel",
    "err_KINIO_SOURCE_UNSUPPORTED": "This recorder doesn't support Kinio camera channels",
    "err_NO_FREE_CHANNEL": "The recorder has no free channel",
    "err_ORG_MFA_REQUIRED": "The camera's organization requires two-step verification; turn it on and sign in again",
    "err_GATEWAY_OFFLINE": "The recorder is offline"
  },
  "rech": {
    "title": "Recording health",
    "table_title": "Recording health by channel",
    "col_channel": "Channel",
    "col_state": "Status",
    "state_ok": "Recording normally",
    "state_idle": "Not scheduled to record now",
    "idle_note": "Outside the recording schedule, or recording is off",
    "state_interrupted": "Recording stopped: {{reason}}",
    "since": "Since {{at}} ({{dur}})",
    "state_none": "Not reported",
    "none_note": "This recorder's firmware doesn't support it yet, or it hasn't connected to the cloud",
    "state_unreadable": "Can't read",
    "host_offline": "The recorder is offline; showing its last report ({{at}})",
    "reason_disk_repairing": "The hard disk is being repaired and is read-only for now",
    "reason_no_storage": "No recording disk found",
    "reason_no_space": "The disk is full and overwriting is off",
    "reason_io_error": "Writing to the disk failed",
    "reason_no_stream": "No video from the camera (offline or stream lost)",
    "reason_unsupported_stream": "The camera's video format can't be recorded",
    "reason_not_writing": "Should be recording but no files are being written (cause unknown)",
    "reason_unknown": "Cause unknown",
    "last_write": "Last written",
    "dropped": "Frames dropped (last hour)",
    "dropped_n": "{{n}} frames",
    "dropped_note": "Dropped when writing couldn't keep up; signal loss at the camera isn't counted",
    "fsync": "Time to save files (last hour)",
    "fsync_v": "Usually within {{p95}} ms · slowest {{max}} ms",
    "fsync_none": "No files saved in the last hour",
    "write_err": "Write failures (last 24 h)",
    "write_err_n": "{{n}}",
    "reset_note": "These numbers restart from 0 when the recorder restarts",
    "loading": "Loading…",
    "dur_lt1m": "under a minute",
    "dur_min_one": "{{count}} minute",
    "dur_min_other": "{{count}} minutes"
  },
  "lens": {
    "lens_upper": "Upper lens",
    "lens_lower": "Lower lens",
    "lens_wide": "Wide lens",
    "lens_tele": "Telephoto lens",
    "lens_left": "Left lens",
    "lens_right": "Right lens",
    "lens_n": "Lens {{n}}",
    "group": "Lens",
    "group_playback": "Playback lens",
    "filter_all": "All lenses",
    "switching": "Switching to {{name}}…",
    "switched": "Switched to {{name}}",
    "timeout": "{{name}} isn’t responding",
    "unsupported": "{{name}} isn’t available on this camera right now",
    "privacy": "{{name}} isn’t available while a privacy mask is on",
    "moved_back": "A privacy mask is on, so the view switched back to {{name}}",
    "old_fw": "This camera can only show one lens right now",
    "look": "View {{name}}",
    "timeline_main": "Recordings from {{name}}",
    "no_rec": "Recording is off for {{name}}",
    "no_rec_at": "No recording from {{name}} at this time",
    "open_settings": "Turn on in settings",
    "ask_owner": "Ask the owner to turn it on in settings"
  },
  "wb": {
    "filter": "Filter",
    "filter_all": "All",
    "filter_mine": "Assigned to me",
    "filter_overdue": "Overdue",
    "list": "Alarm list",
    "pane": "Alarm details",
    "empty": "No alarms right now",
    "empty_mine": "No unhandled alarms assigned to you",
    "empty_overdue": "No alarms past their claim time",
    "all_done": "All caught up",
    "recent_closed": "Recently closed",
    "group_security": "Unhandled (security)",
    "group_status": "Unhandled (status)",
    "group_recovered": "Unhandled (recovered)",
    "group_claimed": "In progress",
    "group_closed": "Closed",
    "group_unlisted": "Unregistered or removed device",
    "recovered": "↺ Recovered",
    "me": "me",
    "left_member": "Former member",
    "system": "System",
    "assigned_to": "Assigned to {{name}}",
    "assigned_line": "Assigned to {{name}} (by {{by}}, {{at}})",
    "assigned_now": "current",
    "assign": "Assign…",
    "assign_me": "{{name}} (me)",
    "unassign": "Unassign",
    "assign_filter": "Type a name to filter",
    "assign_none": "No one else can handle this device",
    "assign_truncated": "Showing the first 500. Type a name to filter.",
    "assign_not_eligible": "This person can’t handle alarms from this device right now",
    "assign_invalid": "This alarm can’t be assigned that way in its current state",
    "assign_closed": "Closed alarms can’t be assigned",
    "cannot": "This alarm is “{{state}}”, so “{{act}}” isn’t available",
    "conflict": "{{name}} changed it to “{{state}}”. Please check again.",
    "wave_skipped": "{{n}} already handled by someone else, skipped",
    "note_placeholder": "Note (one line, up to {{max}} characters; Enter adds the note only)",
    "note_saved": "Note added",
    "read_only": "You can only view this alarm",
    "no_media": "Not a camera, so there’s no clip",
    "live": "Live",
    "live_open": "Watch live",
    "live_offline": "Offline",
    "enlarge": "Enlarge",
    "floorplan": "Floor plan",
    "floorplan_open": "Open this floor plan on the map page",
    "related_more": "{{n}} more",
    "wave": "This wave: {{n}} times",
    "wave_more": "Show all",
    "wave_less": "Show less",
    "wave_rest": "{{n}} more",
    "unlisted": "This device isn’t in the device list (unregistered channel or removed device). It isn’t counted as unhandled and has no claim time.",
    "started_before_alarm": "This detection started before it counted as an alarm (it became one after arming, or the start record was missing).",
    "sla_left": "{{d}} left",
    "sla_over": "{{d}} overdue",
    "sla_over_now": "Overdue",
    "sla_line": "Claim within {{m}} min · {{s}}",
    "sla_recovered": "Recovered, timer stopped",
    "sla_stopped": "Claimed",
    "sla_met": "Claimed within {{d}}",
    "sla_met_late": "Claimed {{d}} late",
    "sla_src_org": "From the organization default",
    "sla_src_site": "From the node setting",
    "sla_src_share": "From {{org}} (shared) default",
    "sla_src_other_org": "another organization",
    "dur_min_one": "{{count}} min",
    "dur_min_other": "{{count}} min",
    "dur_hour_one": "{{count}} hr",
    "dur_hour_other": "{{count}} hr",
    "dur_day_one": "{{count}} day",
    "dur_day_other": "{{count}} days",
    "h_assign": "{{by}} assigned it to {{to}}",
    "h_unassign": "{{by}} unassigned it (was {{to}})",
    "h_note": "{{by}} added a note",
    "h_overdue": "Past claim time; notified {{list}}",
    "h_overdue_none": "Past claim time (no one to notify)",
    "h_overdue_merged": "Past claim time; included in the {{at}} overdue notice",
    "h_cleared": "(was assigned to {{name}})",
    "help_title": "Keyboard shortcuts",
    "help_hint": "Shortcuts don’t work while typing in a box or when a dialog is open.",
    "key_jk": "J / K (↓ / ↑)",
    "key_a": "A",
    "key_c": "C",
    "key_r": "R",
    "key_f": "F",
    "key_s": "S",
    "key_n": "N",
    "key_enter": "Enter",
    "key_x": "X",
    "key_q": "?",
    "key_esc": "Esc",
    "keydesc_jk": "Next / previous",
    "keydesc_a": "Seen",
    "keydesc_c": "I’ll handle it (take over if someone else is)",
    "keydesc_r": "Resolved (moves to the next one)",
    "keydesc_f": "False alarm (moves to the next one)",
    "keydesc_s": "Assign to a colleague",
    "keydesc_n": "Note (Enter adds the note only, Esc cancels)",
    "keydesc_enter": "Enlarge (plays the clip if there is one)",
    "keydesc_x": "Expand / collapse this wave",
    "keydesc_q": "Show shortcuts",
    "keydesc_esc": "Close the enlarged view, menu, or drawer",
    "assigned_line_noat": "Assigned to {{name}} (by {{by}})"
  },
  "sla": {
    "title": "Alarm claim time",
    "hint": "If no one takes an alarm within this time, it’s marked “Overdue” and the assignee and supervisors (organization owner, admins, node admins) are notified once. Overdue is a reminder only; the state doesn’t change. Leave blank for none.",
    "default": "Organization default",
    "security": "Security",
    "status": "Status (video signal loss)",
    "minutes": "min",
    "off": "None",
    "invalid": "Enter a whole number from 1 to {{max}}, or leave blank",
    "invalid_node": "Enter a valid number of minutes",
    "nodes": "Node overrides",
    "nodes_none": "No node overrides; everything uses the organization default.",
    "node_unknown": "(deleted node)",
    "inherit": "Inherit",
    "set": "Custom",
    "node_off": "None for this node",
    "reset": "Inherit again",
    "pick_node": "Choose a node",
    "add": "Add override"
  },
  "mycam": {
    "full_mode": "Full mode",
    "simple_mode": "Simple mode",
    "add_title": "Add an old phone as a camera",
    "add_intro": "Install MyCam on the old phone, then add it to your home with the QR code or 8-digit code shown here.",
    "home": "Home",
    "pick_home": "Choose a home",
    "create_code": "Create code",
    "steps": "On the old phone, open MyCam and scan this QR code, or enter the 8-digit code below.",
    "qr_label": "QR code for the MyCam code",
    "expires": "Valid for {{n}} min",
    "waiting": "Waiting for the old phone…",
    "compare_title": "Does the old phone show this number?",
    "compare_device": "Phone to add: {{device}}",
    "name": "Name",
    "name_default": "Living room",
    "confirm": "Yes, add it",
    "reject": "Not this phone",
    "done": "Added “{{name}}”. The old phone starts watching after its PIN is set.",
    "go_cameras": "View cameras",
    "expired": "The code has expired.",
    "plan_limit": "Your plan's camera limit is reached. Remove a camera or upgrade, then try again.",
    "no_admin_home": "You don't have a home you can add devices to (you need to be its owner or admin).",
    "brand_warn": "“{{home}}” was created in another brand's app. If you add MyCam here, your phone app won't get motion alerts. Create a new home in the phone app first, then add MyCam there.",
    "brand_keep": "Add to this home anyway",
    "add_old_phone": "Add an old phone"
  },
  "leaf": {
    "cur": "Location",
    "cur_lc": "location",
    "cur_pl": "Locations",
    "cur_lc_pl": "locations"
  },
  "support": {
    "title": "Report a problem",
    "no_right": "Ask an organization admin to tick \"Report problems\" for you under People & access › Members to report problems and see your organization's reports here.",
    "new": "New report",
    "hint": "Report problems with VMS, devices, recordings or accounts. People in your organization with the \"Report problems\" permission can see and add to them.",
    "filter": "Filter",
    "scope_all": "All",
    "scope_mine": "Mine",
    "scope_watching": "Following",
    "scope_org": "Organization",
    "load_failed": "Could not load reports. Try again later.",
    "empty": "No reports yet.",
    "new_reply": "New reply",
    "by": "By {{name}} · {{org}}",
    "status_open": "Received",
    "status_triaged": "Checking",
    "status_in_progress": "In progress",
    "status_resolved": "Resolved",
    "status_closed": "Closed",
    "cat_video": "Video and streaming",
    "cat_offline": "Device offline",
    "cat_recording": "Recording and playback",
    "cat_account": "Account and access",
    "cat_alert": "Notifications and alarms",
    "cat_other": "Other",
    "new_title": "New report",
    "new_hint": "Technical support replies here and also emails you.",
    "org": "Organization",
    "category": "Type of problem",
    "device": "Which device (optional)",
    "device_none": "No specific device",
    "subject": "Subject",
    "body": "What happened",
    "body_ph": "When it started, at which location, which views, what you did before it happened…",
    "files": "Screenshots or files (up to {{n}})",
    "file_type": "{{name}}: only images, text, JSON, ZIP or PDF",
    "file_big": "{{name}}: up to 20 MB per file",
    "file_many": "Up to {{n}} files",
    "remove": "Remove",
    "context": "Technical details attached automatically",
    "context_hint": "VMS version, browser, current page, organization, device and recent errors help support find the cause faster.",
    "blocked": "The pre-submit check found: {{summary}}. Edit and resend, or give a reason to send it as is.",
    "override": "Reason to send as is",
    "err_NOT_SUPPORT_REPORTER": "You do not have the \"Report problems\" permission in this organization. Ask an organization admin.",
    "err_BAD_ORG": "You can only report from an organization you belong to.",
    "err_RATE_LIMITED": "Too many reports in the past hour. Try again later.",
    "err_TICKET_CLOSED": "This report was closed more than 7 days ago. Please open a new one.",
    "err_generic": "Could not send ({{code}}). Try again later.",
    "upload_failed": "{{n}} attachment(s) did not upload. You can add them in a comment below.",
    "sending": "Sending…",
    "submit": "Send report",
    "not_found": "This report does not exist or you cannot see it.",
    "back": "Back to reports",
    "me": "Me",
    "member": "Colleague",
    "staff": "Technical support",
    "status_changed": "Status updated",
    "attachments": "Attachments",
    "watchers": "Following",
    "add_comment": "Add details",
    "send": "Send",
    "report_device": "Report a problem with this device"
  },
  "sso": {
    "sign_in_with": "Sign in with {{idp}}",
    "sign_in_hint": "Members of {{org}} can sign in with their company account, or use a password as usual.",
    "finishing": "Finishing company sign-in…",
    "back_home": "Back to home",
    "continue": "Continue",
    "email_reminder": "Your Kinio account email is a company address, which stops working when you leave. Consider changing it to a personal address under My account.",
    "org_unavailable": "Company sign-in is not available for this organization.",
    "start_body": "Sign in with your {{org}} company account ({{idp}}).",
    "use_password": "Sign in with your Kinio password instead",
    "step_up_title": "Company sign-in required",
    "step_up_body": "{{org}} requires company sign-in to view its resources. Your other organizations and personal homes still work.",
    "other_orgs": "Back to my other organizations",
    "verify_with": "Verify with {{idp}}",
    "break_glass_hint": "Company sign-in is down?",
    "break_glass": "Use passkey emergency access",
    "err_default": "Company sign-in did not complete ({{code}}). Please start again.",
    "err_SSO_NOT_LINKED": "This company account is not linked to a Kinio account yet. Sign in with your Kinio account first, then verify with your company account on the organization page.",
    "err_SSO_ALREADY_LINKED": "This company account is already linked to another Kinio account.",
    "err_binding": "This sign-in did not start in this browser. Please start again.",
    "err_SSO_BINDING_MISSING": "This sign-in did not start in this browser. Please start again.",
    "err_BREAK_GLASS_NOT_ALLOWED": "You are not on this organization’s emergency access list.",
    "err_PASSKEY_REQUIRED": "Verify with a passkey first.",
    "err_PASSKEY_CANCELED": "Passkey verification was canceled.",
    "err_SSO_IDP_UNAVAILABLE": "Cannot reach your company’s sign-in system. Try again later.",
    "err_idp_error": "Your company’s sign-in system returned an error. Contact your IT team.",
    "err_state": "This sign-in expired or was already used. Please start again.",
    "ff_title": "Set up your passkey",
    "ff_body": "Your account was created with your company account and doesn't have its own way to sign in yet. Set up a passkey so you can verify it's you.",
    "ff_why": "Some organizations require two-step verification, and some actions ask you to verify with your own account. Signing in with your company account only works for your company's organization. With a passkey, all of these work.",
    "ff_verified": "Verified with your company account. Select Set up passkey again.",
    "ff_unsupported": "This browser doesn't support passkeys. Use the latest Chrome, Edge, or Safari.",
    "ff_setup": "Set up passkey",
    "ff_later": "Not now",
    "ff_not_needed": "Your account already has its own way to sign in. Nothing to set up.",
    "ff_go": "Set up passkey",
    "ff_passkey_name": "First passkey",
    "no_account_title": "Sign in or create a Kinio account first",
    "no_account_body": "This company account isn't linked to a Kinio account yet. Sign in with your own Kinio account (or create one first), then go to the organization page and select \"Verify with company account\". If you just signed up, verify your email first.",
    "no_account_action": "Sign in / Create account",
    "link_pending_body": "Verify with your company account ({{idp}}) to join this organization.",
    "link_pending_dismiss": "Skip",
    "link_not_eligible": "This organization hasn't enabled you to join with your company account yet. Ask an organization admin to invite you (to your Kinio account email), or make sure the email in the company directory matches your Kinio account."
  },
  "ssoadm": {
    "title": "Enterprise SSO",
    "hint": "Require members to verify with their company account (Entra ID, Okta, Google…) to use this organization’s resources. Accounts stay personal: the company cannot touch passwords, two-step verification or personal homes.",
    "idp": "Company IdP",
    "protocol": "Protocol",
    "display_name": "Display name (shown on the sign-in button)",
    "cert": "IdP signing certificate (PEM)",
    "create": "Create",
    "test": "Test connection",
    "activate": "Enable",
    "disable": "Disable",
    "delete": "Delete IdP",
    "delete_title": "Delete the company IdP?",
    "delete_body": "Every member’s company account link is removed. You will need to set it up, test and enable it again, and members verify with their company account once more.",
    "status_draft": "Draft",
    "status_active": "Enabled",
    "status_disabled": "Disabled",
    "untested": "This version has not been tested",
    "pending": "A pending configuration takes effect after a successful test.",
    "sp_values": "Enter these values in your IdP application settings:",
    "sp_redirect_uri": "Redirect URI",
    "sp_entity_id": "SP Entity ID",
    "sp_acs_url": "ACS URL",
    "sp_metadata_url": "SP metadata",
    "domains": "Company domains",
    "domains_hint": "Verified domains show “Sign in with company account” when someone types an email in that domain. Only exact domains match; existing accounts are not changed.",
    "domain_pending": "Pending",
    "domain_verified": "Verified",
    "verify": "Verify",
    "add_domain": "Add domain",
    "require": "Require SSO",
    "require_label": "Require members to verify with their company account",
    "require_hint": "Only applies when using this organization’s resources; personal homes and other organizations work as usual. MFA is handled by your IdP.",
    "require_title": "Turn on Require SSO?",
    "require_body": "Members who have not verified with their company account are blocked from this organization (they are not signed out of their account). Members of organizations you delegated nodes to must use two-step verification instead. Break-glass list: {{bg}}.",
    "require_on": "Turn on",
    "max_age": "Verification valid for",
    "break_glass": "Emergency access (break-glass)",
    "break_glass_hint": "If the company IdP is down, people on this list can bypass SSO with a passkey; every use is audited and other admins are notified. Up to 2 people; only the owner can change it.",
    "bg_none": "(none)",
    "err_default": "Not completed ({{code}})",
    "err_SSO_IDP_INVALID": "The IdP configuration is invalid or unreachable ({{reason}})",
    "err_SSO_IDP_UNTESTED": "Run “Test connection” once before enabling.",
    "err_SSO_REQUIRED_ON": "Require SSO is on; turn it off before disabling or deleting the IdP.",
    "err_SSO_NOT_CONFIGURED": "Set up and enable the company IdP before requiring SSO.",
    "err_SSO_PROOF_REQUIRED": "You have not verified with your company account in this session. Verify first so you do not lock yourself out.",
    "err_DOMAIN_NOT_VERIFIED": "The TXT record was not found yet (DNS may take a few minutes).",
    "err_DOMAIN_TAKEN": "Another organization has verified this domain. Contact support if you dispute it.",
    "err_INVALID_ARGUMENT": "Invalid value (free email domains cannot be verified).",
    "err_REAUTH_REQUIRED": "Please verify your identity again.",
    "err_BAD_POLICY": "Invalid setting.",
    "scim": "SCIM provisioning",
    "scim_hint": "Let your company directory (Entra ID, Okta) sync the roster automatically: when an employee is deactivated, their access to this organization is removed (the account itself is not affected).",
    "scim_endpoint": "Tenant URL (SCIM endpoint)",
    "scim_counts": "Roster: {{users}} ({{unmatched}} not yet matched to an account) · Groups: {{groups}}",
    "scim_last_sync": "Last sync: {{at}}",
    "scim_never": "Never synced",
    "scim_token_row": "Token created {{at}}",
    "scim_token_used": "last used {{at}}",
    "scim_new": "Generate token",
    "scim_new_shown": "This token is shown only once. Copy it into your IdP's Secret Token field now:",
    "scim_revoke": "Revoke",
    "scim_revoke_title": "Revoke this SCIM token?",
    "scim_revoke_body": "Syncs from your IdP using this token will fail. The roster and members are not changed.",
    "err_CONFLICT": "At most 2 active tokens. Revoke one first."
  },
  "ssolink": {
    "title": "Company account links",
    "hint": "These organizations verify you with your company account. After unlinking, you need to verify with the company account again to use them.",
    "unlink": "Unlink",
    "unlink_title": "Unlink your company account from {{org}}?",
    "unlink_body": "Your company verification for this organization ends too.",
    "unlink_failed": "Could not unlink. Verify your identity again and retry."
  },
  "aiByo": {
    "title": "Your own AI",
    "help": "Analyze event frames with your own OpenAI / Anthropic / Gemini account: a one-line searchable description plus person / vehicle / animal / package labels. The provider bills you directly; Kinio adds no markup and does not pay on your behalf.",
    "provider": "Service",
    "provider_openai": "OpenAI",
    "provider_anthropic": "Anthropic Claude",
    "provider_gemini": "Google Gemini",
    "api_key": "API key",
    "key_help": "After saving, only the last 4 characters are shown; nobody, including Kinio, can see the full key. The platform checks it once by listing models (no charge).",
    "consent_summary": "For cameras with your own AI turned on, each motion event sends 1 frame to {{provider}}; results appear in events and search.",
    "consent_body": "Data sent: 1 frame at the moment of the event (long side scaled to 1024 px); camera names are not sent.\nDestination: the official API of the service you chose (OpenAI / Anthropic / Google).\nRetention and training: governed by your agreement with that service; Kinio keeps only the analysis result, for as long as the event.\nCost: billed to you by the service; you can set hourly / daily limits.\nNotice: you are the data controller; please inform the people being recorded.\nWithdraw any time: sending stops within 60 seconds after you delete the key.\nNo face recognition: the analysis never identifies or guesses who anyone is.",
    "agree": "I have read and agree",
    "add": "Verify and save",
    "add_help": "You will be asked to sign in again.",
    "status_active": "Active",
    "status_invalid": "Key invalid",
    "status_disabled": "Disabled",
    "status_needs_reentry": "Re-enter the key",
    "invalid_help": "The service says this key is invalid or lacks permission, so it is no longer used. Please replace the key.",
    "last_used": "Last used {{at}}",
    "model": "Model",
    "usage": "{{calls}} calls this month",
    "cost_note": "The service bill is authoritative.",
    "max_per_hour": "Hourly limit",
    "max_per_day": "Daily limit",
    "devices_help": "Choose the cameras to analyze with your own AI (Kinio cloud AI skips them and does not count them):",
    "rekey_placeholder": "Paste a new key",
    "rekey": "Replace key",
    "delete": "Delete",
    "delete_help": "Sending stops within 60 seconds. If you are worried about a leak, also revoke the key in the service console.",
    "fail_auth": "Invalid key",
    "fail_rate": "Rate limited",
    "fail_quota": "Quota used up",
    "fail_model": "Model unavailable",
    "fail_timeout": "Timed out",
    "fail_server": "Service error",
    "fail_schema": "Bad reply format",
    "fail_bad_request": "Request rejected",
    "err_BYO_AI_KEY_INVALID": "This key is invalid or lacks permission.",
    "err_BYO_AI_MODEL_UNAVAILABLE": "This key cannot use that model.",
    "err_BYO_AI_DISABLED_BY_POLICY": "Your organization security policy does not allow your own cloud AI.",
    "err_BYO_AI_CREDENTIAL_EXISTS": "A key already exists; replace it instead.",
    "err_BYO_AI_PROVIDER_UNAVAILABLE": "The service is unreachable or rate limited. Try again later.",
    "err_ENTITLEMENT_REQUIRED": "Your plan does not include your own cloud AI.",
    "err_AI_ALREADY_ASSIGNED": "This camera is assigned to local AI. Unassign it first.",
    "err_VERSION_CONFLICT": "Someone else changed this. Please refresh.",
    "err_REAUTH_REQUIRED": "Please sign in again and retry."
  },
  "email_verify": {
    "title": "Verify your email first",
    "body": "To protect your account, verify your email before adding a sign-in method. We'll send the verification email to {{email}}.",
    "body_action": "To protect your account, verify your email before doing this. We'll send the verification email to {{email}}.",
    "send": "Send verification email",
    "later": "Not now",
    "sent": "Verification email sent. Open the link in it, then try again.",
    "err_RATE_LIMITED": "Too many requests. Try again later.",
    "err_default": "Couldn't send the verification email ({{code}}). Try again later.",
    "already": "Your email is already verified. Please try again.",
    "body_no_email": "To protect your account, verify your email before adding a sign-in method.",
    "body_action_no_email": "To protect your account, verify your email before doing this."
  }
}
